;
var __I18N__ = {
    "en": {
        "consts": {
            "minAccessTime": "10800",
            "pickupStartTime": "11"
        },
        "submitForm": {
            "ring": {
                "title": "Describe your ring",
                "setting": {
                    "label": "Setting",
                    "settings": {
                        "solitaire": "Solitaire",
                        "bridalSet": "Bridal   set",
                        "3stone": "3 stone",
                        "halo": "Halo",
                        "looseDiamond": "Loose",
                        "other": "Other"
                    }
                },
                "cut": {
                    "label": "Shape",
                    "description1": "Largest diamond only",
                    "cuts": {
                        "round": "Round",
                        "princess": "Princess",
                        "cushion": "Cushion",
                        "marquise": "Marquise",
                        "emerald": "Emerald",
                        "other": "Other"
                    }
                },
                "carat": {
                    "label": "Carat Weight",
                    "description1": "Largest diamond only",
                    "description2": "",
                    "tip": "Most common center diamond Carat size is 0.9CT",
                    "minCarat": "0.01"
                },
                "color": {
                    "label": "Color",
                    "description1": "Largest diamond only",
                    "tip": "Most common center diamond color is H",
                    "colors": {
                        "fancy": "Fancy",
                        "notSure": "Not Sure"
                    }
                },
                "clarity": {
                    "label": "Clarity",
                    "description1": "Largest diamond only",
                    "clarities": {
                        "notSure": "Not Sure"
                    },
                    "tip": "Most common center diamond clarity is SI2"
                },
                "certificate": {
                    "label": "Grading Lab Certificate",
                    "mobileLabel": "Grading Certificate"
                },
                "brand": {
                    "label": "Brand",
                    "description1": "",
                    "brands": {
                        "other": "OTHER"
                    },
                    "tip": ""
                }
            },
            "bracelet": {
                "title": "Describe your bracelet",
                "style": {
                    "label": "Style",
                    "styles": {
                        "tennis": "Tennis",
                        "charm": "Charm",
                        "slide": "Slide",
                        "bangle": "Bangle",
                        "link": "Link",
                        "other": "Other"
                    }
                },
                "metalType": {
                    "label": "Metal type",
                    "types": {
                        "minimum": "10k or less",
                        "level1": "14k",
                        "level2": "18k",
                        "level3": "24k",
                        "maximum": "Platinum",
                        "other": "Other"
                    }
                },
                "numberOfDiamonds": {
                    "label": "Number of diamonds",
                    "tip": "Number of all diamonds on your bracelet",
                    "minNumberOfDiamonds": "1"
                },
                "totalCaratWeight": {
                    "label": "Total carat weight",
                    "tip": "Combined carat weight of all diamonds",
                    "minTotalCarat": "0.01"
                },
                "shape": {
                    "label": "Shape",
                    "description1": "Largest diamond only",
                    "shapes": {
                        "round": "Round",
                        "princess": "Princess",
                        "cushion": "Cushion",
                        "marquise": "Marquise",
                        "emerald": "Emerald",
                        "other": "Other"
                    }
                },
                "color": {
                    "label": "Color",
                    "description1": "Largest diamond only",
                    "tip": "Most common center diamond color is H",
                    "colors": {
                        "fancy": "Fancy",
                        "notSure": "Not Sure"
                    }
                },
                "clarity": {
                    "label": "Clarity",
                    "description1": "Largest diamond only",
                    "clarities": {
                        "notSure": "Not Sure"
                    },
                    "tip": "Most common center diamond clarity is SI2"
                },
                "brand": {
                    "label": "Brand",
                    "description1": "",
                    "brands": {
                        "other": "OTHER"
                    },
                    "tip": ""
                }
            },
            "watch": {
                "brandOptions": {
                    "0": {
                        "name": "rolex",
                        "text": "Rolex"
                    },
                    "1": {
                        "name": "patek_philippe",
                        "text": "Patek Philippe"
                    },
                    "2": {
                        "name": "breitling",
                        "text": "Breitling"
                    },
                    "3": {
                        "name": "omega",
                        "text": "Omega"
                    },
                    "4": {
                        "name": "cartier",
                        "text": "Cartier"
                    },
                    "5": {
                        "name": "iwc",
                        "text": "IWC"
                    },
                    "6": {
                        "name": "tag_heuer",
                        "text": "Tag Heuer"
                    }
                },
                "modelsByBrand": {
                    "breitling": [
                        "NAVITIMER",
                        "CHRONOMAT",
                        "SUPEROCEAN",
                        "AVENGER",
                        "GALACTIC",
                        "MONTBRILLANT",
                        "COLT"
                    ],
                    "cartier": [
                        "BALLON BLUE",
                        "TANK",
                        "SANTOS",
                        "PANTHERE",
                        "CHRONOSCAPH",
                        "PASHA",
                        "ROADSTER"
                    ],
                    "iwc": [
                        "AQUATIMER",
                        "DA VINCI",
                        "INGENIEUR",
                        "PILOT'S WATCH",
                        "PORTOFINO",
                        "PORTUGIESER"
                    ],
                    "omega": [
                        "CONSTELLATION",
                        "SEAMASTER",
                        "SPEEDMASTER",
                        "DE VILLE"
                    ],
                    "patek_philippe": [
                        "GRAND COMPLICATIONS",
                        "COMPLICATIONS",
                        "CALATRAVA",
                        "GONDOL",
                        "NAUTILUS",
                        "AQUANAUT",
                        "POCKET WATCH"
                    ],
                    "rolex": [
                        "DAY DATE",
                        "DATEJUST",
                        "OYSTER PERPETUAL",
                        "DAYTONA",
                        "SUBMARINER",
                        "GMT MASTER",
                        "CELLINI"
                    ],
                    "tag_heuer": [
                        "CARRERA",
                        "AQUARACER",
                        "MONACO",
                        "FORMULA 1",
                        "LINK",
                        "AUTOMATIC",
                        "CHRONOGRAPH"
                    ]
                },
                "fields": {
                    "brand": {
                        "label": "Brand",
                        "hasOther": "true",
                        "placeholder": "e.g. Panerai"
                    },
                    "model": {
                        "label": "Model",
                        "hasOther": "true",
                        "noBrand": "Please enter / select 'Brand' first."
                    },
                    "condition": {
                        "label": "Condition",
                        "hasOther": "false"
                    },
                    "originalBox": {
                        "label": "In original box?"
                    },
                    "papersIncluded": {
                        "label": "Papers included?"
                    }
                },
                "conditions": {
                    "new_in_box": "New in box",
                    "excellent": "Excellent",
                    "very_good": "Very good",
                    "good": "Good",
                    "fair": "Fair",
                    "not_working": "Not Working"
                },
                "title": "Describe your watch"
            },
            "necklace": {
                "title": "Describe your necklace",
                "fields": {
                    "style": {
                        "label": "Style"
                    },
                    "metalType": {
                        "label": "Metal Type"
                    },
                    "caratWeight": {
                        "label": "Carat Weight",
                        "placeholder": "e.g. 3",
                        "note": "Carat weight of the <b>largest diamond only</b>"
                    },
                    "numberOfDiamonds": {
                        "label": "Number of Diamonds",
                        "placeholder": "e.g. 15",
                        "note": "Number of <b>all diamonds</b> on your necklace"
                    },
                    "totalCaratWeight": {
                        "label": "Total Carat Weight",
                        "placeholder": "e.g. 3",
                        "note": "Total carat weight of <b>all diamonds</b> on your necklace"
                    },
                    "shape": {
                        "label": "Shape"
                    },
                    "color": {
                        "label": "Color",
                        "note": "Tip: Most common diamond color H"
                    },
                    "clarity": {
                        "label": "Clarity",
                        "note": "Tip: Most common diamond clarity SI1"
                    },
                    "brand": {
                        "label": "Brand"
                    }
                },
                "styles": {
                    "centerStone": {
                        "drop": "Drop",
                        "pendant": "Pendant"
                    },
                    "multipleDiamonds": {
                        "link": "Link",
                        "choker": "Choker",
                        "collar": "Collar",
                        "lariat": "Lariat",
                        "riviera": "Riviera",
                        "station": "Station"
                    }
                },
                "metalTypes": {
                    "10_or_less": "10k or less",
                    "14k": "14k",
                    "18k": "18k",
                    "24k": "22k",
                    "platinum": "Platinum"
                },
                "shapes": {
                    "round": "Round",
                    "oval": "Oval",
                    "cushion": "Cushion",
                    "pear": "Pear",
                    "emerald": "Emerald"
                },
                "colors": {
                    "notSure": "Not Sure",
                    "fancy": "Fancy"
                },
                "clarityTypes": {
                    "fl": "FL",
                    "if": "IF",
                    "vvs1": "VVS1",
                    "vvs2": "VVS2",
                    "vs1": "VS1",
                    "vs2": "VS2",
                    "si1": "SI1",
                    "si2": "SI2",
                    "i1": "I1",
                    "i2": "I2",
                    "i3": "I3"
                },
                "brands": {
                    "tiffany": "Tiffany Co",
                    "cartier": "Cartier",
                    "van-cleef": "Van Cleef",
                    "harry": "Harry Winston",
                    "david-yurman": "David Yurman"
                }
            },
            "submitButton": "Continue",
            "haveAnotherItem": "I Have More Valuables",
            "addAnotherItem": "Add More Valuables",
            "errorMessage": {
                "select": "Please select '{fieldLabel}' above",
                "enter": "Please enter '{fieldLabel}' above",
                "both": "Please select / enter '{fieldLabel}' above",
                "number": "Please enter 'Carat Weight' above",
                "giaCertificteStructure": "Please enter a valid GIA certificate number above"
            },
            "needHelp": "Need help?",
            "tip": "Tip",
            "clickToHelp": "Click here",
            "otherBoxText": "Other",
            "notSureText": "Not Sure",
            "optional": "Optional",
            "mostValubleAlert": "Please describe the <b>most valuable {itemType}</b>. No need to describe them all."
        },
        "submitJBForm": {
            "submitButton": "Continue",
            "title": "WHAT ARE YOU SELLING?",
            "subtitle": "Select all valuables you want to sell.",
            "gemsOrOtherErr": "We're unable to accept a single GEM or OTHER valuable"
        },
        "howItWorks": {
            "mainPage": {
                "mainTitle": "How it Works",
                "subTitle": "Let’s get the most for your valuable. It’s as easy as 1-2-3.",
                "allSetTitle": "Ready?",
                "allSetText": "Start by describing your valuable. Our dedicated experts use this to give you the information you need to sell smart and get more.",
                "allSetBtn": "Start Selling",
                "faqTitle": "FAQs",
                "faqBtn": "See All FAQs",
                "needHelpTitle": "Need Help?",
                "needHelpBtn": "Start Selling"
            },
            "stepPreview": {
                "step1": {
                    "num": "01",
                    "desc": "Free Secure <br/> Pickup"
                },
                "step2": {
                    "num": "02",
                    "desc": "We Do All <br/> the Work"
                },
                "step3": {
                    "num": "03",
                    "desc": "You Get Paid"
                }
            },
            "sectionData": {
                "step1": {
                    "stepNum": "01",
                    "title": "Free Secure Pickup",
                    "subtitle": "To help you get the most for your valuable, it first needs to be inspected and authenticated. Shipment to us is free of charge via FedEx and is fully insured by brokers at Lloyd’s of London.",
                    "stepListItems": {
                        "stepLI1": {
                            "bullet": "1. Describe your valuable",
                            "expandText": "To help you get the most for your valuable, you will first be asked to describe it. This helps us determine the best path forward for sale."
                        },
                        "stepLI2": {
                            "bullet": "2. Schedule secure shipment",
                            "expandText": "You will be asked to send your valuable to us for authentication. You can choose to schedule a pickup, to drop it off at a nearby staffed FedEx location, or make an appointment at our New York office. Shipment to us is free of charge via FedEx and fully insured by brokers at Lloyd’s of London. <br/><br/>You'll receive an email with everything you need to know about how to pack and send us your valuable. You will need access to a printer to print the shipping label and a box to place your valuables in. <br/><br/><ul><li> Missing packing materials? We’ll happily send you a shipping kit. </li><li> Shipping multiple valuables? Send them all together. </li><li>You can always ship back your valuable, insured & free of charge.</li></ul> </br> In the email, you will also find <strong>Worthy's Certificate of Property Insurance </strong>for your reference. This document serves as proof of insurance for Worthy customers, covering valuables in transit and throughout the auction process."
                        }
                    }
                },
                "step2": {
                    "stepNum": "02",
                    "title": "We Do All the <br/> Work",
                    "subtitle": "Your jewelry will be cleaned and photographed in HD, showing off every angle. This is followed by an objective third-party grading by industry leading experts including GIA, IGI, Central Watch and more. We then create the auction listing for you and promote it though our buyer network. Just set your reserve, and watch the offers roll in.",
                    "stepListItems": {
                        "stepLI1": {
                            "bullet": "1. Screening",
                            "expandText": "When your valuable arrives at Worthy offices, it is checked into our system by our dedicated lab team. Unpacking is tracked and monitored by cameras. We are committed to keeping your valuable secure.<br/><br/><br/>Valuables with a low trending price will typically not go to auction. In that case, your valuable will be returned to you insured and free of charge."
                        },
                        "stepLI2": {
                            "bullet": "2. Cleaning",
                            "expandText": "Your valuable will remain safe and intact during cleaning. The process involves carefully removing dirt or tarnish from jewelry to improve its appearance and make it sparkle. Next stop, photoshoot!"
                        },
                        "stepLI3": {
                            "bullet": "3. Beauty shots",
                            "expandText": "Your valuable is professionally photographed in high-definition from every angle so that buyers can get a closer look and place high bids with confidence."
                        },
                        "stepLI4": {
                            "bullet": "4. Grading",
                            "expandText": "Certified gemologists and industry-leading labs such as GIA, GHI and IGI inspect every valuable we receive. <br/>The gemological grading examines key attributes beyond the basic 4 C's, using state-of-the-art equipment. <br/><br/> Watches auctioned on Worthy are inspected by Central Watch, a trusted watch lab in the heart of New York City."
                        },
                        "stepLI5": {
                            "bullet": "5. Auction listing created",
                            "expandText": "We create a dedicated listing for your valuable that includes a professional description, the beauty shots and the third party grading report. Buyers will be able to view this listing and place bids on your valuable."
                        },
                        "stepLI6": {
                            "bullet": "6. Set your reserve price",
                            "expandText": "Based on the results of the grading report, and previously sold valuables with similar characteristics, you will get an idea of how much buyers are willing to bid for valuables like yours. This information will help you set the right reserve price. <br/><br> The reserve price is set by you before the auction starts. it ensures that your valuable will not sell for less than you are willing to sell it for. You can go with our recommended price, which is based on our previous auctions and assessment of market trends, or set your own.<br/></br>When the auction ends: <br/><ul><li>The sale will be approved automatically if the highest bid at the end of the auction meets or exceeds the reserve price you set.</li><li>If the closing bid is lower than the reserve price you set, you can choose to reject the offer and have your valuable securely returned to you, fully insured and free of charge.</li></ul></li></ul>"
                        },
                        "stepLI7": {
                            "bullet": "7. Start your auction",
                            "expandText": "Once you click the button - your auction is live! You can track and view your valuable’s status during auction and afterwards."
                        }
                    }
                },
                "step3": {
                    "stepNum": "03",
                    "title": "Get Paid",
                    "subtitle": "View the trending price of your valuable and set your price. Get offers from vetted professional buyers in our marketplace, so that you can sell with trust and get more for your valuable. Shortly after the auction concludes, you will receive the final sale amount minus our commission. Our commission is always a percentage of the price your valuable was sold for. When you get more, so do we. Let the win-win begin!",
                    "stepListItems": {
                        "stepLI1": {
                            "bullet": "1. Choose payment method",
                            "expandText": "Before payment, you'll be asked to select your payment method (bank transfer, PayPal or check) and provide your information so that we can process the payment as soon as the sale is complete."
                        },
                        "stepLI2": {
                            "bullet": "2. Get paid — fast",
                            "expandText": "Once the sale is complete, your payment via your chosen payment method is processed almost immediately. Receipt of the payment varies depending on the method selected, as follows: <br/><br/><ul><li>PayPal: 1-2 business days</li><li>Bank transfer (ACH): 2-3 business days</li><li>Checks: 4-5 business days</li></ul><br/> Sold multiple valuables together? payment via your chosen payment method is processed once all sales are complete."
                        },
                        "stepLI3": {
                            "bullet": "3. It’s a win-win",
                            "expandText": "Our fees are respective to your earnings. So we share a common interest - to get you more.<br/><br/> Everything we do is designed to get you more, even the way we've structured our commission. The commission we take is subject to a successful auction and is a percentage of the final sale price. We only get paid when you do, and only benefit when you walk away with more. <br/><br><strong>Check out our fee table:</strong> <br/> {fees_table} * For jewelry Box (3 or more items), a flat fee of <span class='deleted'> 22% </span> 18% applies. <br/> * Limited time offer <br/>"
                        }
                    }
                }
            },
            "faqSection": {
                "faqLI1": {
                    "bullet": "What are Worthy's fees?",
                    "expandText": "Our fees are respective to your earnings. So we share a common interest - to get you more. Everything we do is designed to get you more, even the way we've structured our commission. The commission we take is subject to a successful auction and is a percentage of the final sale price. We only get paid when you do, and only benefit when you walk away with more. {fees_table} * For jewelry Box (3 or more items), a flat fee of <span class='deleted'> 22% </span> 18% applies. <br/> * Limited time offer."
                },
                "faqLI2": {
                    "bullet": "What is \"reserve price\"?",
                    "expandText": "The reserve price is set by you before the auction starts. it ensures that your valuable will not sell for less than you are willing to sell it for. The reserve price is binding: If the leading bid at the end of the auction meets or exceeds the reserve price you set, the sale will be approved automatically. If it is lower than the reserve price you set, you can choose to reject the offer and have your valuable securely returned to you, fully insured and free of charge."
                },
                "faqLI3": {
                    "bullet": "Why should I trust your grading partners over my local jeweler's appraisal?",
                    "expandText": "Buyers place higher bids with Worthy because we only use the very best in the industry to authenticate and grade items auctioned with us. Our grading partners include the Gemological Institute of America, Gemological Science International and the reputable professionals at CentralWatch. Gradings carried out by our partners are so thorough and trusted in the industry, that we put forth a description guarantee. Buyers that come to Worthy know that what they see is what they get, and ultimately place higher bids. <br/> <br/> It is also important to keep in mind that we are not the ultimate buyers of your valuable item, making every evaluation as objective as possible. Our goal is creating mutual trust between buyers and sellers that will result in a win-win deal."
                },
                "faqLI4": {
                    "bullet": "Why should I choose Worthy over eBay?",
                    "expandText": "At Worthy, we’re committed to offering a win-win experience for both sides. While Worthy and eBay are both marketplaces, at Worthy, our experts authenticate and professionally grade all valuables before sale, earning our buyers' trust. We sell exclusively to a network of professional buyers, who are more likely to bid more for high-quality valuables, thus earning you more. Sellers who choose Worthy enjoy higher chances of selling and a shorter time to sale than on eBay. Finally, our expert team provides professional updates and consultation every step of the way, so you know exactly what's happening with your valuable and enjoy full control."
                },
                "faqLI5": {
                    "bullet": "What if my valuables are not in perfect condition?",
                    "expandText": "You can still sell them. Jewelry and precious metals are appraised based on their weight and quality. Thus we can still sell them even if they are broken or incomplete. Watches, however, will achieve a better sale value if they are in proper working condition. It is always preferable to receive valuables in their original box and/or with the payment receipt."
                },
                "faqLI6": {
                    "bullet": "Can I back-out of the process at any time?",
                    "expandText": "Prior to auction there is no obligation of any kind. Once you agree to a reserve price, you are committed to selling your valuable for that price. If the highest bid falls below the reserve price, or you receive a Quick Sale offer, you have the option to decline and have your valuable sent back to you fully insured, free of charge."
                },
                "faqLI7": {
                    "bullet": "If I reject the offer will you send back my valuable?",
                    "expandText": "Yes. If you are not satisfied with the offer and it falls below your reserve price, simply request that the valuable to be sent back to you. We will send it back immediately in the same condition it was sent to us, no strings attached. However, once you agree to a reserve price, you are committed to selling your valuable."
                }
            },
            "needHelpData": {
                "phone": {
                    "title": "Contact Support",
                    "text": "Speak with one of our dedicated success agents: <u>1 (888) 222-0208</u>"
                },
                "chat": {
                    "title": "Chat With Us",
                    "text": "Get your questions answered right away with one click."
                },
                "envelope": {
                    "title": "Request a call",
                    "text": "Let us know how we can help and the best way to reach you."
                }
            }
        },
        "sellingWithTrust": {
            "title": "Selling Jewelry During Times of Crisis",
            "titleParagraph": "At Worthy, we have always strived to provide a safe and easy way for our clients to sell their diamond jewelry for the best price. As the rest of the world tries to find a way to function during the current global health crisis, so does Worthy while remaining committed to our values.",
            "CTAtext": "Start Selling",
            "process": {
                "title": "Our Process",
                "steps": [
                    {
                        "number": "1",
                        "title": "Describe Your Valuable",
                        "text": "Help us understand more about your item by giving us the best description. This will help us determine the sale path."
                    },
                    {
                        "number": "2",
                        "title": "Schedule an Insured Pickup",
                        "text": "We will provide a shipping label fully insured by brokers at Lloyd’s of London. You can then schedule a pickup online."
                    },
                    {
                        "number": "3",
                        "title": "Taking Care of Your Valuable",
                        "text": "Once we receive your valuable, it is screened, cleaned, photographed, and graded. All while using gloves and masks."
                    },
                    {
                        "number": "4",
                        "title": "Set Your Reserve Price",
                        "text": "You are in control in determining whether you want to receive a price guarantee or set the reserve price manually."
                    },
                    {
                        "number": "5",
                        "title": "Start Your Online Auction",
                        "text": "At the click of a button you’ll be able to sit back and watch your online auction right up until the winning bid."
                    },
                    {
                        "number": "6",
                        "title": "Get Paid",
                        "text": "Once the auction has been completed successfully, the money will be sent to you in a matter of days."
                    }
                ]
            },
            "financialHelp": {
                "title": "Can Selling my Jewelry Help me Financially?",
                "text": "In a word, yes it can. Not only is selling jewelry a fast way to make money but it is also a safe and secure way to do so. Depending on the type of item you are selling, the money you make from selling can be enough to finance an emergency fund or cover the necessary items on your budget you were concerned about paying. There are many financial benefits to selling jewelry right now that can help relieve the financial stress of the current recession."
            },
            "thingsToKnow": {
                "title": "Things to Know About Selling Jewelry During a Recession",
                "bullets": [
                    "Diamond jewelry can be a <a href='https://www.worthy.com/blog/divorce/finance/diamond-ring-value-is-more-than-you-think/' style='text-decoration: none; color: #F5A723; font-weight: 600'> forgotten financial asset</a>.",
                    "<a href='https://www.worthy.com/blog/knowledge-center/jewelry/what-your-jewelry-can-do-for-your-finances/' style='text-decoration: none; color: #F5A723; font-weight: 600'> Old, inherited jewelry </a> has the potential to do more for your bank account than for your jewelry box.",
                    "The legwork for <a href='https://www.worthy.com/blog/loss/inheritance/selling-inherited-jewelry/' style='text-decoration: none; color: #F5A723; font-weight: 600'> searching for the right buyer for your jewelry </a> can be exhausting, difficult and potentially pose a health hazard.",
                    "Other online platforms, like <a href='https://www.worthy.com/blog/knowledge-center/jewelry/ebay-vs-worthy/' style='text-decoration: none; color: #F5A723; font-weight: 600'> eBay </a>, are convenient but don’t often yield the same results as jewelry centered platforms do.",
                    "Similarly, while many states are allowing pawn shops to run as an essential business, you are <a href='https://www.worthy.com/blog/knowledge-center/jewelry/avoid-pawn-shops-when-selling-jewelry/' style='text-decoration: none; color: #F5A723; font-weight: 600'> unlikely to get a good deal on your jewelry </a> there."
                ]
            }
        },
        "experts": {
            "pageTitle": "We’re here to help you sell with confidence",
            "header": {
                "howItWorks": "How It Works",
                "explore": "Explore",
                "recentlySold": "Recently Sold",
                "reviews": "Reviews",
                "learn": "Learn",
                "blog": "Blog",
                "aboutUs": "About Us",
                "buyARing": "Buy a Ring"
            }
        },
        "liveChat": {
            "title": "We'd Love to Chat",
            "text": "Thank you for considering selling your <b>{item_name}</b> with us. An account executive is available on live chat to answer your questions and explain what's next.",
            "buttonText": "Start Live Chat",
            "version": "1.0",
            "proactiveWelcomeMessage": "Hi {name}, I’m a member of Worthy’s VIP concierge team. To get started, do you have a selling price in mind?"
        },
        "help": {
            "title": "WE'RE HERE TO HELP",
            "text1": "Request a call at your convenience and our team would be happy to help.",
            "serviceClose": "Our service center is closed at the moment. ",
            "form": {
                "name": {
                    "label": "Your name",
                    "placeholder": "Name"
                },
                "phone": {
                    "label": "Your phone number",
                    "placeholder": "Valid phone number"
                },
                "time": {
                    "label": "Preferred Time",
                    "placeholder": "Preferred contact time"
                }
            },
            "submitButton": "Request a help call",
            "orCall": "Or call us at",
            "thankYou1": "Thank you!",
            "thankYou2": "We'll be in touch soon.",
            "errors": {
                "cannotSend": "Cannot send help request. Please try again later.",
                "nameIsTooShort": "Name is too short",
                "phone": "Phone number is invalid",
                "selectTime": "Please select preferred time"
            }
        },
        "logIn": {
            "title": "SIGN IN",
            "text1": "Welcome back!",
            "text2": "To continue, please sign in to your account",
            "form": {
                "email": {
                    "label": "Your email",
                    "placeholder": "e.g. john@yourmail.com"
                },
                "password": {
                    "label": "Password | {forgot}",
                    "label_forgot": "I forgot my password",
                    "placeholder": "Enter your password"
                }
            },
            "switchToRegister": "New here? {register}",
            "switchToRegister_register": "Sign up now",
            "submitButton": "Calculate Market Value",
            "newHere": "New here?",
            "register": "Register",
            "errors": {
                "credentials": "Incorrect email or password",
                "email": "Email address is incorrect",
                "password": "Please enter a password"
            },
            "emailScreen": {
                "topText": "Enter your email and we'll send you a temporary",
                "boldText": "6 digit login code",
                "verify": "To verify your account we'll send you a temporary",
                "verifyBoldText": "6 digit login code"
            },
            "codeScreen": {
                "topText": "Enter the 6 digit code sent to:"
            },
            "assistanceText": "For assistance call us at"
        },
        "oneTimePassword": {
            "title": "One Time Password",
            "tryAgain": "Need a new code? Try again in 30 seconds.",
            "resend": "Didn't get the code?",
            "resend2": "Resend",
            "invalidNumber": "Email is connected to invalid number.",
            "6digits": "Please enter the 6-digit code sent to:",
            "enterYourEmail": "Enter your email and we'll text you a one <br> time password",
            "switchToLogin": "Log in with email & password",
            "ourPhone": "1(888) 222-0208",
            "noSuccess": "Still no success call us at"
        },
        "logInPage": {
            "title": "LOG IN",
            "form": {
                "email": {
                    "placeholder": "Email"
                },
                "password": {
                    "placeholder": "Password"
                },
                "submitButton": "Continue",
                "submitButtonPendingItem": "Continue",
                "errors": {
                    "credentials": "Incorrect email or password",
                    "email": "Email address is incorrect",
                    "password": "Please enter a password"
                }
            },
            "forgotPass": "Forgot password?",
            "switchToRegister": "New here? {registerNow}",
            "registerNow": "Sign Up",
            "textMe": "Log in with one time password"
        },
        "register": {
            "title": "CREATE TOUR ACCOUNT",
            "text1": "Fill in your information to receive your True Market Value Analysis",
            "text2": "Your information will not be shared with any third party.",
            "form": {
                "email": {
                    "label": "Email",
                    "placeholder": "e.g. john@yourmail.com"
                },
                "phone": {
                    "label": "Phone Number",
                    "placeholder": "e.g. 1 (212) 555-1234"
                }
            },
            "submitButton": "Calculate Market Value",
            "switchToLogin": "Already have an account? {login}",
            "switchToLogin_login": "Log in",
            "errors": {
                "email": "Email address is incorrect",
                "phone": "Phone number is incorrect"
            }
        },
        "registerPage": {
            "title": "SEE HOW MUCH YOU&nbsp;CAN&nbsp;GET",
            "titlePendingItem": {
                "desktop": "WHERE TO SEND THE REPORT",
                "mobile": "WHERE TO SEND THE REPORT"
            },
            "contactPreferenceText": "Learn what you can get and how it all works via:",
            "form": {
                "firstName": {
                    "placeholder": "First name"
                },
                "lastName": {
                    "placeholder": "Last name"
                },
                "fullName": {
                    "placeholder": "Full Name"
                },
                "email": {
                    "placeholder": "Email"
                },
                "phone": {
                    "placeholder": "Valid mobile number",
                    "textHelper": "We'll never share your information",
                    "label": "Optional"
                },
                "whereSendPassword": "We'll send your password to this number",
                "submitButton": "Continue",
                "submitButtonPendingItem": "Continue",
                "errors": {
                    "emptyFirstName": "Enter letters only (two or more)",
                    "emptyFullName": "Enter letters only (two or more)",
                    "emptyLastName": "Enter letters only (two or more)",
                    "emptyEmail": "Enter your email address",
                    "emptyPhone": "Enter your phone number",
                    "email": "Enter a valid email (e.g. you@domain.com)",
                    "phone": "Enter a 10-digit US phone number"
                }
            },
            "switchToSignIn": "Already signed up? {signIn}",
            "signIn": "Log In",
            "bottomText": "By signing up, you agree to the Worthy {tndText} and to receive marketing communications from Worthy in accordance with our {privacyPolicyText}.",
            "tndText": "terms & conditions",
            "privacyPolicyText": "privacy policy"
        },
        "itemPage": {
            "validationNeeded": {
                "min": "min.",
                "progressBarTitle": "Calculating..."
            },
            "estimationReady": {
                "exp": {
                    "title": "SELLING IS EASY",
                    "box": {
                        "title": "You have a wonderful {item_type}!",
                        "text": "{numPeople} people are asking for {estimationRange} for {similar_item_popup} now.",
                        "link_text": "similar pre-owned items"
                    },
                    "list": {
                        "graded": {
                            "title": "1. Grading by GIA",
                            "text": "With a pre-paid pickup, insured up to $100,000, your item will be delivered to the world's leading grading lab."
                        },
                        "advancePayment": {
                            "title": "2. Set Your Price",
                            "text": "Name the reserve price you would be willing to sell your item for."
                        },
                        "auction": {
                            "title": "3. Sell It",
                            "text": "Let buyers compete over your item (Low value items get other selling options instead)."
                        }
                    }
                },
                "similarItemsPopup": {
                    "title": "Similar items",
                    "text1": "The asking price range for items similar to yours is {price_range}",
                    "minimumPrice": "Asking price: {price}"
                },
                "title": "MARKET VALUE REPORT",
                "min": "min.",
                "properties": {
                    "largestDiamond": {
                        "title": "LARGEST DIAMOND",
                        "desc": "THE 'KELLEY BLUE BOOK' OF DIAMONDS"
                    },
                    "setting": {
                        "title": "SETTING (METAL)",
                        "desc": "BASED ON MARKET SPOT PRICE"
                    },
                    "additionalDiamonds": {
                        "title": "ADDITIONAL DIAMONDS",
                        "desc": "THE 'KELLEY BLUE BOOK' OF DIAMONDS"
                    },
                    "brandValue": {
                        "title": "BRANDED JEWELRY",
                        "desc": "BASED ON SIMILAR TRANSACTIONS"
                    }
                },
                "readyToSell": {
                    "title": "Hundreds of buyers are waiting to bid on your item!",
                    "text": ""
                },
                "whatsNext": {
                    "title": "LET'S GET YOU STARTED",
                    "titleHighValue": "LET'S BEGIN",
                    "titleJewelryBox": "LET’S GET YOU SET UP!",
                    "gradingGIA": {
                        "title": "Grading By GIA",
                        "text": "Free and fully insured VIP pickup to the Gemological Institute of America (GIA). Buyers trust GIA and it will help sell for more."
                    },
                    "getPaid": {
                        "title": "Get Paid",
                        "text": "We will approach hundreds of worldwide buyers and get you the highest paying buyer in 7 days. Guaranteed!"
                    }
                },
                "needHelp": "Need help?",
                "clickToHelp": "Click here",
                "callForHelp": "Call {phoneNumber} for help",
                "submitButton": "Continue"
            },
            "estimationFailed": {
                "title": "CONSULTING EXPERTS",
                "text1": "Looks like we need to bring in a few experts on this just to be sure. Your patience is appreciated while we attempt to get the most accurate estimate possible. We'll send an estimation update to your inbox shortly.",
                "underMinimumText": "While your {item_type_first} is beautiful, there is currently not enough demand for it in our marketplace. If you have any additional diamond jewelry items you would like to sell, we invite you submit them here.",
                "underMinimumTitle": "you deserve the best...",
                "here": "here.",
                "submitNewItem": "Submit New Item",
                "bottom": {
                    "desktop": {
                        "noThanks": "Go back to {home}"
                    },
                    "mobile": {
                        "noThanks": "No thanks, go back to {home}"
                    },
                    "noThanks_home": "home"
                },
                "needHelp": {
                    "desktop": "Need help? call us at:",
                    "mobile": "Call us for help: "
                }
            },
            "highValueEstimation": {
                "1": {
                    "version": "1.1",
                    "titleLanding": "WORTHY VIP",
                    "titleScheduler": "VIP CALL",
                    "backLink": "Back",
                    "texts": {
                        "topLanding": "Hi I’m Roy, Worthy’s Chief Gemologist. It looks like you have an especially valuable item. We’d love to hear more about it, discuss the trending price and explain our process.",
                        "topScheduler": "Please schedule your call below.",
                        "bottom": "",
                        "worthyVip": "Worthy VIP"
                    },
                    "scheduleCallForm": {
                        "callYouAt": {
                            "title": "CALL YOU AT"
                        },
                        "preferredDay": {
                            "title": "PREFERRED DAY"
                        },
                        "preferredTime": {
                            "title": "PREFERRED TIME"
                        },
                        "cta": "SCHEDULE VIP CALL",
                        "callForHelp": "CALL VIP LINE NOW",
                        "callNow": "call us now"
                    },
                    "vip": {
                        "worthyVIP": "WORTHY VIP",
                        "upperBoxBold": "Your item is especially valuable!",
                        "upperBoxRegular": "This entitels you to our VIP service.",
                        "singlePointOfContact": {
                            "title": "Single Point of Contact",
                            "text": "Your auction specialist is always with you."
                        },
                        "personalHandling": {
                            "title": "Personal Handling",
                            "text": "Items are handled by our chief gemologist."
                        },
                        "insuredNextDayPickup": {
                            "title": "Insured Next Day Pickup",
                            "text": "Only the highest standards of security."
                        },
                        "strategicConsulting": {
                            "title": "Strategic Consulting",
                            "text": "Our team will help you sell for more."
                        },
                        "mobileText": {
                            "line1": "Insured Next Day Pickup, Strategic",
                            "line2": "Consulting and more."
                        }
                    },
                    "popup": {
                        "title": "WE'D LOVE TO TALK",
                        "content": "1-833-896-7849",
                        "remarks": "A VIP representative is expecting your call."
                    },
                    "thankYou": {
                        "title": "THANK YOU",
                        "text": "Your phone appointment is scheduled for {preferred_day} at {preferred_time}. Expect a call from me at 1(888)222-0208."
                    },
                    "errors": {
                        "phone": "Enter valid phone number",
                        "preferredTime": "Select a preferred time",
                        "reportNumber": "Use 8-10 digits only",
                        "caratWeight": "Use digits and/or \".\" only"
                    },
                    "events": {
                        "keys": {
                            "timeSelected": "day_and_time_selected_from_drop_down"
                        },
                        "messages": {
                            "hvCuiPresented": "HV CUI page presented",
                            "chatBotMessage": "{actor} - HV CUI {version}: {message}",
                            "button": "'{buttonText}' button selected",
                            "timeDropDownClicked": "'When shall we call' drop down selected",
                            "phoneField": "Pre-populated phone number field {action}"
                        }
                    }
                }
            },
            "createShippingLabel": {
                "title": "SHIP TO GRADE",
                "text1": "Graded diamonds sell for more. Enter\npickup location for complimentary GIA grading in preparation for auction.",
                "poweredByFedex": "Powered by {fedex}",
                "insuredFor": "Shipping is insured for {sum}!",
                "firstName": "First Name",
                "lastName": "Last Name",
                "street": "Street & building number",
                "apartment": "P.O. box, apartment, suite, etc.",
                "city": "City",
                "state": "State",
                "selectState": "Select a state",
                "zip": "Zip Code",
                "iWouldLikeInsurance": "I would like FREE insurance for {dollars}",
                "iWouldLikeFreeShipping": "I would like FREE VIP next day shipping",
                "errorStreet": "Street is invalid",
                "errorCity": "City name is invalid",
                "errorZip": "ZIP code is invalid",
                "errorPleaseFill": "Please fill in the fields in red",
                "submitButton": "Set Pickup Location",
                "submitButton_loading": "Verifying",
                "pleaseWait": "This may take a few moments...",
                "needHelp": "Need help?",
                "clickToHelp": "Click here"
            },
            "shippingLabel": {
                "title": "CALL US TO ARRANGE PICKUP",
                "labelSent": "Your pre-paid shipping label and packing instructions have been sent to your inbox.",
                "itemNumber": "Your item number is: {itemNumber}",
                "callUs": {
                    "desktop": "Call us at: {phoneNumber}",
                    "mobile": "Call us to schedule a time for pickup."
                },
                "dropOff": {
                    "title": "OR, DROP OFF",
                    "text": "Approved FedEx locations near you"
                },
                "bottomText": {
                    "desktop": "",
                    "mobile": "You can also, {callFedex} to schedule directly.",
                    "callFedex": "Call FedEx"
                }
            },
            "shippingLabelFailed": {
                "title": "FedEx Shipping Label Error",
                "text1": "Looks like we’ve experience a little glitch! Worry not, our team has been notified and one of our account managers will be in touch to get you back on track.",
                "needHelp": "If you have preferred contact times, please enter them {here}.",
                "needHelp_here": "here"
            },
            "pendingAuction": {
                "A": {
                    "version": "1.5.1",
                    "title": "START YOUR AUCTION",
                    "sellerNotes": {
                        "title": "SELLER NOTES",
                        "placeholder": "e.g. antique, family heirloom",
                        "text": "Tell the story of your item, it might help sell for more"
                    },
                    "syaTitle": "CHOOSE YOUR PRICE",
                    "syaTitleAbovePG": "PRICING",
                    "syaSubtitle": "Go with our recommended price guarantee or set your own price.",
                    "syaSubtitleAbovePG": "Go with our recommended price or set your <br>own price.",
                    "priceGuarantee": {
                        "title": "Price Guarantee",
                        "beforePrice": "At least",
                        "tag": "Best Deal",
                        "infoTexts": {
                            "0": "{similarItemsLink} had a price guarantee of {priceRangeDollars}",
                            "1": "Once auction ends, valuable is automatically sold for {reservePriceDollars} or more",
                            "2": "If it ends over {reservePriceDollars}, you'll get the extra!",
                            "3": "We'll cover the difference if it ends below {reservePriceDollars}"
                        },
                        "cta": "START AUCTION"
                    },
                    "noGuarantee": {
                        "title": "No Guarantee",
                        "infoTexts": {
                            "0": "Sale is not guaranteed",
                            "1": "Risk of auction ending at lower price"
                        },
                        "cta": "SET MANUALLY",
                        "hidden": {
                            "title": "RESERVE PRICE",
                            "subtitle": "Select the minimum price you are willing to accept for your valuable",
                            "subtitle_second": "Once the auction meets or exceeds your reserve price, it's a deal and the sale cannot be canceled",
                            "radioOptions": {
                                "recommended": {
                                    "text1": "{price} {text}",
                                    "text2": "Based on over 50,000 previous auctions and current market trends"
                                },
                                "recommendedAdditional5": {
                                    "text1": "{priceAdditional5Pct} 5% above recommendation",
                                    "text2": "Lower probability to sell"
                                },
                                "other": {
                                    "text1": "Other reserve price",
                                    "text2": ""
                                }
                            },
                            "percentageSteps": {
                                "101": "100",
                                "110": "80",
                                "120": "50",
                                "130": "30",
                                "140": "20",
                                "max": "15"
                            }
                        }
                    },
                    "noGuaranteeNew": {
                        "title": "Recommended Price",
                        "infoTexts": {
                            "0": "Reserve price is set to {reservePriceDollars}",
                            "1": "Based on over 50,000 previous auctions on our marketplace",
                            "2": "Based on professional assessment of current diamond market trends"
                        },
                        "headsUpPopupNew": {
                            "headline": "Confirm Your Reserve",
                            "text": "Once the auction meets or exceeds your reserve price, it's a deal and the sale can’t be canceled.",
                            "declineBtn": "Cancel",
                            "approveBtn": "Confirm & Start Auction",
                            "confirm": "Confirm"
                        },
                        "manualPart": {
                            "title": "Set reserve manually",
                            "cta": "Set Reserve"
                        },
                        "cta": "Set Reserve to {reservePriceDollars}",
                        "cta_manually": "Set Reserve Manually"
                    },
                    "successFeesLink": "{link} apply",
                    "successFeesLinkText": "Worthy Success Fees",
                    "highReservePricePopup": {
                        "title": "Your Reserve Price is High",
                        "text_1": "Based on over 50,000 of previous auctions and current market trends, the price you entered is too high, reducing the likelihood of a sale.",
                        "text_2": "Once the auction meets or exceeds your reserve price, it's a deal and the sale can’t be canceled.",
                        "buttonEdit": "Edit Price",
                        "buttonContinue": "Keep Price"
                    },
                    "priceGuaranteePopup": {
                        "approveButtonText": "Agree",
                        "declineButtonText": "Cancel",
                        "text_1": "By choosing Price Guarantee, you have secured at least ",
                        "text_2": " (Worthy Success Fees apply) and commit to selling your {item_type}."
                    },
                    "errors": {
                        "noReservePrice": "Please enter a reserve price"
                    }
                },
                "B": {
                    "version": "1.6",
                    "title": "START YOUR AUCTION",
                    "sellerNotes": {
                        "title": "SELLER NOTES",
                        "placeholder": "e.g. antique, family heirloom",
                        "text": "Tell the story of your item, it might help sell for more"
                    },
                    "syaTitle": "SET RESERVE PRICE",
                    "syaTitleAbovePG": "PRICING",
                    "syaSubtitle": "Go with our recommended reserve price to get a price guarantee, or set the reserve price manually.",
                    "syaSubtitleAbovePG": "Go with our recommended price or set your <br>own price.",
                    "priceGuarantee": {
                        "title": "Price Guarantee",
                        "beforePrice": "At least",
                        "tag": "Best Deal",
                        "infoTexts": {
                            "0": "Reserve price is set to {reservePriceDollars}",
                            "1": "Auction ends for less? We’ll cover the difference",
                            "2": "Auction nets more, you get more!",
                            "3": "{similarItemsLink} had reserve of {priceRangeDollars}"
                        },
                        "cta": "START AUCTION",
                        "underCta": "By clicking above, you agree that your ring will be automatically sold for {reservePriceDollars} or more when the auction ends."
                    },
                    "noGuarantee": {
                        "title": "No Guarantee",
                        "infoTexts": {
                            "0": "Sale is not guaranteed",
                            "1": "Risk of auction ending at lower price"
                        },
                        "cta": "SET MANUALLY",
                        "hidden": {
                            "title": "RESERVE PRICE",
                            "subtitle": "Select the minimum price you are willing to accept for your valuable",
                            "subtitle_second": "Once the auction meets or exceeds your reserve price, it's a deal and the sale cannot be canceled",
                            "radioOptions": {
                                "recommended": {
                                    "text1": "{price} {text}",
                                    "text2": "Based on over 50,000 previous auctions and current market trends"
                                },
                                "recommendedAdditional5": {
                                    "text1": "{priceAdditional5Pct} 5% above recommendation",
                                    "text2": "Lower probability to sell"
                                },
                                "other": {
                                    "text1": "Other reserve price",
                                    "text2": ""
                                }
                            },
                            "percentageSteps": {
                                "101": "100",
                                "110": "80",
                                "120": "50",
                                "130": "30",
                                "140": "20",
                                "max": "15"
                            }
                        }
                    },
                    "noGuaranteeNew": {
                        "title": "Recommended Price",
                        "infoTexts": {
                            "0": "Reserve price is set to {reservePriceDollars}",
                            "1": "Based on over 50,000 previous auctions on our marketplace",
                            "2": "Based on professional assessment of current diamond market trends"
                        },
                        "headsUpPopupNew": {
                            "headline": "Confirm Your Reserve",
                            "text": "Once the auction meets or exceeds your reserve price, it's a deal and the sale can’t be canceled.",
                            "declineBtn": "Cancel",
                            "approveBtn": "Confirm & Start Auction",
                            "confirm": "Confirm"
                        },
                        "manualPart": {
                            "title": "Set reserve manually",
                            "cta": "Set Reserve"
                        },
                        "cta": "Set Reserve to {reservePriceDollars}",
                        "cta_manually": "Set Reserve Manually"
                    },
                    "successFeesLink": "{link} apply",
                    "successFeesLinkText": "Worthy Success Fees",
                    "highReservePricePopup": {
                        "title": "Your Reserve Price is High",
                        "text_1": "Based on over 50,000 of previous auctions and current market trends, the price you entered is too high, reducing the likelihood of a sale.",
                        "text_2": "Once the auction meets or exceeds your reserve price, it's a deal and the sale can’t be canceled.",
                        "buttonEdit": "Edit Price",
                        "buttonContinue": "Keep Price"
                    },
                    "priceGuaranteePopup": {
                        "approveButtonText": "Agree",
                        "declineButtonText": "Cancel",
                        "text_1": "By choosing Price Guarantee, you have secured at least ",
                        "text_2": " (Worthy Success Fees apply) and commit to selling your {item_type}."
                    },
                    "errors": {
                        "noReservePrice": "Please enter a reserve price"
                    }
                }
            },
            "pendingSale": {
                "version": "1.0",
                "title": "SELL YOUR ITEM",
                "saleFormat": {
                    "title": "SELLING FORMAT",
                    "sub1": "Please select how you would like to sell your item.",
                    "sub2": "{similarItemsLink} sold for {valueRange}.",
                    "similarItemsLink": "Similar items",
                    "successFeesLink": "Worthy success fees",
                    "boxes": {
                        "footerLink": "{successFeesLink} apply.",
                        "box1": {
                            "title": "OPTION 1",
                            "subtitle": {
                                "quickSale": "QUICK SALE",
                                "assortedAuction": "ASSORTED SALE"
                            },
                            "cta": {
                                "regular": "APPROVE PRICE",
                                "tablet": "SELL NOW"
                            }
                        },
                        "box2": {
                            "title": "OPTION 2",
                            "subtitle": "AUCTION",
                            "redBox": "Auction format is only available for items expected to sell for over $1,000.",
                            "cta": "START AUCTION"
                        }
                    },
                    "shipBackLink": "No thanks"
                },
                "popups": {
                    "shipBack": {
                        "title": "SHIP BACK?",
                        "content": "Below is a breakdown of the Quick Sale Price. If you are still interested in selling, click the link at the bottom.",
                        "CTAs": {
                            "confirm": "SHIP MY ITEM BACK",
                            "decline": "I do want to sell"
                        }
                    },
                    "info": {
                        "content": "This selling option lets you get paid for your ring immediately instead of going on auction. This is optimal, since rings like yours typically sell better in bulk."
                    },
                    "similarItems": {
                        "text1": "Items similar to yours sold for {price_range}",
                        "minimumPrice": "Sold for: {price}"
                    }
                },
                "banners": {
                    "shipBack": {
                        "text": "Your request to ship back the {type} is confirmed. A Customer Support representative will contact you soon."
                    },
                    "sold": {
                        "text": "Congratulations! Your {type} has been sold. Your payment is being processed via the payment method you selected.",
                        "priceQuickSale": "Quick Sale price",
                        "priceAuction": "Winning bid"
                    }
                }
            },
            "supportNegotiation": {
                "version": "1.7",
                "my_items": "All my items",
                "auction_ended": {
                    "title": "Your {type} drew the interest of {interested_buyers} buyers around the world. The auction has now concluded at:",
                    "bid": "Highest bid",
                    "similar": "{similarReplace} sold with high bids between {price1}-{price2}.",
                    "similar_similarReplace": "Similar Items",
                    "fee": "{successFee} apply.",
                    "fee_successFee": "Worthy success fees",
                    "cta": "Approve & Get Paid",
                    "refuse": "No thanks",
                    "tag": "ended"
                },
                "sold": {
                    "title": "Congratulations! Your ring has been sold. Your payment is being processed via the payment method you selected.",
                    "bid": "Winning bid",
                    "fee": "{successFee}",
                    "fee_successFee": "Worthy success fees",
                    "tag": "sold"
                },
                "pendingResponse": {
                    "small_banner_title": "Your new price of {type} has been set. You will be notified if a buyer accepts this price within the next business day.",
                    "bid": "Highest bid",
                    "tag": "ended"
                },
                "shipBack": {
                    "small_banner_title": "An account manager will contact you. In the meantime, we're available at {tel}",
                    "bid": "Highest bid",
                    "tag": "ended"
                },
                "lastChance": {
                    "small_banner_title": "Great news! You got a better deal in response to your adjusted price.",
                    "bid": "New bid",
                    "tag": "ended",
                    "cta": "Approve & Get Paid",
                    "refuse": "Send my item back",
                    "betterDeal": "This deal is {betterDiff} better",
                    "similar": "{similarReplace} sold with high bids between {price1}-{price2}.",
                    "similar_similarReplace": "Similar Items"
                },
                "lastChanceNewOffer": {
                    "small_banner_title": "Great news! You got a better deal in response to your adjusted price.",
                    "bid": "New bid",
                    "tag": "ended",
                    "cta": "Approve & Get Paid",
                    "refuse": "Send my item back",
                    "betterDeal": "This deal is {betterDiff} better",
                    "similar": "{similarReplace} sold with high bids between {price1}-{price2}.",
                    "similar_similarReplace": "Similar Items"
                }
            },
            "popupAnotherChance": {
                "popupError": "Price must be lower than your original minimum price of {higherPrice}.",
                "negotiationPrice": {
                    "title": "ASK FOR MORE",
                    "text": "Not happy with the highest bid of {highest}? \n You might be closer to a deal than you think. Suggest a final price that you are willing to sell for. We will ask our buyers to match it.",
                    "subtitleAfter": " YOUR NEW PRICE ",
                    "subtitle": "YOUR NEW PRICE",
                    "cta": "SEND TO BUYERS",
                    "additionalLink": "Ship my item back"
                },
                "warning": {
                    "title": "Ask Buyers for More",
                    "text": "We understand your decision, however you still have a chance to ask for a deal higher than {highestBid}. Select a suggested price below:",
                    "cta": "Challenge buyers",
                    "notInterestedBtn": "I'm Not Interested",
                    "subtitle": "Enter other price",
                    "subtitleAfter": "OTHER PRICE",
                    "firstOption": "Buyers unlikely to accept",
                    "secondOption": "Buyers likely to accept",
                    "thirdOption": "Buyers most likely to accept",
                    "selectOption": "Please select one of the options below",
                    "noPrice": "Enter new price",
                    "priceLower": "Price must be lower than",
                    "priceHigher": "Price must be higher than",
                    "recommended": "  (Recommended) ",
                    "additionalLink": "Ship my item back",
                    "higher": " higher"
                },
                "shipBack": {
                    "title": "ARE YOU SURE?",
                    "text": "Shipping your item back will end the sale. Are you sure?",
                    "cta2": "SHIP MY ITEM BACK",
                    "cta": "CLOSE"
                }
            },
            "popupSuccessFees": {
                "title": "Worthy success fees",
                "text1": "Our fees are respective to your earnings. So we share a common interest - to get you more. Everything we do is designed to get you more, even the way we've structured our commission. The commission we take is subject to a successful auction and is a percentage of the final sale price. We only get paid when you do, and only benefit when you walk away with more.",
                "th1": "Transaction",
                "th2": "Seller fees*",
                "tr1td1": "Up to $5,000",
                "tr1td2": "<span style='position:relative;color:red;text-decoration:line-through'>22%</span> 18%",
                "tr2td1": "$5,001-$15,000",
                "tr2td2": "<span style='position:relative;color:red;text-decoration:line-through'>15%</span> 14%",
                "tr3td1": "$15,001-$30,000",
                "tr3td2": "<span style='position:relative;color:red;text-decoration:line-through'>15%</span> 12%",
                "tr4td1": "$30,001 - Above",
                "tr4td2": "<span style='position:relative;color:red;text-decoration:line-through'>14%</span> 10%",
                "tr5td1": "",
                "tr5td2": ""
            },
            "popupSuccessFeesTextUnderTable": {
                "p": "For Jewelry Box (3 or more items), a flat fee of <span style='position:relative;color:red;text-decoration:line-through'>22%</span> 18%* applies. <br><br> * Limited time offer"
            },
            "popupSimilarItems": {
                "title": "SOLD ON OUR MARKETPLACE",
                "subtitle": "Valuables similar to: <br> <b>{item_desc}</b>",
                "minimumPrice": "Asking price: {price}",
                "exploreMore": "Explore More",
                "noSimilar": {
                    "explore": "EXPLORE OUR MARKETPLACE",
                    "message": "Looks like it's taking some time to<br>load similar valuables.<br/><br/>Click below to visit our marketplace and check out other valuables.",
                    "CTA": "Explore Marketplace"
                }
            },
            "popupSimilarAuctionItems": {
                "title": "Similar sold items",
                "text1": "Our recommended price is based on these similar sold items:",
                "minimumPrice": "Sold for: {price}",
                "buyItBowPrice": "Buy It Now: {price}"
            },
            "sellerNotes": {
                "title": "SELLER NOTES",
                "inputPlaceholder": "e.g. antique, family heirloom",
                "subText": "Tell the story of your item, it might help sell for more"
            },
            "scheduledAuction": {
                "titlePreScheduled": "Auction run time",
                "textPreScheduled": "Watch auctions run Monday to Thursday every week. Once you approve starting your auction, it will automatically start on <span style='white-space: nowrap;'>{date}</span>",
                "titleScheduled": "Auction scheduled",
                "textScheduled1": "You're All Set! Your auction will start on {dow} <span style='white-space: nowrap;'>({date})</span> at <span style='white-space: nowrap;'>{time}</span> EST.",
                "textScheduled2": "For any questions, contact us at <a href:'mailto:support@worthy.com' style='white-space: nowrap;>support@worthy.com</a> or call us at <a href:'tel:1-888-222-0208' style='white-space: nowrap;>1-888-222-0208</a>"
            },
            "trends": {
                "versions": {
                    "v1": "1.1",
                    "v2": "1.2"
                },
                "relevantStates": [
                    "estimation_ready",
                    "shipping"
                ],
                "title": "WORTHY TRENDS",
                "subTitle": "See how your valuable stacks up in the secondary market",
                "buttonSellNow": "CONTINUE",
                "asmDescription": "Assumptions made for {asmCount} missing parameters. Accurate values will be provided in grading lab.",
                "your": "Your",
                "subsets": {
                    "startTitle": "Estimated Price of  ",
                    "endTitle": " is a Sum of:",
                    "centerStone": "Center Stone",
                    "settings": "Setting\n(Melt Value)",
                    "smallDiamonds": "Small\nDiamonds",
                    "brand": "Brand"
                },
                "amounts": {
                    "interval": "600000",
                    "sellersDesc": "Amount of Sellers",
                    "bidsDesc": "Number of Bids",
                    "timeDesc": "Receive Payment within:",
                    "sellersDescCon": "With similar valuables",
                    "bidsDescCon": "On valuables like yours",
                    "timeDescCon": "On average, from auction end",
                    "total_time": "2 Days",
                    "onWorthy": "on Worthy"
                },
                "highestPayingBuyers": {
                    "title": "Highest Paying Buyers",
                    "searchInMonths": "12"
                },
                "gradingCertificates": {
                    "title": "Top Grading Certificates for Your Valuable",
                    "subTitle": "Which grading report can help you get the most",
                    "highCarat": {
                        "GIA": "90",
                        "IGI": "40",
                        "GSI": "35",
                        "EGL": "25",
                        "Other": "15"
                    },
                    "lowCarat": {
                        "GIA": "80",
                        "IGI": "50",
                        "GSI": "45",
                        "EGL": "35",
                        "Other": "25"
                    },
                    "most": "Most",
                    "least": "Least",
                    "trusted": "Trusted",
                    "darkColor": "#4a90e2",
                    "lightColor": "#80f3e9"
                },
                "similarValuables": {
                    "title": "How Much Are Similar Valuables Sold For",
                    "yourItem": "Your Valuable",
                    "otherSellers": "{sellerNumber} Other Sellers",
                    "colors": {
                        "darkItem": "#00aedb",
                        "lightItem": "#a7eaff",
                        "darkSimilar": "#3023ae",
                        "lightSimilar": "#c86dd7"
                    }
                },
                "priceOverTime": {
                    "title": "Your {itemTypeName}'s Value Over Time",
                    "new": "New",
                    "preOwned": "Pre-Owned",
                    "yearAgo": "1 Year Ago",
                    "today": "Today",
                    "inYear": "in 1 Year",
                    "was": "Was",
                    "now": "Now",
                    "projected": "Projected",
                    "colors": {
                        "darkCenterStone": "#05c79c",
                        "lightCenterStone": "#d2fff5",
                        "darkSettings": "#cb1cef",
                        "lightSettings": "#f9daff",
                        "darkSmallDiamonds": "#0368e0",
                        "lightSmallDiamonds": "#edf5ff",
                        "darkBrand": "#3023ae",
                        "lightBrand": "#ddd8ff",
                        "lineStyle": "#7c09e0"
                    }
                },
                "listingTrends": {
                    "mainAlert": "This summary is based on your description of your ring.",
                    "title": "Estimated Value Summary",
                    "subTitle": "See how your valuable stacks up in the secondary market",
                    "pricing": {
                        "title": "Ring pricing (estimated)",
                        "mainTitle": "Retail vs Pre-Owned",
                        "alert1": "Retail setting prices are higher due to design and manufacturing costs.",
                        "alert2": "Retail Diamond prices are higher due to manufacturing costs.",
                        "subsets": {
                            "centerDiamond": "Your diamond",
                            "setting": "Your ring setting"
                        },
                        "content": {
                            "title": "Did You Know?",
                            "subTitle": "Here are some little known facts regarding how pre-owned jewelry is priced.",
                            "partsDescription": "Pre-owned jewelry is usually priced & sold for it’s metal and diamond/s separately.",
                            "diamondDescription": "Pre-owned diamond prices are based on a diamond’s attributes and demand.",
                            "scaleDescription": "Pre-owned settings are priced by metal value alone, which decreases their value."
                        }
                    },
                    "similarItems": {
                        "description": "Similar rings sold on our marketplace"
                    }
                }
            },
            "lightTrends": {
                "version": "1.3",
                "title": "Potential Value Summary ",
                "helperText": "Calculated based on past auctions",
                "valueRange": {
                    "total": "Total range",
                    "diamond": "{caratWeight} ct. diamond",
                    "metal": "Gold (assumed)",
                    "static": "Other elements",
                    "staticValue": "TBD"
                },
                "notification": "This value range can change significantly after expert examination of your ring, which is done prior to auction.",
                "sellSection": {
                    "title": "Sell Your Ring",
                    "bullet1": "Receive constant status updates",
                    "bullet2": "Manage your auction online",
                    "bullet3": "Choose your reserve price"
                },
                "similarItemsTitle": "Similar Sold Rings",
                "recentDealSoldFor": "Sold for"
            },
            "updateReservePrice": {
                "version": "1.0",
                "backLinkText": "Back to auction",
                "similarItems": {
                    "linkText": "Similar items",
                    "fullText": "{linkText} sold for {valueRange}."
                },
                "radioOptions": {
                    "100": {
                        "guaranteed": {
                            "0": "{price} Guaranteed",
                            "1": "Even if the closing bid is lower, you'll receive {recommended_reserve_price}. If it's higher, you'll get the extra"
                        },
                        "highestChance": {
                            "0": "{price}",
                            "1": "Highest chance for a deal"
                        }
                    },
                    "105": {
                        "0": "{price}",
                        "1": "80% chance of a deal"
                    },
                    "110": {
                        "0": "{price}",
                        "1": "50% chance of a deal"
                    },
                    "other": {
                        "0": "Other price"
                    }
                },
                "successFees": {
                    "linkText": "Worthy success fees",
                    "fullText": "{linkText} apply."
                },
                "errors": {
                    "0": "Please enter a reserve price",
                    "1": "Price must be lower than {price}"
                }
            },
            "AddressWaiting": {
                "consts": {
                    "placeholder": "e.g. 30 Rockefeller New York, NY",
                    "onFocusMsg": "Enter a valid address: House no., Street, City, State",
                    "inTyppingMsg": "Keep typing, then select your address from the list above",
                    "onFocusMsgShort": "Enter a valid address",
                    "typingInMessage": "Keep typing, then select your address from the list",
                    "errorMessage": "Valid address: Street no. & name, City, State"
                }
            },
            "shipBack": {
                "title": "Jewelry Return",
                "subTitle": "In order to initiate your return, please confirm the return address below",
                "yourAddress": "Your Address",
                "yourAddressFinePrintDirect": "Changes to this address will update the specified address jewelry is shipped to.",
                "yourAddressFinePrintHAL": "Approved FedEx location pre-selected based on your address, edit to change.",
                "shipTo": "Ship to",
                "specifiedAddress": "Specified address",
                "fedExShippingCenter": "FedEx Shipping Center",
                "securityRecommendation": "Secure return shipment",
                "securityRecommendationHAL": "For a safer and more secure return, Worthy provides insured shipping to qualified FedEx-Operated retail locations.",
                "securityRecommendationHALLink": "see details",
                "securityRecommendationDirect": "For specified address returns, please refer to form for shipment coverage guidelines.",
                "insurance": "Insurance",
                "insuranceCoverage": "Full coverage ",
                "insuranceCoverageLink": "insurance certificate",
                "insuranceCoverageReleaseFormLink": "Insurance coverage ",
                "insuranceCoverageReleaseForm": "as outlined on release form",
                "shipmentDetails": "Shipment Details",
                "fedExShipment": "FedEx shipment",
                "insuranceIncluded": "Insurance included",
                "approveCTA": "Approve Shipment",
                "signCTA": "Sign Form",
                "contactSupport": "Contact Support",
                "shipmentStatus": "Shipment Status",
                "shipmentSignForm": "Sign form",
                "shipmentConfirmed": "Confirm shipment",
                "shipmentPreparingReturn": "Preparing return",
                "shipmentPackageReady": "Package ready ",
                "shipmentPackageShipped": "Package shipped",
                "shipmentPackageArrived": "Package arrived",
                "updateAddressModalHeader": "Update Address",
                "updateAddressModalSubHeader": "Update the address used to determine shipment destination",
                "updateDestinationModalHeader": "Shipment Destination",
                "updateDestinationModalSubHeader": "Select shipment destination type",
                "updateDestinationShippingAddress": "Shipping Address",
                "updateDestinationUpdateShipTo": "You will be able to update the “Ship to” address before confirming your return shipment.",
                "destinationHAL": "Send my jewelry to an approved FedEx location",
                "destinationDirect": "Send my jewelry to specified address (Signing a release form is required)",
                "save": "Save",
                "cancel": "Cancel",
                "addressNotDetermined": "Address could not be determined, please contact support",
                "shippingOptionsModal": {
                    "title": "Shipping Options",
                    "subTitle": "Additional shipping options",
                    "contentP1": "For the safety of your item and to maintain insurance coverage, as outlined in our terms and conditions, we are returning packages to a qualifying FedEx-operated location (i.e. FedEx Office Print & Ship Center or FedEx Ship Center). These locations have strict security measures in place to safeguard your shipment from potential damage or loss until released to you.",
                    "contentP2": "For remote addresses where there is no conveniently-located FedEx location, we will facilitate a direct return, however, please note an additional step is required as this is a less secure shipping method. While rare, your required signature may not be obtained before the package is marked as \"Delivered\" and left unattended. This action puts the package at risk of damage or loss that would not be covered through our complimentary insurance. Please also note, if the delivery to your residence is unsuccessful, the package is at risk of being returned to our facility. A $50 charge will apply to each subsequent reshipment. ",
                    "contentP3": "To ship your package directly to your residence, we will send an electronic form for you to sign acknowledging your understanding of the $50 reshipment fee as well as any potential damage or loss that would not be eligible through our insurance policy. ",
                    "contentP4": "To request the option to ship your jewelry to your residence, please select Contact Support.",
                    "closeBtn": "Close"
                },
                "distanceFromYourAddress": "from your address",
                "trackYourShipment": "Track Your Shipment",
                "trackYourShipmentText": "Monitor your package, once it's in transit, using FedEx tracking",
                "bannerSignForm": "Direct returns require your approval, please <a>Sign form</a>",
                "bannerNeedOTPVerification": "For verification purposes, you will be asked to <a>confirm your account</a> when you <a>Approve shipment</a>",
                "edit": "Edit"
            }
        },
        "missingDetails": {
            "title": {
                "firstLine": {
                    "0": "To complete your profile and get started",
                    "1": "Finish registration to explore selling"
                },
                "secondLine": {
                    "0": "selling, we need your phone number",
                    "1": "options for your jewelry"
                }
            },
            "underCTA": {
                "firstLine": {
                    "0": "We'll never share your phone number",
                    "1": "We’ll text you your trending price report"
                },
                "or": "Or"
            },
            "version": "1.0"
        },
        "facebookConnect": {
            "errors": {
                "missingEmail": "We couldn’t connect your Facebook account. Please sign up with Worthy below."
            }
        },
        "myAccount": {
            "title": "MY JEWELRY BOX",
            "version": "1.0",
            "successFeesLink": "{link} apply",
            "successFeesLinkText": "worthy success fees",
            "popups": {
                "successFees": {
                    "title": "WORTHY SUCCESS FEES",
                    "p1": "When you get paid after your valuables are sold you're charged a fee that is calculated based on the total amount of the sale.",
                    "p2": "Worthy success fees for multiple jewelry bundles is <span style='color:red;text-decoration:line-through'>22%</span> 18%*."
                },
                "getPaid": {
                    "title": "GETTING PAID",
                    "text": {
                        "bank_transfer": "Click below to sell your valuables for {totalValue} and transfer the proceeds (minus {feesRate} Worthy Success Fees) to the following bank account:",
                        "paypal": "Click below to sell your valuables for {totalValue} and transfer the proceeds (minus {feesRate} Worthy Success Fees) to the following PayPal account:",
                        "check2": "Click below to sell your valuables for {totalValue} and receive a check (minus {feesRate} Worthy Success Fees) in the mail."
                    },
                    "paymentDetails": {
                        "bank_transfer": "Account number: {accountNumber} {bankName}",
                        "paypal": "{paypalUser}",
                        "check": ""
                    },
                    "cta": "APPROVE",
                    "afterCta": "By clicking Approve I agree to sell all of my valuables for the price above"
                },
                "multipleItems": {
                    "title": "MULTIPLE RINGS?",
                    "subTitle": "How many rings/bridal sets are you interested in selling?",
                    "buttons": {
                        "single": "SINGLE OR BRIDAL SET",
                        "multiple": "MULTIPLE RINGS"
                    }
                },
                "typeQtySelector": {
                    "title": "MULTIPLE {items}?",
                    "subTitle": "How many {items} are you interested in selling?",
                    "submitForm": "OK"
                }
            },
            "bannerPaymentSuccessful": "Great! Your payment of {valueAfterFees} ({valueBeforeFees} minus {feesRate} Worthy success fees) for {numValuables} is being processed.",
            "bannerPaymentSuccessfulAdditional": "Great! Your payment of {valueAfterFees} for {numValuables} is being processed.",
            "bundle": {
                "scheduleCall": "Schedule a Call",
                "setUpShipping": "Set up shipping",
                "schedulePickup": "Schedule Pickup",
                "editPickup": "Edit Pickup",
                "seeOffer": "See Offer",
                "trackPackage": "Track package",
                "startAuction": "Start auction",
                "valueSummary": "Value summary",
                "seeValueSummary": "See Value Summary",
                "awaitingShipment": "Awaiting shipment",
                "pickupScheduledFor": "Pickup scheduled for",
                "pendingDropOffAtFedex": "Pending drop off at Fedex",
                "pendingOfficeDropOff": "Pending In-Person Appointment",
                "callScheduled": "Call scheduled",
                "callScheduledFor": "Call scheduled for",
                "pendingReview": "Pending review"
            }
        },
        "user": {
            "paymentDetails": {
                "version": "1.3",
                "title": "Getting paid",
                "text1": "Please fill in the information and select how you would like to receive the final sale amount.",
                "yourActionIsLive": "Your auction is live!",
                "yourActionIsLive_buyers": "{buyers} matching buyers found.",
                "idNumber": {
                    "title": "ID number",
                    "typeDriverLicense": "Driver License",
                    "typePassport": "Passport",
                    "placeholder": "e.g. 123 456 789"
                },
                "gender": {
                    "title": "Gender",
                    "f": "Female",
                    "m": "Male"
                },
                "birthday": {
                    "title": "Date of birth"
                },
                "howToPay": {
                    "title": "How to pay you",
                    "bank": "Bank Transfer",
                    "paypal": "PayPal (Applicable up to $5000)",
                    "paypalTooltip": {
                        "title": "PayPal",
                        "text": "PayPal only allows payments up to $5000. Should you select PayPal and your total deal amount exceeds $5000, we will contact you to collect your bank account information and  you will receive the funds via bank transfer."
                    },
                    "check": "Check"
                },
                "bankAccountHolderName": {
                    "title": "Account holder name",
                    "placeholder": "e.g. Samantha Jones"
                },
                "bankName": {
                    "title": "Bank name",
                    "placeholder": "e.g. Bank of Americ corp."
                },
                "bankRoutingNumber": {
                    "title": "Routing number",
                    "placeholder": "e.g. 123456789",
                    "tooltip": {
                        "title": "Routing number",
                        "text": "Your routing number is a 9 digit number that appears on the bottom left side of your check."
                    }
                },
                "bankAccountNumber": {
                    "title": "Account number",
                    "placeholder": "e.g. 18746356918",
                    "tooltip": {
                        "title": "Account number",
                        "text": "Your account number is an 11 digit number that appears at the bottom of your check."
                    }
                },
                "paypalFullName": {
                    "title": "Full name",
                    "placeholder": "e.g. Samantha Jones"
                },
                "paypalUserName": {
                    "title": "User name",
                    "placeholder": "e.g. email@example.com"
                },
                "checkPayTo": {
                    "title": "Pay to order of",
                    "placeholder": "e.g. Samantha Jones",
                    "fees": "handling fee applies"
                },
                "checkMailingAddress": {
                    "title": "Cashable check mailing address",
                    "placeholder": "e.g. 1230 Warwick, RI, United States"
                },
                "checkMailingAddress2": {
                    "title": "Apartment/suite number",
                    "placeholder": "e.g. Private residence"
                },
                "submitButton": "Save & go to auction page",
                "submitButtonNoItem": "Save payment details",
                "submitButtonGetPaidStartAuction": "Get Paid & Start Auction",
                "submitButtonGetPaidMyAccount": "Update and get paid",
                "submitButtonJB": "Save & Start Auction",
                "submitButtonScheduledAuction": "Save & Start Auction on <span style='white-space: nowrap;'>{date}</span>",
                "errors": {
                    "noIdNumber": "Fill the ID number",
                    "not18yearsOld": "You should be at least 18 years old",
                    "dateOfBirthIsInvalid": "Please select your date of birth",
                    "noBankName": "Please enter your bank name",
                    "noBankRoutingNumber": "Please enter a valid routing number",
                    "noBankAccountNumber": "Please enter a valid account number",
                    "noPaypal": "Fill a valid PayPal email",
                    "noCheckName": "Fill name to write on check",
                    "noCheckAddress": "Fill address to send the check to",
                    "noCheckPlainData": "Fill check details"
                }
            }
        },
        "common": {
            "sellItemWizard": {
                "stepDescribe": "Describe Item",
                "stepRegister": "Sign up",
                "stepSignIn": "Log In",
                "stepRegisterSignIn": "Sign Up/Sign In",
                "stepMarketValue": "Get Market Value",
                "stepShipToGrade": "Ship to Grade",
                "stepSetPrice": "Set Price & Get Paid"
            },
            "menu": {
                "entries": {
                    "home": "Home",
                    "myAccount": "My Account",
                    "logIn": "Log in",
                    "logOut": "Log out"
                },
                "logOutMessage": "Are you sure you want to log out?",
                "errorLogOut": "Error logging out"
            },
            "phoneNumberString": "1 (888) 222-0208",
            "phoneNumber": "+18882220208",
            "vipPhoneNumber": "+18338967849",
            "vipPhoneNumberString": "1-833-896-7849",
            "fedexPhoneNumber": "",
            "auction": {
                "successPercentageSteps": {
                    "101": "100",
                    "110": "80",
                    "120": "50",
                    "130": "30",
                    "140": "20",
                    "max": "15"
                }
            }
        },
        "titles": {
            "404": "Page not found | Worthy",
            "form": "Worthy - The Smart Way to Sell & Buy Diamond Jewelry and Watches",
            "itemPage": "My Auction | Worthy",
            "loginPage": "Log In | Worthy",
            "registerPage": "Sign Up | Worthy",
            "paymentDetails": "Getting paid | Worthy",
            "jewelryBoxPage": "My Jewelry Box | Worthy",
            "myAccountPage": "My Account | Worthy",
            "howItWorks": "How It Works | Worthy",
            "sellingWithTrust": "Selling With Trust | Worthy",
            "experts": "Uncover the Value of Your Jewelry | Worthy",
            "whereToSell": "Where to Sell Pre-owned Diamond Jewelry | Worthy",
            "howToPrice": "How Pre-owned Diamond Jewelry is Priced | Worth",
            "calculator": "Resale Price Range Calculator | Worthy",
            "listing": "Worthy - Listing",
            "trends": "Worthy - Trends",
            "liveChat": "We'd Love to Chat",
            "homePage": "Worthy - The Smart Way to Sell & Buy Diamond Jewelry and Watches",
            "manageCall": "Manage Call"
        },
        "metaData": {
            "experts": {
                "title": "Uncover the Value of Your Jewelry | Worthy",
                "description": "Get an expert opinion today to uncover the value of your jewelry with the help of Worthy's knowledge and expertise. Discover resources to help you learn more."
            },
            "whereToSell": {
                "title": "Where to Sell Pre-owned Diamond Jewelry | Worthy",
                "description": "Wondering where to sell pre-owned diamond jewelry? Check out our comparative analysis of all the places for selling diamonds to find the best place for you."
            },
            "howToPrice": {
                "title": "How Pre-owned Diamond Jewelry is Priced | Worthy",
                "description": "Come learn how pre-ownded diamond jewelry is priced. Our step by step process has all the answers to explain the ins and outs of pricing in the preowned market."
            },
            "calculator": {
                "title": "Resale Price Range Calculator | Worthy",
                "description": "Try out our great resale price range calculator to find out the approximate value of your diamonds. Just enter your diamond’s attributes to get started!"
            }
        },
        "errors": {
            "ERR_NETWORK": "Connection error, try again later",
            "ERR_GENERIC": "Unknown error",
            "HTTP_GENERIC": "HTTP error",
            "HTTP_100": "Continue",
            "HTTP_101": "Switching Protocol",
            "HTTP_200": "OK",
            "HTTP_201": "Created",
            "HTTP_202": "Accepted",
            "HTTP_203": "Non-Authoritative Information",
            "HTTP_204": "No Content",
            "HTTP_205": "Reset Content",
            "HTTP_206": "Partial Content",
            "HTTP_300": "Multiple Choice",
            "HTTP_301": "Moved Permanently",
            "HTTP_302": "Found",
            "HTTP_303": "See Other",
            "HTTP_304": "Not Modified",
            "HTTP_305": "Use Proxy",
            "HTTP_306": "unused",
            "HTTP_307": "Temporary Redirect",
            "HTTP_308": "Permanent Redirect",
            "HTTP_400": "Bad Request",
            "HTTP_401": "Unauthorized",
            "HTTP_402": "Payment Required",
            "HTTP_403": "Forbidden",
            "HTTP_404": "Not Found",
            "HTTP_405": "Method Not Allowed",
            "HTTP_406": "Not Acceptable",
            "HTTP_407": "Proxy Authentication Required",
            "HTTP_408": "Request Timeout",
            "HTTP_409": "Conflict",
            "HTTP_410": "Gone",
            "HTTP_411": "Length Required",
            "HTTP_412": "Precondition Failed",
            "HTTP_413": "Payload Too Large",
            "HTTP_414": "URI Too Long",
            "HTTP_415": "Unsupported Media Type",
            "HTTP_416": "Requested Range Not Satisfiable",
            "HTTP_417": "Expectation Failed",
            "HTTP_418": "I'm a teapot",
            "HTTP_421": "Misdirected Request",
            "HTTP_426": "Upgrade Required",
            "HTTP_428": "Precondition Required",
            "HTTP_429": "Too Many Requests",
            "HTTP_431": "Request Header Fields Too Large",
            "HTTP_500": "Internal Server Error",
            "HTTP_501": "Not Implemented",
            "HTTP_502": "Bad Gateway",
            "HTTP_503": "Service Unavailable",
            "HTTP_504": "Gateway Timeout",
            "HTTP_505": "HTTP Version Not Supported",
            "HTTP_506": "Variant Also Negotiates",
            "HTTP_507": "Variant Also Negotiates",
            "HTTP_511": "Network Authentication Required",
            "HTTP_4XX": "Resource not found",
            "HTTP_5XX": "Server error, try again later",
            "AUTHORIZATION": "Not Found",
            "EMAIL_TAKEN": "Email already taken. Please sign-in instead",
            "INVALID_EMAIL": "Invalid email",
            "MISSING_DETAILS": "User's name is missing",
            "ESTIMATION_FAILED": "Automatic estimation failed",
            "ESTIMATION_MINIMUM": "Bellow minimum",
            "ESTIMATION_NOT_READY": "Estimation not yet ready",
            "BUNDLE_NOT_ESTIMATED": "Bundle not yet estimated",
            "WRONG_STATE": "Wrong item state",
            "WRONG_ADDRESS": "Wrong address"
        },
        "conversationFlow": {
            "back_to_cui": {
                "key": "message_welcome_back",
                "direction": "1",
                "type": "message",
                "text": "Hi #{user_first_name}, Welcome back! Let's pick up where we left off.",
                "time_to_show": "3000",
                "states": {
                    "pickup_waiting": {
                        "key": "back_to_pickup_waiting",
                        "type": "method",
                        "method": "back_to_pickup_waiting",
                        "direction": "1",
                        "jump_to_key": "has_available_pickup_slots",
                        "time_to_show": "1500",
                        "hide_waves_timeout": "1500",
                        "message": {
                            "key": "back_to_pickup_waiting_message",
                            "direction": "1",
                            "type": "message",
                            "text": "I'd like to schedule your complimentary Fedex pickup, insured up to $100,000, from <b>#{user_address}</b>",
                            "time_to_show": "1500"
                        }
                    }
                }
            },
            "standard": {
                "0": {
                    "version": "3.3.2",
                    "showAvatar": "true",
                    "const_messages": {
                        "message_address_change": {
                            "key": "message_address_change",
                            "direction": "2",
                            "type": "message",
                            "text": "Oops, I'd like to change the address.",
                            "response": {
                                "key": "message_enter_address_again",
                                "direction": "1",
                                "type": "message",
                                "text": "Sure, no problem. Please enter your address again.",
                                "time_to_show": "2000"
                            }
                        },
                        "welcomeBackSubmissionPhoto": {
                            "key": "message_welcome_back_submission_photo",
                            "direction": "1",
                            "type": "message",
                            "text": "Welcome back #{user_first_name}.",
                            "jump_to_key": "message_welcome_similar_items_proceed",
                            "time_to_show": "4000"
                        }
                    },
                    "flow": {
                        "0": {
                            "key": "message_welcome",
                            "direction": "1",
                            "type": "message",
                            "text": "Hi #{user_first_name}.<br><br>Thank you for considering us for the sale of your: <br><b>#{item_desc}</b>.",
                            "time_to_show": "1000"
                        },
                        "1": {
                            "key": "message_welcome_similar_items_proceed",
                            "direction": "1",
                            "type": "message",
                            "text": "How would you like to proceed?",
                            "time_to_show": "1000"
                        },
                        "2": {
                            "key": "two_buttons",
                            "direction": "0",
                            "type": "two_buttons",
                            "button1": {
                                "key": "schedule_pickup_button_with_log",
                                "text": "Set Pickup",
                                "response": {
                                    "0": {
                                        "key": "message_schedule_pickup",
                                        "direction": "2",
                                        "type": "message",
                                        "text": "I’m ready to schedule a pickup."
                                    }
                                }
                            },
                            "button2": {
                                "key": "learn_more_button_with_log",
                                "text": "Learn More",
                                "clarityComponent": "primary",
                                "action": "open_listing_page"
                            }
                        },
                        "3": {
                            "key": "accept_sell_estimation_method",
                            "direction": "0",
                            "type": "method",
                            "method": "accept_sell_estimation",
                            "time_to_show": "2000"
                        },
                        "4": {
                            "key": "message_gia",
                            "direction": "1",
                            "type": "message",
                            "text": "Our sellers get the most competitive offers because our buyers trust us. To maintain that trust we inspect and authenticate each valuable.</br></br>FedEx shipping, which is required for authentication before auction, is fully insured (up to $100,000) and is covered by Worthy.",
                            "time_to_show": "2000"
                        },
                        "5": {
                            "key": "message_fedex_explain",
                            "direction": "1",
                            "type": "message",
                            "text": "To create your free Fedex label, would you please enter your address?",
                            "ignore_time_to_show_other_state": "true",
                            "time_to_show": "2500"
                        },
                        "6": {
                            "key": "input_google_maps",
                            "direction": "0",
                            "type": "google_mui_auto_complete",
                            "text": "Enter your address",
                            "map_name": "seller_location"
                        },
                        "7": {
                            "key": "message_got_address",
                            "direction": "1",
                            "type": "message",
                            "text": "I got it, thanks!<br>Is this an apartment or a suite?",
                            "time_to_show": "2500"
                        },
                        "8": {
                            "key": "two_buttons_address_2",
                            "direction": "0",
                            "type": "two_buttons",
                            "text": "1: Apartment/Suite, 2: Neither",
                            "button1": {
                                "text": "APARTMENT / SUITE",
                                "response": {
                                    "0": {
                                        "key": "message_apartment_suite_selected",
                                        "direction": "2",
                                        "type": "message",
                                        "text": "The address is an apartment / suite."
                                    },
                                    "1": {
                                        "key": "message_apartment_suite_request",
                                        "direction": "1",
                                        "type": "message",
                                        "text": "Great!<br>What's your apartment / suite number?",
                                        "time_to_show": "1800"
                                    },
                                    "2": {
                                        "key": "input_address_2",
                                        "key_response": "message_address_2_provided",
                                        "direction": "0",
                                        "type": "free_text",
                                        "text": "Enter apartment/suite number",
                                        "nothing": "It’s not an apartment / suite.",
                                        "update_state": "address2"
                                    }
                                }
                            },
                            "button2": {
                                "text": "NEITHER",
                                "response": {
                                    "0": {
                                        "key": "message_address_2_not_provided",
                                        "direction": "2",
                                        "type": "message",
                                        "text": "It’s not an apartment / suite.",
                                        "time_to_show": "1800"
                                    }
                                }
                            }
                        },
                        "9": {
                            "key": "generate_shipping_label_method",
                            "direction": "0",
                            "type": "method",
                            "method": "generate_shipping_label",
                            "time_to_show": "0"
                        },
                        "10": {
                            "key": "message_fedex_arrange_pickup",
                            "direction": "1",
                            "type": "message",
                            "text": "Ok, we partnered with Fedex to make shipping as easy as possible.",
                            "time_to_show": "2500"
                        },
                        "11": {
                            "key": "shipping_label_ready_method",
                            "direction": "0",
                            "type": "method",
                            "method": "shipping_label_ready",
                            "time_to_show": "0"
                        },
                        "12": {
                            "key": "has_available_pickup_slots",
                            "direction": "0",
                            "type": "method",
                            "method": "check_available_pickup_slots",
                            "time_to_show": "0",
                            "hide_waves_timeout": "0",
                            "has_slots": {
                                "0": {
                                    "key": "message_pick_up_time_works",
                                    "direction": "1",
                                    "type": "message",
                                    "text": "What pickup time slot works best for you?",
                                    "time_to_show": "0",
                                    "hide_waves_timeout": "0"
                                },
                                "1": {
                                    "key": "multiple_buttons_schedule_pickup",
                                    "direction": "0",
                                    "type": "schedule_pickup_time",
                                    "placeholder": "Select pickup time...",
                                    "later": {
                                        "text": "Later"
                                    },
                                    "other": {
                                        "text": "<div class=\"day\">OTHER</div> <div class=\"day\">PICKUP TIME</div>",
                                        "update_state": {
                                            "shipmentPreferences": {
                                                "type": "pickup",
                                                "text": "Seller asked for a different pick time options. please contact ASAP and set up a pickup time"
                                            }
                                        }
                                    },
                                    "stickyButtons": {
                                        "text": "<div class=\"day\">DROP IT OFF</div> <div class=\"day\">MYSELF</div>"
                                    },
                                    "fedex_arrange_response": {
                                        "0": {
                                            "key": "message_i_will_arrange_pickup",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "No problem, I’ll check with FedEx for you. It may take a few moments, please don’t close this window.",
                                            "time_to_show": "2000"
                                        },
                                        "1": {
                                            "key": "schedule_fedex_pickup_method",
                                            "direction": "0",
                                            "type": "method",
                                            "method": "schedule_fedex_pickup",
                                            "time_to_show": "0",
                                            "success": {
                                                "0": {
                                                    "key": "message_success_schedule_pickup",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "All done, please see the important packing instructions and pre paid shipping label that I've just emailed to you.<br><br> We also attached <b>Worthy’s Certificate of Property Insurance</b> for your reference. Call us anytime at <a href='tel: 18882220208'>1 (888) 222-0208 </a>"
                                                },
                                                "1": {
                                                    "key": "message_shipping_label_details",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "<b>Your pickup is confirmed for #{schedule_time_text} at #{schedule_pickup_address}</b><br><br>Phone: #{user_phone}<br>Email: #{user_email}<br>Insurance: up to $100,000",
                                                    "time_to_show": "3000"
                                                },
                                                "2": {
                                                    "key": "multiple_buttons_details_correction",
                                                    "direction": "0",
                                                    "type": "update_pickup_details",
                                                    "placeholder": "Need anything else?",
                                                    "buttons": {
                                                        "0": {
                                                            "label": "Done",
                                                            "action": "done",
                                                            "responseText": "Done.",
                                                            "followUpMessage": "update_details_done"
                                                        },
                                                        "1": {
                                                            "label": "Change time",
                                                            "action": "update_pickup_details_time",
                                                            "responseText": "I would like to change my pickup time.",
                                                            "followUpMessage": "update_details_change_time"
                                                        },
                                                        "2": {
                                                            "label": "Change address",
                                                            "action": "update_pickup_details_address",
                                                            "responseText": "I would like to change my pickup address.",
                                                            "followUpMessage": "update_details_action_required"
                                                        },
                                                        "3": {
                                                            "label": "Change email",
                                                            "action": "update_pickup_details_email",
                                                            "responseText": "I would like to change my email.",
                                                            "followUpMessage": "update_details_action_required"
                                                        },
                                                        "4": {
                                                            "label": "Change phone",
                                                            "action": "update_pickup_details_phone",
                                                            "responseText": "I would like to change my phone.",
                                                            "followUpMessage": "update_details_action_required"
                                                        },
                                                        "5": {
                                                            "label": "I have some questions, can we talk?",
                                                            "action": "update_pickup_details_learn_more",
                                                            "responseText": "I have some questions, can we talk?",
                                                            "followUpMessage": "update_details_action_required"
                                                        },
                                                        "6": {
                                                            "label": "Sell another jewelry piece",
                                                            "action": "update_pickup_details_sell_another",
                                                            "responseText": "I would like to sell another jewelry piece",
                                                            "followUpMessage": "update_details_sell_another_jewelry"
                                                        }
                                                    },
                                                    "update_pickup_details_response": {
                                                        "0": {
                                                            "key": "create_update_pickup_details_task",
                                                            "direction": "0",
                                                            "type": "method",
                                                            "method": "update_pickup_details",
                                                            "update_details_done": {
                                                                "0": {
                                                                    "key": "message_update_pickup_details_all_good",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "Great! While you’re getting ready to ship, check out<br><a href='https://www.worthy.com/about/reviews' class='our-reviews' target='_blank'>Our reviews</a>",
                                                                    "time_to_show": "0"
                                                                }
                                                            },
                                                            "update_details_all_good": {
                                                                "0": {
                                                                    "key": "message_update_pickup_details_all_good",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "Great, feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                                                    "time_to_show": "0"
                                                                }
                                                            },
                                                            "update_details_change_time": {
                                                                "0": {
                                                                    "key": "update_details_change_time",
                                                                    "direction": "0",
                                                                    "type": "method",
                                                                    "method": "update_details_change_time",
                                                                    "jump_to_key": "multiple_buttons_schedule_pickup",
                                                                    "message": {
                                                                        "key": "update_details_change_time_message",
                                                                        "direction": "1",
                                                                        "type": "message",
                                                                        "text": "Sure, no problem. I canceled your scheduled pickup.<br><br>Please select a new pickup time below.",
                                                                        "time_to_show": "0"
                                                                    }
                                                                }
                                                            },
                                                            "update_details_action_required": {
                                                                "0": {
                                                                    "key": "message_update_pickup_details_action_required",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "OK, we will contact you shortly.",
                                                                    "time_to_show": "0"
                                                                }
                                                            },
                                                            "update_details_sell_another_jewelry": {
                                                                "0": {
                                                                    "key": "message_update_pickup_details_sell_another_jewelry",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "That's great! Just add it (and any others) to the box with your other valuable and send it in. We'll take care of it.",
                                                                    "time_to_show": "0"
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            "fail": {
                                                "0": {
                                                    "key": "message_fail_schedule_pickup",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "It looks like FedEx is unavailable right now.<br><br>I’ll try again later and contact you once I have your pickup confirmation."
                                                }
                                            }
                                        }
                                    },
                                    "fedex_more_slots": {
                                        "0": {
                                            "key": "message_schedule_pickup_other",
                                            "direction": "2",
                                            "type": "message",
                                            "text": "None of the time slots work for me. Could you show me more options?",
                                            "hide_waves_timeout": "1800"
                                        },
                                        "1": {
                                            "key": "message_i_will_back_to_you",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "No problem. I will get back to you to schedule a pickup time. Expect a call from <a href='tel: 18882220208'>1 (888) 222-0208</a>.",
                                            "time_to_show": "2000"
                                        },
                                        "2": {
                                            "key": "message_if_any_questions",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "Feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                            "time_to_show": "3000"
                                        },
                                        "3": {
                                            "key": "update_shipment_preferences_method",
                                            "direction": "0",
                                            "type": "method",
                                            "method": "update_shipment_preferences",
                                            "time_to_show": "0"
                                        }
                                    },
                                    "fedex_drop_off_locations": {
                                        "0": {
                                            "key": "message_schedule_pickup_drop_off",
                                            "direction": "2",
                                            "type": "message",
                                            "text": "I prefer to drop it off by myself",
                                            "hide_waves_timeout": "1800"
                                        },
                                        "1": {
                                            "key": "message_drop_off_locations",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "No problem, here are a few FedEx drop off locations next to your address.",
                                            "time_to_show": "2000"
                                        },
                                        "2": {
                                            "key": "update_drop_off_locations",
                                            "direction": "0",
                                            "type": "method",
                                            "method": "update_drop_off",
                                            "time_to_show": "0",
                                            "success": {
                                                "0": {
                                                    "key": "message_shipping_label_details",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "Please follow the important packing instructions I just emailed you at:<br><br><b>#{user_email}</b><br><br>The pre-paid shipping label is also enclosed in this email.",
                                                    "time_to_show": "0",
                                                    "hide_waves_timeout": "1800"
                                                }
                                            }
                                        },
                                        "3": {
                                            "key": "message_if_any_questions",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "Feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                            "time_to_show": "3000"
                                        },
                                        "4": {
                                            "key": "multiple_buttons_details_correction",
                                            "direction": "0",
                                            "type": "update_drop_off_details",
                                            "placeholder": "Need anything else?",
                                            "buttons": {
                                                "0": {
                                                    "label": "Done",
                                                    "action": "done",
                                                    "responseText": "Done.",
                                                    "followUpMessage": "update_details_done"
                                                },
                                                "1": {
                                                    "label": "Change email",
                                                    "action": "update_drop_off_details_email",
                                                    "responseText": "I would like to change my email.",
                                                    "followUpMessage": "update_details_action_required"
                                                },
                                                "2": {
                                                    "label": "Change phone",
                                                    "action": "update_drop_off_details_phone",
                                                    "responseText": "I would like to change my phone.",
                                                    "followUpMessage": "update_details_action_required"
                                                },
                                                "3": {
                                                    "label": "I have some questions, can we talk?",
                                                    "action": "update_drop_off_details_learn_more",
                                                    "responseText": "I have some questions, can we talk?",
                                                    "followUpMessage": "update_details_action_required"
                                                },
                                                "4": {
                                                    "label": "Sell another jewelry piece",
                                                    "action": "update_drop_off_details_sell_another",
                                                    "responseText": "I would like to sell another jewelry piece",
                                                    "followUpMessage": "update_details_sell_another_jewelry"
                                                }
                                            },
                                            "update_drop_off_details_response": {
                                                "0": {
                                                    "key": "create_update_pickup_details_task",
                                                    "direction": "0",
                                                    "type": "method",
                                                    "method": "update_drop_off_details",
                                                    "update_details_done": {
                                                        "0": {
                                                            "key": "message_update_drop_off_details_all_good",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "Great! While you’re getting ready to ship, check out<br><a href='https://www.worthy.com/about/reviews' class='our-reviews' target='_blank'>Our reviews</a>",
                                                            "time_to_show": "0"
                                                        }
                                                    },
                                                    "update_details_action_required": {
                                                        "0": {
                                                            "key": "message_update_drop_off_details_action_required",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "OK, we will contact you shortly.",
                                                            "time_to_show": "0"
                                                        }
                                                    },
                                                    "update_details_sell_another_jewelry": {
                                                        "0": {
                                                            "key": "message_update_drop_off_details_sell_another_jewelry",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "That's great! Just add it (and any others) to the box with your other valuable and send it in. We'll take care of it.",
                                                            "time_to_show": "0"
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "time_to_show": "0"
                                }
                            },
                            "has_no_slots": {
                                "0": {
                                    "key": "message_pick_up_time_no_slots",
                                    "direction": "1",
                                    "type": "message",
                                    "text": "Unfortunately it seems like there are currently no available pickup time slots for your address.</br> You can still drop it off yourself or contact an Account Executive for assistance.",
                                    "time_to_show": "0",
                                    "hide_waves_timeout": "0"
                                },
                                "1": {
                                    "key": "two_buttons_no_slots_response",
                                    "direction": "0",
                                    "type": "two_buttons",
                                    "button1": {
                                        "text": "Drop it off Myself",
                                        "response": {
                                            "0": {
                                                "key": "message_schedule_pickup_drop_off",
                                                "direction": "2",
                                                "type": "message",
                                                "text": "I prefer to drop it off by myself",
                                                "hide_waves_timeout": "1800"
                                            },
                                            "1": {
                                                "key": "message_drop_off_locations",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "No problem, here are a few FedEx drop off locations next to your address.",
                                                "time_to_show": "2000"
                                            },
                                            "2": {
                                                "key": "update_drop_off_locations",
                                                "direction": "0",
                                                "type": "method",
                                                "method": "update_drop_off",
                                                "time_to_show": "0",
                                                "success": {
                                                    "0": {
                                                        "key": "message_shipping_label_details",
                                                        "direction": "1",
                                                        "type": "message",
                                                        "text": "Please follow the important packing instructions I just emailed you at:<br><br><b>#{user_email}</b><br><br>The pre-paid shipping label is also enclosed in this email.",
                                                        "time_to_show": "0",
                                                        "hide_waves_timeout": "1800"
                                                    }
                                                }
                                            },
                                            "3": {
                                                "key": "message_if_any_questions",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "Feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                                "time_to_show": "3000"
                                            },
                                            "4": {
                                                "key": "multiple_buttons_details_correction",
                                                "direction": "0",
                                                "type": "update_drop_off_details",
                                                "placeholder": "Need anything else?",
                                                "buttons": {
                                                    "0": {
                                                        "label": "Done",
                                                        "action": "done",
                                                        "responseText": "Done.",
                                                        "followUpMessage": "update_details_done"
                                                    },
                                                    "1": {
                                                        "label": "Change email",
                                                        "action": "update_drop_off_details_email",
                                                        "responseText": "I would like to change my email.",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "2": {
                                                        "label": "Change phone",
                                                        "action": "update_drop_off_details_phone",
                                                        "responseText": "I would like to change my phone.",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "3": {
                                                        "label": "I have some questions, can we talk?",
                                                        "action": "update_drop_off_details_learn_more",
                                                        "responseText": "I have some questions, can we talk?",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "4": {
                                                        "label": "Sell another jewelry piece",
                                                        "action": "update_drop_off_details_sell_another",
                                                        "responseText": "I would like to sell another jewelry piece",
                                                        "followUpMessage": "update_details_sell_another_jewelry"
                                                    }
                                                },
                                                "update_drop_off_details_response": {
                                                    "0": {
                                                        "key": "create_update_pickup_details_task",
                                                        "direction": "0",
                                                        "type": "method",
                                                        "method": "update_drop_off_details",
                                                        "update_details_done": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_all_good",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "Great! While you’re getting ready to ship, check out<br><a href='https://www.worthy.com/about/reviews' class='our-reviews' target='_blank'>Our reviews</a>",
                                                                "time_to_show": "0"
                                                            }
                                                        },
                                                        "update_details_action_required": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_action_required",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "OK, we will contact you shortly.",
                                                                "time_to_show": "0"
                                                            }
                                                        },
                                                        "update_details_sell_another_jewelry": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_sell_another_jewelry",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "That's great! Just add it (and any others) to the box with your other valuable and send it in. We'll take care of it.",
                                                                "time_to_show": "0"
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "time_to_show": "0"
                                    },
                                    "button2": {
                                        "text": "Talk to Account Executive",
                                        "response": {
                                            "0": {
                                                "key": "message_contact_ae",
                                                "direction": "2",
                                                "type": "message",
                                                "text": "I’d like to talk to an Account Executive."
                                            },
                                            "1": {
                                                "key": "contact_ae_method",
                                                "direction": "0",
                                                "type": "method",
                                                "method": "contact_ae",
                                                "time_to_show": "0"
                                            },
                                            "2": {
                                                "key": "message_we_can_do_that",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "We can do that!<br>An account executive will call you at #{user_phone}.<br><br>Expect a call from <b>1 (888) 222-0208</b>.",
                                                "time_to_show": "1800"
                                            }
                                        }
                                    }
                                }
                            },
                            "fedex_error": {
                                "0": {
                                    "key": "message_no_pickup_availability",
                                    "direction": "1",
                                    "type": "message",
                                    "text": "Looks like FedEx is unavailable right now.</br> You can still drop it off yourself or contact an Account Executive for assistance.",
                                    "time_to_show": "0",
                                    "hide_waves_timeout": "0"
                                },
                                "1": {
                                    "key": "two_buttons_no_slots_response",
                                    "direction": "0",
                                    "type": "two_buttons",
                                    "button1": {
                                        "text": "Drop it off Myself",
                                        "response": {
                                            "0": {
                                                "key": "message_schedule_pickup_drop_off",
                                                "direction": "2",
                                                "type": "message",
                                                "text": "I prefer to drop it off by myself",
                                                "hide_waves_timeout": "1800"
                                            },
                                            "1": {
                                                "key": "message_drop_off_locations",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "No problem, here are a few FedEx drop off locations next to your address.",
                                                "time_to_show": "2000"
                                            },
                                            "2": {
                                                "key": "update_drop_off_locations",
                                                "direction": "0",
                                                "type": "method",
                                                "method": "update_drop_off",
                                                "time_to_show": "0",
                                                "success": {
                                                    "0": {
                                                        "key": "message_shipping_label_details",
                                                        "direction": "1",
                                                        "type": "message",
                                                        "text": "Please follow the important packing instructions I just emailed you at:<br><br><b>#{user_email}</b><br><br>The pre-paid shipping label is also enclosed in this email.",
                                                        "time_to_show": "0",
                                                        "hide_waves_timeout": "1800"
                                                    }
                                                }
                                            },
                                            "3": {
                                                "key": "message_if_any_questions",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "Feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                                "time_to_show": "3000"
                                            },
                                            "4": {
                                                "key": "multiple_buttons_details_correction",
                                                "direction": "0",
                                                "type": "update_drop_off_details",
                                                "placeholder": "Need anything else?",
                                                "buttons": {
                                                    "0": {
                                                        "label": "Done",
                                                        "action": "done",
                                                        "responseText": "Done.",
                                                        "followUpMessage": "update_details_done"
                                                    },
                                                    "1": {
                                                        "label": "Change email",
                                                        "action": "update_drop_off_details_email",
                                                        "responseText": "I would like to change my email.",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "2": {
                                                        "label": "Change phone",
                                                        "action": "update_drop_off_details_phone",
                                                        "responseText": "I would like to change my phone.",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "3": {
                                                        "label": "I have some questions, can we talk?",
                                                        "action": "update_drop_off_details_learn_more",
                                                        "responseText": "I have some questions, can we talk?",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "4": {
                                                        "label": "Sell another jewelry piece",
                                                        "action": "update_drop_off_details_sell_another",
                                                        "responseText": "I would like to sell another jewelry piece",
                                                        "followUpMessage": "update_details_sell_another_jewelry"
                                                    }
                                                },
                                                "update_drop_off_details_response": {
                                                    "0": {
                                                        "key": "create_update_pickup_details_task",
                                                        "direction": "0",
                                                        "type": "method",
                                                        "method": "update_drop_off_details",
                                                        "update_details_done": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_all_good",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "Great! While you’re getting ready to ship, check out<br><a href='https://www.worthy.com/about/reviews' class='our-reviews' target='_blank'>Our reviews</a>",
                                                                "time_to_show": "0"
                                                            }
                                                        },
                                                        "update_details_action_required": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_action_required",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "OK, we will contact you shortly.",
                                                                "time_to_show": "0"
                                                            }
                                                        },
                                                        "update_details_sell_another_jewelry": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_sell_another_jewelry",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "That's great! Just add it (and any others) to the box with your other valuable and send it in. We'll take care of it.",
                                                                "time_to_show": "0"
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "time_to_show": "0"
                                    },
                                    "button2": {
                                        "text": "Talk to Account Executive",
                                        "response": {
                                            "0": {
                                                "key": "message_contact_ae",
                                                "direction": "2",
                                                "type": "message",
                                                "text": "I’d like to talk to an Account Executive."
                                            },
                                            "1": {
                                                "key": "contact_ae_method",
                                                "direction": "0",
                                                "type": "method",
                                                "method": "contact_ae",
                                                "time_to_show": "0"
                                            },
                                            "2": {
                                                "key": "message_we_can_do_that",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "We can do that!<br>An account executive will call you at #{user_phone}.<br><br>Expect a call from <b>1 (888) 222-0208</b>.",
                                                "time_to_show": "1800"
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        "13": {
                            "key": "button_phone",
                            "direction": "0",
                            "type": "one_button_phone",
                            "text": "Call 1 (888) 222-0208",
                            "time_to_show": "3000",
                            "phone": "18882220208"
                        }
                    }
                },
                "1": {
                    "version": "3.3.1",
                    "showAvatar": "true",
                    "const_messages": {
                        "message_address_change": {
                            "key": "message_address_change",
                            "direction": "2",
                            "type": "message",
                            "text": "Oops, I'd like to change the address.",
                            "response": {
                                "key": "message_enter_address_again",
                                "direction": "1",
                                "type": "message",
                                "text": "Sure, no problem. Please enter your address again.",
                                "time_to_show": "2000"
                            }
                        },
                        "welcomeBackSubmissionPhoto": {
                            "key": "message_welcome_back_submission_photo",
                            "direction": "1",
                            "type": "message",
                            "text": "Welcome back #{user_first_name}.",
                            "jump_to_key": "message_welcome_similar_items_proceed",
                            "time_to_show": "4000"
                        }
                    },
                    "flow": {
                        "0": {
                            "key": "message_welcome",
                            "direction": "1",
                            "type": "message",
                            "text": "Hi #{user_first_name}.<br><br>Thank you for considering us for the sale of your: <br><b>#{item_desc}</b>.",
                            "time_to_show": "1000"
                        },
                        "1": {
                            "key": "message_welcome_similar_items_proceed",
                            "direction": "1",
                            "type": "message",
                            "text": "How would you like to proceed?",
                            "time_to_show": "1000"
                        },
                        "2": {
                            "key": "two_buttons",
                            "direction": "0",
                            "type": "two_buttons",
                            "button1": {
                                "key": "schedule_pickup_button_with_log",
                                "text": "Set Pickup",
                                "response": {
                                    "0": {
                                        "key": "message_schedule_pickup",
                                        "direction": "2",
                                        "type": "message",
                                        "text": "I’m ready to schedule a pickup."
                                    }
                                }
                            },
                            "button2": {
                                "key": "learn_more_button_with_log",
                                "text": "Learn More",
                                "clarityComponent": "primary",
                                "action": "open_listing_page"
                            }
                        },
                        "3": {
                            "key": "accept_sell_estimation_method",
                            "direction": "0",
                            "type": "method",
                            "method": "accept_sell_estimation",
                            "time_to_show": "2000"
                        },
                        "4": {
                            "key": "message_gia",
                            "direction": "1",
                            "type": "message",
                            "text": "Our sellers get the most competitive offers because our buyers trust us. To maintain that trust we inspect and authenticate each valuable.</br></br>FedEx shipping, which is required for authentication before auction, is fully insured (up to $100,000) and is covered by Worthy.",
                            "time_to_show": "2000"
                        },
                        "5": {
                            "key": "message_insurance",
                            "direction": "1",
                            "type": "message",
                            "text": "To create your free Fedex label, would you please enter your mobile number below?",
                            "ignore_time_to_show_other_state": "true",
                            "time_to_show": "2000"
                        },
                        "6": {
                            "key": "phone_input",
                            "direction": "0",
                            "type": "phone_input",
                            "text": "To create your free Fedex lable, would you please enter you mobile number below?",
                            "time_to_show": "0",
                            "method": "phone_input",
                            "hide_waves_timeout": "0",
                            "response": {
                                "key": "message_lets_continue",
                                "direction": "2",
                                "type": "message",
                                "text": "My phone number is {user_phone}"
                            }
                        },
                        "7": {
                            "key": "message_fedex_explain",
                            "direction": "1",
                            "type": "message",
                            "text": "Great, thank you. Next we'll need your address.",
                            "ignore_time_to_show_other_state": "true",
                            "time_to_show": "2500"
                        },
                        "8": {
                            "key": "input_google_maps",
                            "direction": "0",
                            "type": "google_mui_auto_complete",
                            "text": "Enter your address",
                            "map_name": "seller_location"
                        },
                        "9": {
                            "key": "message_got_address",
                            "direction": "1",
                            "type": "message",
                            "text": "I got it, thanks!<br>Is this an apartment or a suite?",
                            "time_to_show": "2500"
                        },
                        "10": {
                            "key": "two_buttons_address_2",
                            "direction": "0",
                            "type": "two_buttons",
                            "text": "1: Apartment/Suite, 2: Neither",
                            "button1": {
                                "text": "APARTMENT / SUITE",
                                "response": {
                                    "0": {
                                        "key": "message_apartment_suite_selected",
                                        "direction": "2",
                                        "type": "message",
                                        "text": "The address is an apartment / suite."
                                    },
                                    "1": {
                                        "key": "message_apartment_suite_request",
                                        "direction": "1",
                                        "type": "message",
                                        "text": "Great!<br>What's your apartment / suite number?",
                                        "time_to_show": "1800"
                                    },
                                    "2": {
                                        "key": "input_address_2",
                                        "key_response": "message_address_2_provided",
                                        "direction": "0",
                                        "type": "free_text",
                                        "text": "Enter apartment/suite number",
                                        "nothing": "It’s not an apartment / suite.",
                                        "update_state": "address2"
                                    }
                                }
                            },
                            "button2": {
                                "text": "NEITHER",
                                "response": {
                                    "0": {
                                        "key": "message_address_2_not_provided",
                                        "direction": "2",
                                        "type": "message",
                                        "text": "It’s not an apartment / suite.",
                                        "time_to_show": "1800"
                                    }
                                }
                            }
                        },
                        "11": {
                            "key": "generate_shipping_label_method",
                            "direction": "0",
                            "type": "method",
                            "method": "generate_shipping_label",
                            "time_to_show": "0"
                        },
                        "12": {
                            "key": "message_fedex_arrange_pickup",
                            "direction": "1",
                            "type": "message",
                            "text": "Ok, we partnered with Fedex to make shipping as easy as possible.",
                            "time_to_show": "2500"
                        },
                        "13": {
                            "key": "shipping_label_ready_method",
                            "direction": "0",
                            "type": "method",
                            "method": "shipping_label_ready",
                            "time_to_show": "0"
                        },
                        "14": {
                            "key": "has_available_pickup_slots",
                            "direction": "0",
                            "type": "method",
                            "method": "check_available_pickup_slots",
                            "time_to_show": "0",
                            "hide_waves_timeout": "0",
                            "has_slots": {
                                "0": {
                                    "key": "message_pick_up_time_works",
                                    "direction": "1",
                                    "type": "message",
                                    "text": "What pickup time slot works best for you?",
                                    "time_to_show": "0",
                                    "hide_waves_timeout": "0"
                                },
                                "1": {
                                    "key": "multiple_buttons_schedule_pickup",
                                    "direction": "0",
                                    "type": "schedule_pickup_time",
                                    "placeholder": "Select pickup time...",
                                    "later": {
                                        "text": "Later"
                                    },
                                    "other": {
                                        "text": "<div class=\"day\">OTHER</div> <div class=\"day\">PICKUP TIME</div>",
                                        "update_state": {
                                            "shipmentPreferences": {
                                                "type": "pickup",
                                                "text": "Seller asked for a different pick time options. please contact ASAP and set up a pickup time"
                                            }
                                        }
                                    },
                                    "stickyButtons": {
                                        "text": "<div class=\"day\">DROP IT OFF</div> <div class=\"day\">MYSELF</div>"
                                    },
                                    "fedex_arrange_response": {
                                        "0": {
                                            "key": "message_i_will_arrange_pickup",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "No problem, I’ll check with FedEx for you. It may take a few moments, please don’t close this window.",
                                            "time_to_show": "2000"
                                        },
                                        "1": {
                                            "key": "schedule_fedex_pickup_method",
                                            "direction": "0",
                                            "type": "method",
                                            "method": "schedule_fedex_pickup",
                                            "time_to_show": "0",
                                            "success": {
                                                "0": {
                                                    "key": "message_success_schedule_pickup",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "All done, please see the important packing instructions and pre paid shipping label that I've just emailed to you.<br><br> We also attached <b>Worthy’s Certificate of Property Insurance</b> for your reference. Call us anytime at <a href='tel: 18882220208'>1 (888) 222-0208 </a>"
                                                },
                                                "1": {
                                                    "key": "message_shipping_label_details",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "<b>Your pickup is confirmed for #{schedule_time_text} at #{schedule_pickup_address}</b><br><br>Phone: #{user_phone}<br>Email: #{user_email}<br>Insurance: up to $100,000",
                                                    "time_to_show": "3000"
                                                },
                                                "2": {
                                                    "key": "multiple_buttons_details_correction",
                                                    "direction": "0",
                                                    "type": "update_pickup_details",
                                                    "placeholder": "Need anything else?",
                                                    "buttons": {
                                                        "0": {
                                                            "label": "Done",
                                                            "action": "done",
                                                            "responseText": "Done.",
                                                            "followUpMessage": "update_details_done"
                                                        },
                                                        "1": {
                                                            "label": "Change time",
                                                            "action": "update_pickup_details_time",
                                                            "responseText": "I would like to change my pickup time.",
                                                            "followUpMessage": "update_details_change_time"
                                                        },
                                                        "2": {
                                                            "label": "Change address",
                                                            "action": "update_pickup_details_address",
                                                            "responseText": "I would like to change my pickup address.",
                                                            "followUpMessage": "update_details_action_required"
                                                        },
                                                        "3": {
                                                            "label": "Change email",
                                                            "action": "update_pickup_details_email",
                                                            "responseText": "I would like to change my email.",
                                                            "followUpMessage": "update_details_action_required"
                                                        },
                                                        "4": {
                                                            "label": "Change phone",
                                                            "action": "update_pickup_details_phone",
                                                            "responseText": "I would like to change my phone.",
                                                            "followUpMessage": "update_details_action_required"
                                                        },
                                                        "5": {
                                                            "label": "I have some questions, can we talk?",
                                                            "action": "update_pickup_details_learn_more",
                                                            "responseText": "I have some questions, can we talk?",
                                                            "followUpMessage": "update_details_action_required"
                                                        },
                                                        "6": {
                                                            "label": "Sell another jewelry piece",
                                                            "action": "update_pickup_details_sell_another",
                                                            "responseText": "I would like to sell another jewelry piece",
                                                            "followUpMessage": "update_details_sell_another_jewelry"
                                                        }
                                                    },
                                                    "update_pickup_details_response": {
                                                        "0": {
                                                            "key": "create_update_pickup_details_task",
                                                            "direction": "0",
                                                            "type": "method",
                                                            "method": "update_pickup_details",
                                                            "update_details_done": {
                                                                "0": {
                                                                    "key": "message_update_pickup_details_all_good",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "Great! While you’re getting ready to ship, check out<br><a href='https://www.worthy.com/about/reviews' class='our-reviews' target='_blank'>Our reviews</a>",
                                                                    "time_to_show": "0"
                                                                }
                                                            },
                                                            "update_details_all_good": {
                                                                "0": {
                                                                    "key": "message_update_pickup_details_all_good",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "Great, feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                                                    "time_to_show": "0"
                                                                }
                                                            },
                                                            "update_details_change_time": {
                                                                "0": {
                                                                    "key": "update_details_change_time",
                                                                    "direction": "0",
                                                                    "type": "method",
                                                                    "method": "update_details_change_time",
                                                                    "jump_to_key": "multiple_buttons_schedule_pickup",
                                                                    "message": {
                                                                        "key": "update_details_change_time_message",
                                                                        "direction": "1",
                                                                        "type": "message",
                                                                        "text": "Sure, no problem. I canceled your scheduled pickup.<br><br>Please select a new pickup time below.",
                                                                        "time_to_show": "0"
                                                                    }
                                                                }
                                                            },
                                                            "update_details_action_required": {
                                                                "0": {
                                                                    "key": "message_update_pickup_details_action_required",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "OK, we will contact you shortly.",
                                                                    "time_to_show": "0"
                                                                }
                                                            },
                                                            "update_details_sell_another_jewelry": {
                                                                "0": {
                                                                    "key": "message_update_pickup_details_sell_another_jewelry",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "That's great! Just add it (and any others) to the box with your other valuable and send it in. We'll take care of it.",
                                                                    "time_to_show": "0"
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            "fail": {
                                                "0": {
                                                    "key": "message_fail_schedule_pickup",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "It looks like FedEx is unavailable right now.<br><br>I’ll try again later and contact you once I have your pickup confirmation."
                                                }
                                            }
                                        }
                                    },
                                    "fedex_more_slots": {
                                        "0": {
                                            "key": "message_schedule_pickup_other",
                                            "direction": "2",
                                            "type": "message",
                                            "text": "None of the time slots work for me. Could you show me more options?",
                                            "hide_waves_timeout": "1800"
                                        },
                                        "1": {
                                            "key": "message_i_will_back_to_you",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "No problem. I will get back to you to schedule a pickup time. Expect a call from <a href='tel: 18882220208'>1 (888) 222-0208</a>.",
                                            "time_to_show": "2000"
                                        },
                                        "2": {
                                            "key": "message_if_any_questions",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "Feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                            "time_to_show": "3000"
                                        },
                                        "3": {
                                            "key": "update_shipment_preferences_method",
                                            "direction": "0",
                                            "type": "method",
                                            "method": "update_shipment_preferences",
                                            "time_to_show": "0"
                                        }
                                    },
                                    "fedex_drop_off_locations": {
                                        "0": {
                                            "key": "message_schedule_pickup_drop_off",
                                            "direction": "2",
                                            "type": "message",
                                            "text": "I prefer to drop it off by myself",
                                            "hide_waves_timeout": "1800"
                                        },
                                        "1": {
                                            "key": "message_drop_off_locations",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "No problem, here are a few FedEx drop off locations next to your address.",
                                            "time_to_show": "2000"
                                        },
                                        "2": {
                                            "key": "update_drop_off_locations",
                                            "direction": "0",
                                            "type": "method",
                                            "method": "update_drop_off",
                                            "time_to_show": "0",
                                            "success": {
                                                "0": {
                                                    "key": "message_shipping_label_details",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "Please follow the important packing instructions I just emailed you at:<br><br><b>#{user_email}</b><br><br>The pre-paid shipping label is also enclosed in this email.",
                                                    "time_to_show": "0",
                                                    "hide_waves_timeout": "1800"
                                                }
                                            }
                                        },
                                        "3": {
                                            "key": "message_if_any_questions",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "Feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                            "time_to_show": "3000"
                                        },
                                        "4": {
                                            "key": "multiple_buttons_details_correction",
                                            "direction": "0",
                                            "type": "update_drop_off_details",
                                            "placeholder": "Need anything else?",
                                            "buttons": {
                                                "0": {
                                                    "label": "Done",
                                                    "action": "done",
                                                    "responseText": "Done.",
                                                    "followUpMessage": "update_details_done"
                                                },
                                                "1": {
                                                    "label": "Change email",
                                                    "action": "update_drop_off_details_email",
                                                    "responseText": "I would like to change my email.",
                                                    "followUpMessage": "update_details_action_required"
                                                },
                                                "2": {
                                                    "label": "Change phone",
                                                    "action": "update_drop_off_details_phone",
                                                    "responseText": "I would like to change my phone.",
                                                    "followUpMessage": "update_details_action_required"
                                                },
                                                "3": {
                                                    "label": "I have some questions, can we talk?",
                                                    "action": "update_drop_off_details_learn_more",
                                                    "responseText": "I have some questions, can we talk?",
                                                    "followUpMessage": "update_details_action_required"
                                                },
                                                "4": {
                                                    "label": "Sell another jewelry piece",
                                                    "action": "update_drop_off_details_sell_another",
                                                    "responseText": "I would like to sell another jewelry piece",
                                                    "followUpMessage": "update_details_sell_another_jewelry"
                                                }
                                            },
                                            "update_drop_off_details_response": {
                                                "0": {
                                                    "key": "create_update_pickup_details_task",
                                                    "direction": "0",
                                                    "type": "method",
                                                    "method": "update_drop_off_details",
                                                    "update_details_done": {
                                                        "0": {
                                                            "key": "message_update_drop_off_details_all_good",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "Great! While you’re getting ready to ship, check out<br><a href='https://www.worthy.com/about/reviews' class='our-reviews' target='_blank'>Our reviews</a>",
                                                            "time_to_show": "0"
                                                        }
                                                    },
                                                    "update_details_action_required": {
                                                        "0": {
                                                            "key": "message_update_drop_off_details_action_required",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "OK, we will contact you shortly.",
                                                            "time_to_show": "0"
                                                        }
                                                    },
                                                    "update_details_sell_another_jewelry": {
                                                        "0": {
                                                            "key": "message_update_drop_off_details_sell_another_jewelry",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "That's great! Just add it (and any others) to the box with your other valuable and send it in. We'll take care of it.",
                                                            "time_to_show": "0"
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "time_to_show": "0"
                                }
                            },
                            "has_no_slots": {
                                "0": {
                                    "key": "message_pick_up_time_no_slots",
                                    "direction": "1",
                                    "type": "message",
                                    "text": "Unfortunately it seems like there are currently no available pickup time slots for your address.</br> You can still drop it off yourself or contact an Account Executive for assistance.",
                                    "time_to_show": "0",
                                    "hide_waves_timeout": "0"
                                },
                                "1": {
                                    "key": "two_buttons_no_slots_response",
                                    "direction": "0",
                                    "type": "two_buttons",
                                    "button1": {
                                        "text": "Drop it off Myself",
                                        "response": {
                                            "0": {
                                                "key": "message_schedule_pickup_drop_off",
                                                "direction": "2",
                                                "type": "message",
                                                "text": "I prefer to drop it off by myself",
                                                "hide_waves_timeout": "1800"
                                            },
                                            "1": {
                                                "key": "message_drop_off_locations",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "No problem, here are a few FedEx drop off locations next to your address.",
                                                "time_to_show": "2000"
                                            },
                                            "2": {
                                                "key": "update_drop_off_locations",
                                                "direction": "0",
                                                "type": "method",
                                                "method": "update_drop_off",
                                                "time_to_show": "0",
                                                "success": {
                                                    "0": {
                                                        "key": "message_shipping_label_details",
                                                        "direction": "1",
                                                        "type": "message",
                                                        "text": "Please follow the important packing instructions I just emailed you at:<br><br><b>#{user_email}</b><br><br>The pre-paid shipping label is also enclosed in this email.",
                                                        "time_to_show": "0",
                                                        "hide_waves_timeout": "1800"
                                                    }
                                                }
                                            },
                                            "3": {
                                                "key": "message_if_any_questions",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "Feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                                "time_to_show": "3000"
                                            },
                                            "4": {
                                                "key": "multiple_buttons_details_correction",
                                                "direction": "0",
                                                "type": "update_drop_off_details",
                                                "placeholder": "Need anything else?",
                                                "buttons": {
                                                    "0": {
                                                        "label": "Done",
                                                        "action": "done",
                                                        "responseText": "Done.",
                                                        "followUpMessage": "update_details_done"
                                                    },
                                                    "1": {
                                                        "label": "Change email",
                                                        "action": "update_drop_off_details_email",
                                                        "responseText": "I would like to change my email.",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "2": {
                                                        "label": "Change phone",
                                                        "action": "update_drop_off_details_phone",
                                                        "responseText": "I would like to change my phone.",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "3": {
                                                        "label": "I have some questions, can we talk?",
                                                        "action": "update_drop_off_details_learn_more",
                                                        "responseText": "I have some questions, can we talk?",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "4": {
                                                        "label": "Sell another jewelry piece",
                                                        "action": "update_drop_off_details_sell_another",
                                                        "responseText": "I would like to sell another jewelry piece",
                                                        "followUpMessage": "update_details_sell_another_jewelry"
                                                    }
                                                },
                                                "update_drop_off_details_response": {
                                                    "0": {
                                                        "key": "create_update_pickup_details_task",
                                                        "direction": "0",
                                                        "type": "method",
                                                        "method": "update_drop_off_details",
                                                        "update_details_done": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_all_good",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "Great! While you’re getting ready to ship, check out<br><a href='https://www.worthy.com/about/reviews' class='our-reviews' target='_blank'>Our reviews</a>",
                                                                "time_to_show": "0"
                                                            }
                                                        },
                                                        "update_details_action_required": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_action_required",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "OK, we will contact you shortly.",
                                                                "time_to_show": "0"
                                                            }
                                                        },
                                                        "update_details_sell_another_jewelry": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_sell_another_jewelry",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "That's great! Just add it (and any others) to the box with your other valuable and send it in. We'll take care of it.",
                                                                "time_to_show": "0"
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "time_to_show": "0"
                                    },
                                    "button2": {
                                        "text": "Talk to Account Executive",
                                        "response": {
                                            "0": {
                                                "key": "message_contact_ae",
                                                "direction": "2",
                                                "type": "message",
                                                "text": "I’d like to talk to an Account Executive."
                                            },
                                            "1": {
                                                "key": "contact_ae_method",
                                                "direction": "0",
                                                "type": "method",
                                                "method": "contact_ae",
                                                "time_to_show": "0"
                                            },
                                            "2": {
                                                "key": "message_we_can_do_that",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "We can do that!<br>An account executive will call you at #{user_phone}.<br><br>Expect a call from <b>1 (888) 222-0208</b>.",
                                                "time_to_show": "1800"
                                            }
                                        }
                                    }
                                }
                            },
                            "fedex_error": {
                                "0": {
                                    "key": "message_no_pickup_availability",
                                    "direction": "1",
                                    "type": "message",
                                    "text": "Looks like FedEx is unavailable right now.</br> You can still drop it off yourself or contact an Account Executive for assistance.",
                                    "time_to_show": "0",
                                    "hide_waves_timeout": "0"
                                },
                                "1": {
                                    "key": "two_buttons_no_slots_response",
                                    "direction": "0",
                                    "type": "two_buttons",
                                    "button1": {
                                        "text": "Drop it off Myself",
                                        "response": {
                                            "0": {
                                                "key": "message_schedule_pickup_drop_off",
                                                "direction": "2",
                                                "type": "message",
                                                "text": "I prefer to drop it off by myself",
                                                "hide_waves_timeout": "1800"
                                            },
                                            "1": {
                                                "key": "message_drop_off_locations",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "No problem, here are a few FedEx drop off locations next to your address.",
                                                "time_to_show": "2000"
                                            },
                                            "2": {
                                                "key": "update_drop_off_locations",
                                                "direction": "0",
                                                "type": "method",
                                                "method": "update_drop_off",
                                                "time_to_show": "0",
                                                "success": {
                                                    "0": {
                                                        "key": "message_shipping_label_details",
                                                        "direction": "1",
                                                        "type": "message",
                                                        "text": "Please follow the important packing instructions I just emailed you at:<br><br><b>#{user_email}</b><br><br>The pre-paid shipping label is also enclosed in this email.",
                                                        "time_to_show": "0",
                                                        "hide_waves_timeout": "1800"
                                                    }
                                                }
                                            },
                                            "3": {
                                                "key": "message_if_any_questions",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "Feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                                "time_to_show": "3000"
                                            },
                                            "4": {
                                                "key": "multiple_buttons_details_correction",
                                                "direction": "0",
                                                "type": "update_drop_off_details",
                                                "placeholder": "Need anything else?",
                                                "buttons": {
                                                    "0": {
                                                        "label": "Done",
                                                        "action": "done",
                                                        "responseText": "Done.",
                                                        "followUpMessage": "update_details_done"
                                                    },
                                                    "1": {
                                                        "label": "Change email",
                                                        "action": "update_drop_off_details_email",
                                                        "responseText": "I would like to change my email.",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "2": {
                                                        "label": "Change phone",
                                                        "action": "update_drop_off_details_phone",
                                                        "responseText": "I would like to change my phone.",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "3": {
                                                        "label": "I have some questions, can we talk?",
                                                        "action": "update_drop_off_details_learn_more",
                                                        "responseText": "I have some questions, can we talk?",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "4": {
                                                        "label": "Sell another jewelry piece",
                                                        "action": "update_drop_off_details_sell_another",
                                                        "responseText": "I would like to sell another jewelry piece",
                                                        "followUpMessage": "update_details_sell_another_jewelry"
                                                    }
                                                },
                                                "update_drop_off_details_response": {
                                                    "0": {
                                                        "key": "create_update_pickup_details_task",
                                                        "direction": "0",
                                                        "type": "method",
                                                        "method": "update_drop_off_details",
                                                        "update_details_done": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_all_good",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "Great! While you’re getting ready to ship, check out<br><a href='https://www.worthy.com/about/reviews' class='our-reviews' target='_blank'>Our reviews</a>",
                                                                "time_to_show": "0"
                                                            }
                                                        },
                                                        "update_details_action_required": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_action_required",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "OK, we will contact you shortly.",
                                                                "time_to_show": "0"
                                                            }
                                                        },
                                                        "update_details_sell_another_jewelry": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_sell_another_jewelry",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "That's great! Just add it (and any others) to the box with your other valuable and send it in. We'll take care of it.",
                                                                "time_to_show": "0"
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "time_to_show": "0"
                                    },
                                    "button2": {
                                        "text": "Talk to Account Executive",
                                        "response": {
                                            "0": {
                                                "key": "message_contact_ae",
                                                "direction": "2",
                                                "type": "message",
                                                "text": "I’d like to talk to an Account Executive."
                                            },
                                            "1": {
                                                "key": "contact_ae_method",
                                                "direction": "0",
                                                "type": "method",
                                                "method": "contact_ae",
                                                "time_to_show": "0"
                                            },
                                            "2": {
                                                "key": "message_we_can_do_that",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "We can do that!<br>An account executive will call you at #{user_phone}.<br><br>Expect a call from <b>1 (888) 222-0208</b>.",
                                                "time_to_show": "1800"
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        "15": {
                            "key": "button_phone",
                            "direction": "0",
                            "type": "one_button_phone",
                            "text": "Call 1 (888) 222-0208",
                            "time_to_show": "3000",
                            "phone": "18882220208"
                        }
                    }
                },
                "2": {
                    "version": "3.1",
                    "showAvatar": "true",
                    "const_messages": {
                        "message_address_change": {
                            "key": "message_address_change",
                            "direction": "2",
                            "type": "message",
                            "text": "Oops, I'd like to change the address.",
                            "response": {
                                "key": "message_enter_address_again",
                                "direction": "1",
                                "type": "message",
                                "text": "Sure, no problem. Please enter your address again.",
                                "time_to_show": "2000"
                            }
                        },
                        "welcomeBackSubmissionPhoto": {
                            "key": "message_welcome_back_submission_photo",
                            "direction": "1",
                            "type": "message",
                            "text": "Welcome back #{user_first_name}. The next step is to set up your free and insured FedEx shipment.</br></br>To create a FedEx label, would you please enter your address?",
                            "jump_to_key": "input_google_maps",
                            "time_to_show": "0",
                            "hide_waves_timeout": "0"
                        }
                    },
                    "flow": {
                        "0": {
                            "key": "message_welcome",
                            "direction": "1",
                            "type": "message",
                            "text": "Hi #{user_first_name}.<br><br>Thank you for considering us for the sale of your: <br><b>#{item_desc}</b>.",
                            "time_to_show": "0",
                            "hide_waves_timeout": "0"
                        },
                        "1": {
                            "key": "message_welcome_photo",
                            "direction": "1",
                            "type": "message",
                            "text": "To help us get a better sense of your valuable, please upload a top view <b>photo</b> of it or any <b>documentation</b> you might have.",
                            "time_to_show": "0",
                            "hide_waves_timeout": "0"
                        },
                        "2": {
                            "key": "two_buttons_upload_photo",
                            "direction": "0",
                            "type": "add_photo_button_two",
                            "bottomText": "Uploading a photo should expedite the process",
                            "text": "Upload Photo",
                            "time_to_show": "1000",
                            "hide_waves_timeout": "0",
                            "button1": {
                                "text": "Upload Photo",
                                "response": {
                                    "0": {
                                        "key": "message_photo_being_uploaded",
                                        "direction": "2",
                                        "type": "photo_being_uploaded",
                                        "text": "",
                                        "time_to_show": "0",
                                        "hide_waves_timeout": "0"
                                    },
                                    "1": {
                                        "key": "upload_photo_method",
                                        "direction": "0",
                                        "type": "method",
                                        "method": "upload_photo",
                                        "time_to_show": "0",
                                        "hide_waves_timeout": "0",
                                        "add_key_on_fail": "true",
                                        "success": {
                                            "0": {
                                                "key": "message_schedule_after_photo",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "Got it. How would you like to proceed?",
                                                "time_to_show": "1000",
                                                "hide_waves_timeout": "0"
                                            },
                                            "1": {
                                                "key": "two_buttons_contact_ae",
                                                "direction": "0",
                                                "type": "two_buttons",
                                                "button1": {
                                                    "text": "Continue",
                                                    "response": {
                                                        "0": {
                                                            "key": "message_lets_continue_online",
                                                            "direction": "2",
                                                            "type": "message",
                                                            "text": "Let's continue!"
                                                        }
                                                    }
                                                },
                                                "button2": {
                                                    "text": "Talk to Expert",
                                                    "clarityComponent": "secondary",
                                                    "response": {
                                                        "0": {
                                                            "key": "message_contact_ae",
                                                            "direction": "2",
                                                            "type": "message",
                                                            "text": "I’d like to talk to an Account Executive."
                                                        },
                                                        "1": {
                                                            "key": "contact_ae_method",
                                                            "direction": "0",
                                                            "type": "method",
                                                            "method": "contact_ae",
                                                            "time_to_show": "0"
                                                        },
                                                        "2": {
                                                            "key": "message_we_can_do_that",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "We can do that!<br>An account executive will call you at #{user_phone}.<br><br>Expect a call from <b>1 (888) 222-0208</b>.",
                                                            "time_to_show": "1800"
                                                        },
                                                        "3": {
                                                            "key": "button_continue",
                                                            "direction": "0",
                                                            "type": "one_button",
                                                            "text": "Continue Online",
                                                            "response": {
                                                                "key": "message_lets_continue",
                                                                "direction": "2",
                                                                "type": "message",
                                                                "text": "Let's continue!"
                                                            },
                                                            "time_to_show": "1000"
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            "button2": {
                                "text": "Skip",
                                "clarityComponent": "secondary",
                                "response": {
                                    "0": {
                                        "key": "message_lets_skip",
                                        "direction": "2",
                                        "type": "message",
                                        "text": "Skip this step please."
                                    },
                                    "1": {
                                        "key": "message_no_problem",
                                        "direction": "1",
                                        "type": "message",
                                        "text": "Sure. How would you like to proceed?",
                                        "time_to_show": "1800"
                                    },
                                    "2": {
                                        "key": "two_buttons_contact_ae",
                                        "direction": "0",
                                        "type": "two_buttons",
                                        "button1": {
                                            "text": "Continue",
                                            "response": {
                                                "0": {
                                                    "key": "message_lets_continue_online",
                                                    "direction": "2",
                                                    "type": "message",
                                                    "text": "Let's continue!"
                                                }
                                            }
                                        },
                                        "button2": {
                                            "text": "Talk to Expert",
                                            "clarityComponent": "secondary",
                                            "response": {
                                                "0": {
                                                    "key": "message_contact_ae",
                                                    "direction": "2",
                                                    "type": "message",
                                                    "text": "I’d like to talk to an Account Executive."
                                                },
                                                "1": {
                                                    "key": "contact_ae_method",
                                                    "direction": "0",
                                                    "type": "method",
                                                    "method": "contact_ae",
                                                    "time_to_show": "0"
                                                },
                                                "2": {
                                                    "key": "message_we_can_do_that",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "We can do that!<br>An account executive will call you at #{user_phone}.<br><br>Expect a call from <b>1 (888) 222-0208</b>.",
                                                    "time_to_show": "1800"
                                                },
                                                "3": {
                                                    "key": "button_continue",
                                                    "direction": "0",
                                                    "type": "one_button",
                                                    "text": "Continue Online",
                                                    "response": {
                                                        "key": "message_lets_continue",
                                                        "direction": "2",
                                                        "type": "message",
                                                        "text": "Let's continue!"
                                                    },
                                                    "time_to_show": "1000"
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        "3": {
                            "key": "accept_sell_estimation_method",
                            "direction": "0",
                            "type": "method",
                            "method": "accept_sell_estimation",
                            "time_to_show": "0"
                        },
                        "4": {
                            "key": "message_gia",
                            "direction": "1",
                            "type": "message",
                            "text": "Our sellers get the most competitive offers because our buyers trust us.</br></br>To maintain that trust we inspect and authenticate each valuable.",
                            "ignore_time_to_show_other_state": "true",
                            "time_to_show": "4000"
                        },
                        "5": {
                            "key": "message_insurance",
                            "direction": "1",
                            "type": "message",
                            "text": "For authentication, your valuable will be shipped with FedEx, fully insured.",
                            "ignore_time_to_show_other_state": "true",
                            "time_to_show": "3500"
                        },
                        "6": {
                            "key": "message_fedex_explain",
                            "direction": "1",
                            "type": "message",
                            "text": "To create your free Fedex label, would you please enter your address?",
                            "ignore_time_to_show_other_state": "true",
                            "time_to_show": "2500"
                        },
                        "7": {
                            "key": "input_google_maps",
                            "direction": "0",
                            "type": "google_mui_auto_complete",
                            "text": "Enter your address",
                            "map_name": "seller_location"
                        },
                        "8": {
                            "key": "message_got_address",
                            "direction": "1",
                            "type": "message",
                            "text": "I got it, thanks!<br>Is this an apartment or a suite?",
                            "time_to_show": "2500"
                        },
                        "9": {
                            "key": "two_buttons_address_2",
                            "direction": "0",
                            "type": "two_buttons",
                            "text": "1: Apartment/Suite, 2: Neither",
                            "button1": {
                                "text": "APARTMENT / SUITE",
                                "response": {
                                    "0": {
                                        "key": "message_apartment_suite_selected",
                                        "direction": "2",
                                        "type": "message",
                                        "text": "The address is an apartment / suite."
                                    },
                                    "1": {
                                        "key": "message_apartment_suite_request",
                                        "direction": "1",
                                        "type": "message",
                                        "text": "Great!<br>What's your apartment / suite number?",
                                        "time_to_show": "1800"
                                    },
                                    "2": {
                                        "key": "input_address_2",
                                        "key_response": "message_address_2_provided",
                                        "direction": "0",
                                        "type": "free_text",
                                        "text": "Enter apartment/suite number",
                                        "nothing": "It’s not an apartment / suite.",
                                        "update_state": "address2"
                                    }
                                }
                            },
                            "button2": {
                                "text": "NEITHER",
                                "response": {
                                    "0": {
                                        "key": "message_address_2_not_provided",
                                        "direction": "2",
                                        "type": "message",
                                        "text": "It’s not an apartment / suite.",
                                        "time_to_show": "1800"
                                    }
                                }
                            }
                        },
                        "10": {
                            "key": "generate_shipping_label_method",
                            "direction": "0",
                            "type": "method",
                            "method": "generate_shipping_label",
                            "time_to_show": "0"
                        },
                        "11": {
                            "key": "message_fedex_arrange_pickup",
                            "direction": "1",
                            "type": "message",
                            "text": "Ok, we partnered with Fedex to make shipping as easy as possible.",
                            "time_to_show": "2500"
                        },
                        "12": {
                            "key": "shipping_label_ready_method",
                            "direction": "0",
                            "type": "method",
                            "method": "shipping_label_ready",
                            "time_to_show": "0"
                        },
                        "13": {
                            "key": "has_available_pickup_slots",
                            "direction": "0",
                            "type": "method",
                            "method": "check_available_pickup_slots",
                            "time_to_show": "0",
                            "hide_waves_timeout": "0",
                            "has_slots": {
                                "0": {
                                    "key": "message_pick_up_time_works",
                                    "direction": "1",
                                    "type": "message",
                                    "text": "What pickup time slot works best for you?",
                                    "time_to_show": "0",
                                    "hide_waves_timeout": "0"
                                },
                                "1": {
                                    "key": "multiple_buttons_schedule_pickup",
                                    "direction": "0",
                                    "type": "schedule_pickup_time",
                                    "placeholder": "Select pickup time...",
                                    "later": {
                                        "text": "Later"
                                    },
                                    "other": {
                                        "text": "<div class=\"day\">OTHER</div> <div class=\"day\">PICKUP TIME</div>",
                                        "update_state": {
                                            "shipmentPreferences": {
                                                "type": "pickup",
                                                "text": "Seller asked for a different pick time options. please contact ASAP and set up a pickup time"
                                            }
                                        }
                                    },
                                    "stickyButtons": {
                                        "text": "<div class=\"day\">DROP IT OFF</div> <div class=\"day\">MYSELF</div>"
                                    },
                                    "fedex_arrange_response": {
                                        "0": {
                                            "key": "message_i_will_arrange_pickup",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "No problem, I’ll check with FedEx for you. It may take a few moments, please don’t close this window.",
                                            "time_to_show": "2000"
                                        },
                                        "1": {
                                            "key": "schedule_fedex_pickup_method",
                                            "direction": "0",
                                            "type": "method",
                                            "method": "schedule_fedex_pickup",
                                            "time_to_show": "0",
                                            "success": {
                                                "0": {
                                                    "key": "message_success_schedule_pickup",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "All done, please see the important packing instructions and pre paid shipping label that I've just emailed to you.<br><br> We also attached <b>Worthy’s Certificate of Property Insurance</b> for your reference. Call us anytime at <a href='tel: 18882220208'>1 (888) 222-0208 </a>"
                                                },
                                                "1": {
                                                    "key": "message_shipping_label_details",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "<b>Your pickup is confirmed for #{schedule_time_text} at #{schedule_pickup_address}</b><br><br>Phone: #{user_phone}<br>Email: #{user_email}<br>Insurance: up to $100,000",
                                                    "time_to_show": "3000"
                                                },
                                                "2": {
                                                    "key": "multiple_buttons_details_correction",
                                                    "direction": "0",
                                                    "type": "update_pickup_details",
                                                    "placeholder": "Need anything else?",
                                                    "buttons": {
                                                        "0": {
                                                            "label": "Done",
                                                            "action": "done",
                                                            "responseText": "Done.",
                                                            "followUpMessage": "update_details_done"
                                                        },
                                                        "1": {
                                                            "label": "Change time",
                                                            "action": "update_pickup_details_time",
                                                            "responseText": "I would like to change my pickup time.",
                                                            "followUpMessage": "update_details_change_time"
                                                        },
                                                        "2": {
                                                            "label": "Change address",
                                                            "action": "update_pickup_details_address",
                                                            "responseText": "I would like to change my pickup address.",
                                                            "followUpMessage": "update_details_action_required"
                                                        },
                                                        "3": {
                                                            "label": "Change email",
                                                            "action": "update_pickup_details_email",
                                                            "responseText": "I would like to change my email.",
                                                            "followUpMessage": "update_details_action_required"
                                                        },
                                                        "4": {
                                                            "label": "Change phone",
                                                            "action": "update_pickup_details_phone",
                                                            "responseText": "I would like to change my phone.",
                                                            "followUpMessage": "update_details_action_required"
                                                        },
                                                        "5": {
                                                            "label": "I have some questions, can we talk?",
                                                            "action": "update_pickup_details_learn_more",
                                                            "responseText": "I have some questions, can we talk?",
                                                            "followUpMessage": "update_details_action_required"
                                                        },
                                                        "6": {
                                                            "label": "Sell another jewelry piece",
                                                            "action": "update_pickup_details_sell_another",
                                                            "responseText": "I would like to sell another jewelry piece",
                                                            "followUpMessage": "update_details_sell_another_jewelry"
                                                        }
                                                    },
                                                    "update_pickup_details_response": {
                                                        "0": {
                                                            "key": "create_update_pickup_details_task",
                                                            "direction": "0",
                                                            "type": "method",
                                                            "method": "update_pickup_details",
                                                            "update_details_done": {
                                                                "0": {
                                                                    "key": "message_update_pickup_details_all_good",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "Great! While you’re getting ready to ship, check out<br><a href='https://www.worthy.com/about/reviews' class='our-reviews' target='_blank'>Our reviews</a>",
                                                                    "time_to_show": "0"
                                                                }
                                                            },
                                                            "update_details_all_good": {
                                                                "0": {
                                                                    "key": "message_update_pickup_details_all_good",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "Great, feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                                                    "time_to_show": "0"
                                                                }
                                                            },
                                                            "update_details_change_time": {
                                                                "0": {
                                                                    "key": "update_details_change_time",
                                                                    "direction": "0",
                                                                    "type": "method",
                                                                    "method": "update_details_change_time",
                                                                    "jump_to_key": "multiple_buttons_schedule_pickup",
                                                                    "message": {
                                                                        "key": "update_details_change_time_message",
                                                                        "direction": "1",
                                                                        "type": "message",
                                                                        "text": "Sure, no problem. I canceled your scheduled pickup.<br><br>Please select a new pickup time below.",
                                                                        "time_to_show": "0"
                                                                    }
                                                                }
                                                            },
                                                            "update_details_action_required": {
                                                                "0": {
                                                                    "key": "message_update_pickup_details_action_required",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "OK, we will contact you shortly.",
                                                                    "time_to_show": "0"
                                                                }
                                                            },
                                                            "update_details_sell_another_jewelry": {
                                                                "0": {
                                                                    "key": "message_update_pickup_details_sell_another_jewelry",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "That's great! Just add it (and any others) to the box with your other valuable and send it in. We'll take care of it.",
                                                                    "time_to_show": "0"
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            "fail": {
                                                "0": {
                                                    "key": "message_fail_schedule_pickup",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "It looks like FedEx is unavailable right now.<br><br>I’ll try again later and contact you once I have your pickup confirmation."
                                                }
                                            }
                                        }
                                    },
                                    "fedex_more_slots": {
                                        "0": {
                                            "key": "message_schedule_pickup_other",
                                            "direction": "2",
                                            "type": "message",
                                            "text": "None of the time slots work for me. Could you show me more options?",
                                            "hide_waves_timeout": "1800"
                                        },
                                        "1": {
                                            "key": "message_i_will_back_to_you",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "No problem. I will get back to you to schedule a pickup time. Expect a call from <a href='tel: 18882220208'>1 (888) 222-0208</a>.",
                                            "time_to_show": "2000"
                                        },
                                        "2": {
                                            "key": "message_if_any_questions",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "Feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                            "time_to_show": "3000"
                                        },
                                        "3": {
                                            "key": "update_shipment_preferences_method",
                                            "direction": "0",
                                            "type": "method",
                                            "method": "update_shipment_preferences",
                                            "time_to_show": "0"
                                        }
                                    },
                                    "fedex_drop_off_locations": {
                                        "0": {
                                            "key": "message_schedule_pickup_drop_off",
                                            "direction": "2",
                                            "type": "message",
                                            "text": "I prefer to drop it off by myself",
                                            "hide_waves_timeout": "1800"
                                        },
                                        "1": {
                                            "key": "message_drop_off_locations",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "No problem, here are a few FedEx drop off locations next to your address.",
                                            "time_to_show": "2000"
                                        },
                                        "2": {
                                            "key": "update_drop_off_locations",
                                            "direction": "0",
                                            "type": "method",
                                            "method": "update_drop_off",
                                            "time_to_show": "0",
                                            "success": {
                                                "0": {
                                                    "key": "message_shipping_label_details",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "Please follow the important packing instructions I just emailed you at:<br><br><b>#{user_email}</b><br><br>The pre-paid shipping label is also enclosed in this email.",
                                                    "time_to_show": "0",
                                                    "hide_waves_timeout": "1800"
                                                }
                                            }
                                        },
                                        "3": {
                                            "key": "message_if_any_questions",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "Feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                            "time_to_show": "3000"
                                        },
                                        "4": {
                                            "key": "multiple_buttons_details_correction",
                                            "direction": "0",
                                            "type": "update_drop_off_details",
                                            "placeholder": "Need anything else?",
                                            "buttons": {
                                                "0": {
                                                    "label": "Done",
                                                    "action": "done",
                                                    "responseText": "Done.",
                                                    "followUpMessage": "update_details_done"
                                                },
                                                "1": {
                                                    "label": "Change email",
                                                    "action": "update_drop_off_details_email",
                                                    "responseText": "I would like to change my email.",
                                                    "followUpMessage": "update_details_action_required"
                                                },
                                                "2": {
                                                    "label": "Change phone",
                                                    "action": "update_drop_off_details_phone",
                                                    "responseText": "I would like to change my phone.",
                                                    "followUpMessage": "update_details_action_required"
                                                },
                                                "3": {
                                                    "label": "I have some questions, can we talk?",
                                                    "action": "update_drop_off_details_learn_more",
                                                    "responseText": "I have some questions, can we talk?",
                                                    "followUpMessage": "update_details_action_required"
                                                },
                                                "4": {
                                                    "label": "Sell another jewelry piece",
                                                    "action": "update_drop_off_details_sell_another",
                                                    "responseText": "I would like to sell another jewelry piece",
                                                    "followUpMessage": "update_details_sell_another_jewelry"
                                                }
                                            },
                                            "update_drop_off_details_response": {
                                                "0": {
                                                    "key": "create_update_pickup_details_task",
                                                    "direction": "0",
                                                    "type": "method",
                                                    "method": "update_drop_off_details",
                                                    "update_details_done": {
                                                        "0": {
                                                            "key": "message_update_drop_off_details_all_good",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "Great! While you’re getting ready to ship, check out<br><a href='https://www.worthy.com/about/reviews' class='our-reviews' target='_blank'>Our reviews</a>",
                                                            "time_to_show": "0"
                                                        }
                                                    },
                                                    "update_details_action_required": {
                                                        "0": {
                                                            "key": "message_update_drop_off_details_action_required",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "OK, we will contact you shortly.",
                                                            "time_to_show": "0"
                                                        }
                                                    },
                                                    "update_details_sell_another_jewelry": {
                                                        "0": {
                                                            "key": "message_update_drop_off_details_sell_another_jewelry",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "That's great! Just add it (and any others) to the box with your other valuable and send it in. We'll take care of it.",
                                                            "time_to_show": "0"
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "time_to_show": "0"
                                }
                            },
                            "has_no_slots": {
                                "0": {
                                    "key": "message_pick_up_time_no_slots",
                                    "direction": "1",
                                    "type": "message",
                                    "text": "Unfortunately it seems like there are currently no available pickup time slots for your address.</br> You can still drop it off yourself or contact an Account Executive for assistance.",
                                    "time_to_show": "0",
                                    "hide_waves_timeout": "0"
                                },
                                "1": {
                                    "key": "two_buttons_no_slots_response",
                                    "direction": "0",
                                    "type": "two_buttons",
                                    "button1": {
                                        "text": "Drop it off Myself",
                                        "response": {
                                            "0": {
                                                "key": "message_schedule_pickup_drop_off",
                                                "direction": "2",
                                                "type": "message",
                                                "text": "I prefer to drop it off by myself",
                                                "hide_waves_timeout": "1800"
                                            },
                                            "1": {
                                                "key": "message_drop_off_locations",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "No problem, here are a few FedEx drop off locations next to your address.",
                                                "time_to_show": "2000"
                                            },
                                            "2": {
                                                "key": "update_drop_off_locations",
                                                "direction": "0",
                                                "type": "method",
                                                "method": "update_drop_off",
                                                "time_to_show": "0",
                                                "success": {
                                                    "0": {
                                                        "key": "message_shipping_label_details",
                                                        "direction": "1",
                                                        "type": "message",
                                                        "text": "Please follow the important packing instructions I just emailed you at:<br><br><b>#{user_email}</b><br><br>The pre-paid shipping label is also enclosed in this email.",
                                                        "time_to_show": "0",
                                                        "hide_waves_timeout": "1800"
                                                    }
                                                }
                                            },
                                            "3": {
                                                "key": "message_if_any_questions",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "Feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                                "time_to_show": "3000"
                                            },
                                            "4": {
                                                "key": "multiple_buttons_details_correction",
                                                "direction": "0",
                                                "type": "update_drop_off_details",
                                                "placeholder": "Need anything else?",
                                                "buttons": {
                                                    "0": {
                                                        "label": "Done",
                                                        "action": "done",
                                                        "responseText": "Done.",
                                                        "followUpMessage": "update_details_done"
                                                    },
                                                    "1": {
                                                        "label": "Change email",
                                                        "action": "update_drop_off_details_email",
                                                        "responseText": "I would like to change my email.",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "2": {
                                                        "label": "Change phone",
                                                        "action": "update_drop_off_details_phone",
                                                        "responseText": "I would like to change my phone.",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "3": {
                                                        "label": "I have some questions, can we talk?",
                                                        "action": "update_drop_off_details_learn_more",
                                                        "responseText": "I have some questions, can we talk?",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "4": {
                                                        "label": "Sell another jewelry piece",
                                                        "action": "update_drop_off_details_sell_another",
                                                        "responseText": "I would like to sell another jewelry piece",
                                                        "followUpMessage": "update_details_sell_another_jewelry"
                                                    }
                                                },
                                                "update_drop_off_details_response": {
                                                    "0": {
                                                        "key": "create_update_pickup_details_task",
                                                        "direction": "0",
                                                        "type": "method",
                                                        "method": "update_drop_off_details",
                                                        "update_details_done": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_all_good",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "Great! While you’re getting ready to ship, check out<br><a href='https://www.worthy.com/about/reviews' class='our-reviews' target='_blank'>Our reviews</a>",
                                                                "time_to_show": "0"
                                                            }
                                                        },
                                                        "update_details_action_required": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_action_required",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "OK, we will contact you shortly.",
                                                                "time_to_show": "0"
                                                            }
                                                        },
                                                        "update_details_sell_another_jewelry": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_sell_another_jewelry",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "That's great! Just add it (and any others) to the box with your other valuable and send it in. We'll take care of it.",
                                                                "time_to_show": "0"
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "time_to_show": "0"
                                    },
                                    "button2": {
                                        "text": "Talk to Account Executive",
                                        "response": {
                                            "0": {
                                                "key": "message_contact_ae",
                                                "direction": "2",
                                                "type": "message",
                                                "text": "I’d like to talk to an Account Executive."
                                            },
                                            "1": {
                                                "key": "contact_ae_method",
                                                "direction": "0",
                                                "type": "method",
                                                "method": "contact_ae",
                                                "time_to_show": "0"
                                            },
                                            "2": {
                                                "key": "message_we_can_do_that",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "We can do that!<br>An account executive will call you at #{user_phone}.<br><br>Expect a call from <b>1 (888) 222-0208</b>.",
                                                "time_to_show": "1800"
                                            }
                                        }
                                    }
                                }
                            },
                            "fedex_error": {
                                "0": {
                                    "key": "message_no_pickup_availability",
                                    "direction": "1",
                                    "type": "message",
                                    "text": "Looks like FedEx is unavailable right now.</br> You can still drop it off yourself or contact an Account Executive for assistance.",
                                    "time_to_show": "0",
                                    "hide_waves_timeout": "0"
                                },
                                "1": {
                                    "key": "two_buttons_no_slots_response",
                                    "direction": "0",
                                    "type": "two_buttons",
                                    "button1": {
                                        "text": "Drop it off Myself",
                                        "response": {
                                            "0": {
                                                "key": "message_schedule_pickup_drop_off",
                                                "direction": "2",
                                                "type": "message",
                                                "text": "I prefer to drop it off by myself",
                                                "hide_waves_timeout": "1800"
                                            },
                                            "1": {
                                                "key": "message_drop_off_locations",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "No problem, here are a few FedEx drop off locations next to your address.",
                                                "time_to_show": "2000"
                                            },
                                            "2": {
                                                "key": "update_drop_off_locations",
                                                "direction": "0",
                                                "type": "method",
                                                "method": "update_drop_off",
                                                "time_to_show": "0",
                                                "success": {
                                                    "0": {
                                                        "key": "message_shipping_label_details",
                                                        "direction": "1",
                                                        "type": "message",
                                                        "text": "Please follow the important packing instructions I just emailed you at:<br><br><b>#{user_email}</b><br><br>The pre-paid shipping label is also enclosed in this email.",
                                                        "time_to_show": "0",
                                                        "hide_waves_timeout": "1800"
                                                    }
                                                }
                                            },
                                            "3": {
                                                "key": "message_if_any_questions",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "Feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                                "time_to_show": "3000"
                                            },
                                            "4": {
                                                "key": "multiple_buttons_details_correction",
                                                "direction": "0",
                                                "type": "update_drop_off_details",
                                                "placeholder": "Need anything else?",
                                                "buttons": {
                                                    "0": {
                                                        "label": "Done",
                                                        "action": "done",
                                                        "responseText": "Done.",
                                                        "followUpMessage": "update_details_done"
                                                    },
                                                    "1": {
                                                        "label": "Change email",
                                                        "action": "update_drop_off_details_email",
                                                        "responseText": "I would like to change my email.",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "2": {
                                                        "label": "Change phone",
                                                        "action": "update_drop_off_details_phone",
                                                        "responseText": "I would like to change my phone.",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "3": {
                                                        "label": "I have some questions, can we talk?",
                                                        "action": "update_drop_off_details_learn_more",
                                                        "responseText": "I have some questions, can we talk?",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "4": {
                                                        "label": "Sell another jewelry piece",
                                                        "action": "update_drop_off_details_sell_another",
                                                        "responseText": "I would like to sell another jewelry piece",
                                                        "followUpMessage": "update_details_sell_another_jewelry"
                                                    }
                                                },
                                                "update_drop_off_details_response": {
                                                    "0": {
                                                        "key": "create_update_pickup_details_task",
                                                        "direction": "0",
                                                        "type": "method",
                                                        "method": "update_drop_off_details",
                                                        "update_details_done": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_all_good",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "Great! While you’re getting ready to ship, check out<br><a href='https://www.worthy.com/about/reviews' class='our-reviews' target='_blank'>Our reviews</a>",
                                                                "time_to_show": "0"
                                                            }
                                                        },
                                                        "update_details_action_required": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_action_required",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "OK, we will contact you shortly.",
                                                                "time_to_show": "0"
                                                            }
                                                        },
                                                        "update_details_sell_another_jewelry": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_sell_another_jewelry",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "That's great! Just add it (and any others) to the box with your other valuable and send it in. We'll take care of it.",
                                                                "time_to_show": "0"
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "time_to_show": "0"
                                    },
                                    "button2": {
                                        "text": "Talk to Account Executive",
                                        "response": {
                                            "0": {
                                                "key": "message_contact_ae",
                                                "direction": "2",
                                                "type": "message",
                                                "text": "I’d like to talk to an Account Executive."
                                            },
                                            "1": {
                                                "key": "contact_ae_method",
                                                "direction": "0",
                                                "type": "method",
                                                "method": "contact_ae",
                                                "time_to_show": "0"
                                            },
                                            "2": {
                                                "key": "message_we_can_do_that",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "We can do that!<br>An account executive will call you at #{user_phone}.<br><br>Expect a call from <b>1 (888) 222-0208</b>.",
                                                "time_to_show": "1800"
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        "14": {
                            "key": "button_phone",
                            "direction": "0",
                            "type": "one_button_phone",
                            "text": "Call 1 (888) 222-0208",
                            "time_to_show": "3000",
                            "phone": "18882220208"
                        }
                    }
                }
            },
            "highValue": {
                "0": {
                    "version": "1.2",
                    "showAvatar": "true",
                    "const_messages": {
                        "message_phone_change": {
                            "key": "message_phone_change",
                            "direction": "1",
                            "type": "message",
                            "text": "All set. Your dedicated auction specialist will call you <b>#{selected_time_full}, at #{user_phone}.</b><br><br>Expect a call from 1(888) 222-0208.",
                            "originalText": "All set. Your dedicated auction specialist will call you <b>#{selected_time_full}, at #{user_new_phone}.</b><br><br>Expect a call from 1(888) 222-0208.",
                            "time_to_show": "0",
                            "hide_waves_timeout": "1800"
                        }
                    },
                    "flow": {
                        "0": {
                            "key": "message_welcome_high_value",
                            "direction": "1",
                            "type": "message",
                            "text": "Hi! I’m Roy, Worthy’s Chief Gemologist. Our VIP team is at your service to discuss selling options for your {item_type}.",
                            "time_to_show": "0"
                        },
                        "1": {
                            "key": "message_welcome_high_value2",
                            "direction": "1",
                            "type": "message",
                            "text": "When is a good time to call you?",
                            "time_to_show": "1000"
                        },
                        "2": {
                            "key": "schedule_appointment_time",
                            "direction": "0",
                            "type": "schedule_appointment",
                            "text": "When shall we call?",
                            "time_to_show": "3000",
                            "response_other_day": {
                                "0": {
                                    "key": "message_change_day_selection",
                                    "direction": "2",
                                    "type": "message",
                                    "text": "Call me #{selected_day}."
                                },
                                "1": {
                                    "key": "message_change_day_selection",
                                    "direction": "1",
                                    "type": "message",
                                    "text": "Sure, what time #{selected_day} works for you?",
                                    "jumpTo": "schedule_appointment_time"
                                }
                            },
                            "response_time_selected": {
                                "0": {
                                    "key": "message_schedule_appointment_success",
                                    "direction": "2",
                                    "type": "message",
                                    "text": "#{selected_time_day_hour} is perfect.",
                                    "time_to_show": "3000"
                                },
                                "1": {
                                    "key": "schedule_appointment",
                                    "direction": "1",
                                    "type": "method",
                                    "method": "schedule_appointment",
                                    "success": {
                                        "0": {
                                            "key": "message_schedule_appointment_all_set",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "All set. Your dedicated auction specialist will call you <b>#{selected_time_full}, at #{user_phone}.</b><br><br>Expect a call from 1(888) 222-0208.",
                                            "originalText": "All set. Your dedicated auction specialist will call you <b>#{selected_time_full}, at #{user_new_phone}.</b><br><br>Expect a call from 1(888) 222-0208.",
                                            "time_to_show": "0",
                                            "hide_waves_timeout": "1800"
                                        },
                                        "1": {
                                            "key": "two_buttons_after_schedule",
                                            "direction": "0",
                                            "type": "two_buttons",
                                            "button1": {
                                                "text": "CHANGE PHONE NUMBER",
                                                "response": {
                                                    "0": {
                                                        "key": "message_change_phone_selected",
                                                        "direction": "2",
                                                        "type": "message",
                                                        "text": "Call me at a different number."
                                                    },
                                                    "1": {
                                                        "key": "message_change_phone_response",
                                                        "direction": "1",
                                                        "type": "message",
                                                        "text": "No problem, where should we reach you?",
                                                        "time_to_show": "1800"
                                                    },
                                                    "2": {
                                                        "key": "input_phone",
                                                        "key_response": "message_phone_provided",
                                                        "direction": "0",
                                                        "type": "free_text_phone",
                                                        "text": "Enter phone",
                                                        "button_text": "OK",
                                                        "text_response": "Call me at #{new_phone}.",
                                                        "update_phone": "true"
                                                    }
                                                }
                                            },
                                            "button2": {
                                                "text": "CONTINUE",
                                                "jumpToEnd": "true",
                                                "response": {
                                                    "0": {
                                                        "key": "message_lets_continue",
                                                        "direction": "2",
                                                        "type": "message",
                                                        "text": "Let's continue",
                                                        "time_to_show": "1800"
                                                    },
                                                    "1": {
                                                        "key": "message_lets_continue_response",
                                                        "direction": "1",
                                                        "type": "message",
                                                        "text": "Help us get a better sense of your valuable. Do you have a GIA <b>certificate</b>?",
                                                        "time_to_show": "0",
                                                        "hide_waves_timeout": "1800"
                                                    },
                                                    "2": {
                                                        "key": "two_buttons_have_certificate",
                                                        "direction": "0",
                                                        "type": "two_buttons",
                                                        "button1": {
                                                            "text": "I HAVE",
                                                            "response": {
                                                                "0": {
                                                                    "key": "message_have_certificate",
                                                                    "direction": "2",
                                                                    "type": "message",
                                                                    "text": "I have a GIA certificate."
                                                                },
                                                                "1": {
                                                                    "key": "have_gia_certificate",
                                                                    "direction": "1",
                                                                    "type": "method",
                                                                    "method": "update_gia_certificate"
                                                                },
                                                                "2": {
                                                                    "key": "message_have_certificate_response",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "Great. Do you have the report number handy?",
                                                                    "time_to_show": "0",
                                                                    "hide_waves_timeout": "1800"
                                                                },
                                                                "3": {
                                                                    "key": "two_buttons_have_report",
                                                                    "direction": "0",
                                                                    "type": "two_buttons",
                                                                    "button1": {
                                                                        "text": "I HAVE",
                                                                        "response": {
                                                                            "0": {
                                                                                "key": "message_have_report",
                                                                                "direction": "2",
                                                                                "type": "message",
                                                                                "text": "I have a report number."
                                                                            },
                                                                            "1": {
                                                                                "key": "message_have_report_number_response",
                                                                                "direction": "1",
                                                                                "type": "message",
                                                                                "text": "Great. Please enter your GIA report number.",
                                                                                "time_to_show": "0",
                                                                                "hide_waves_timeout": "1800"
                                                                            },
                                                                            "2": {
                                                                                "key": "input_report",
                                                                                "key_response": "message_report_provided",
                                                                                "direction": "0",
                                                                                "type": "free_text_report",
                                                                                "text": "Enter report number",
                                                                                "button_text": "OK",
                                                                                "text_response": "My report number is:<br>#{report_number}",
                                                                                "update_report": "true"
                                                                            },
                                                                            "3": {
                                                                                "key": "message_have_carat_weight",
                                                                                "direction": "1",
                                                                                "type": "message",
                                                                                "text": "Got it. What is the carat weight that appears in the GIA report?",
                                                                                "time_to_show": "1800"
                                                                            },
                                                                            "4": {
                                                                                "key": "input_carat_weight",
                                                                                "key_response": "message_carat_weight_provided",
                                                                                "direction": "0",
                                                                                "type": "free_text_carat_weight",
                                                                                "text": "Enter carat weight from report",
                                                                                "button_text": "OK",
                                                                                "text_response": "It's #{carat_weight}",
                                                                                "update_carat_weight": "true"
                                                                            },
                                                                            "5": {
                                                                                "key": "message_have_certificate_all_done",
                                                                                "direction": "1",
                                                                                "type": "message",
                                                                                "text": "That's it for now. We look forward to our call with you <b>#{selected_time_full}. We'll call you at #{new_phone}.</b><br><br>Expect a call from 1(888) 222-0208.</b>",
                                                                                "stopConversation": "true",
                                                                                "time_to_show": "1800"
                                                                            }
                                                                        }
                                                                    },
                                                                    "button2": {
                                                                        "text": "I DON'T HAVE",
                                                                        "response": {
                                                                            "0": {
                                                                                "key": "message_dont_have_report",
                                                                                "direction": "2",
                                                                                "type": "message",
                                                                                "text": "I don't have the report handy.",
                                                                                "time_to_show": "1800"
                                                                            },
                                                                            "1": {
                                                                                "key": "message_dont_have_report_response",
                                                                                "direction": "1",
                                                                                "type": "message",
                                                                                "text": "That's it for now. We look forward to our call with you <b>#{selected_time_full}. We'll call you at #{new_phone}.</b><br><br>Expect a call from 1(888) 222-0208.</b>",
                                                                                "stopConversation": "true",
                                                                                "time_to_show": "1800"
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        },
                                                        "button2": {
                                                            "text": "I DON'T HAVE",
                                                            "response": {
                                                                "0": {
                                                                    "key": "message_dont_have_certificate",
                                                                    "direction": "2",
                                                                    "type": "message",
                                                                    "text": "I don't have a certificate.",
                                                                    "time_to_show": "1800"
                                                                },
                                                                "1": {
                                                                    "key": "message_dont_have_certificate_response",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "That's it for now. We look forward to our call with you <b>#{selected_time_full}. We'll call you at #{new_phone}.</b><br><br>Expect a call from 1(888) 222-0208.</b>",
                                                                    "stopConversation": "true",
                                                                    "time_to_show": "1800"
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                "1": {
                    "version": "1.6",
                    "showAvatar": "true",
                    "const_messages": {
                        "message_phone_change": {
                            "key": "message_phone_change",
                            "direction": "1",
                            "type": "message",
                            "text": "All set. Your dedicated auction specialist will call you <b>#{selected_time_full}, at #{user_phone}.</b><br><br>Expect a call from 1(888) 222-0208.",
                            "originalText": "All set. Your dedicated auction specialist will call you <b>#{selected_time_full}, at #{user_new_phone}.</b><br><br>Expect a call from 1(888) 222-0208.",
                            "time_to_show": "0",
                            "hide_waves_timeout": "1800"
                        }
                    },
                    "flow": {
                        "0": {
                            "key": "message_welcome_high_value",
                            "direction": "1",
                            "type": "message",
                            "text": "Hi! I’m Roy, Worthy’s Chief Gemologist. Our VIP team is at your service to discuss selling options for your {item_type}.",
                            "time_to_show": "0"
                        },
                        "1": {
                            "key": "message_welcome_hv_listing_proceed",
                            "direction": "1",
                            "type": "message",
                            "text": "Please select how you'd like to proceed below.",
                            "time_to_show": "1000"
                        },
                        "2": {
                            "key": "two_buttons_hv_listing_decision",
                            "direction": "0",
                            "type": "two_buttons",
                            "button1": {
                                "text": "SCHEDULE VIP CALL",
                                "dataAutomation": "schedule_vip_call_cui",
                                "response": {
                                    "0": {
                                        "key": "want_to_schedule_a_call",
                                        "direction": "2",
                                        "type": "message",
                                        "text": "I'd like to schedule a call.",
                                        "time_to_show": "1000"
                                    },
                                    "1": {
                                        "key": "message_welcome_high_value2",
                                        "direction": "1",
                                        "type": "message",
                                        "text": "Ok, when is a good time to call you?",
                                        "time_to_show": "1000"
                                    },
                                    "2": {
                                        "key": "schedule_appointment_time",
                                        "direction": "0",
                                        "type": "schedule_appointment",
                                        "text": "When shall we call?",
                                        "time_to_show": "3000",
                                        "response_other_day": {
                                            "0": {
                                                "key": "message_change_day_selection",
                                                "direction": "2",
                                                "type": "message",
                                                "text": "Call me #{selected_day}."
                                            },
                                            "1": {
                                                "key": "message_change_day_selection",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "Sure, what time #{selected_day} works for you?",
                                                "jumpTo": "schedule_appointment_time"
                                            }
                                        },
                                        "response_time_selected": {
                                            "0": {
                                                "key": "message_schedule_appointment_success",
                                                "direction": "2",
                                                "type": "message",
                                                "text": "#{selected_time_day_hour} is perfect.",
                                                "time_to_show": "3000"
                                            },
                                            "1": {
                                                "key": "schedule_appointment",
                                                "direction": "1",
                                                "type": "method",
                                                "method": "schedule_appointment",
                                                "success": {
                                                    "0": {
                                                        "key": "message_schedule_appointment_all_set",
                                                        "direction": "1",
                                                        "type": "message",
                                                        "text": "All set. Your dedicated auction specialist will call you <b>#{selected_time_full}, at #{user_phone}.</b><br><br>Expect a call from 1(888) 222-0208.",
                                                        "originalText": "All set. Your dedicated auction specialist will call you <b>#{selected_time_full}, at #{user_new_phone}.</b><br><br>Expect a call from 1(888) 222-0208.",
                                                        "time_to_show": "0",
                                                        "hide_waves_timeout": "1800"
                                                    },
                                                    "1": {
                                                        "key": "two_buttons_after_schedule",
                                                        "direction": "0",
                                                        "type": "two_buttons",
                                                        "button1": {
                                                            "text": "CHANGE PHONE NUMBER",
                                                            "response": {
                                                                "0": {
                                                                    "key": "message_change_phone_selected",
                                                                    "direction": "2",
                                                                    "type": "message",
                                                                    "text": "Call me at a different number."
                                                                },
                                                                "1": {
                                                                    "key": "message_change_phone_response",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "No problem, where should we reach you?",
                                                                    "time_to_show": "1800"
                                                                },
                                                                "2": {
                                                                    "key": "input_phone",
                                                                    "key_response": "message_phone_provided",
                                                                    "direction": "0",
                                                                    "type": "free_text_phone",
                                                                    "text": "Enter phone",
                                                                    "button_text": "OK",
                                                                    "text_response": "Call me at #{new_phone}.",
                                                                    "update_phone": "true"
                                                                }
                                                            }
                                                        },
                                                        "button2": {
                                                            "text": "CONTINUE",
                                                            "jumpToEnd": "true",
                                                            "response": {
                                                                "0": {
                                                                    "key": "message_lets_continue",
                                                                    "direction": "2",
                                                                    "type": "message",
                                                                    "text": "Let's continue",
                                                                    "time_to_show": "1800"
                                                                },
                                                                "1": {
                                                                    "key": "message_lets_continue_response",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "Help us get a better sense of your valuable. Do you have a GIA <b>certificate</b>?",
                                                                    "time_to_show": "0",
                                                                    "hide_waves_timeout": "1800"
                                                                },
                                                                "2": {
                                                                    "key": "two_buttons_have_certificate",
                                                                    "direction": "0",
                                                                    "type": "two_buttons",
                                                                    "button1": {
                                                                        "text": "I HAVE",
                                                                        "response": {
                                                                            "0": {
                                                                                "key": "message_have_certificate",
                                                                                "direction": "2",
                                                                                "type": "message",
                                                                                "text": "I have a GIA certificate."
                                                                            },
                                                                            "1": {
                                                                                "key": "have_gia_certificate",
                                                                                "direction": "1",
                                                                                "type": "method",
                                                                                "method": "update_gia_certificate"
                                                                            },
                                                                            "2": {
                                                                                "key": "message_have_certificate_response",
                                                                                "direction": "1",
                                                                                "type": "message",
                                                                                "text": "Great. Do you have the report number handy?",
                                                                                "time_to_show": "0",
                                                                                "hide_waves_timeout": "1800"
                                                                            },
                                                                            "3": {
                                                                                "key": "two_buttons_have_report",
                                                                                "direction": "0",
                                                                                "type": "two_buttons",
                                                                                "button1": {
                                                                                    "text": "I HAVE",
                                                                                    "response": {
                                                                                        "0": {
                                                                                            "key": "message_have_report",
                                                                                            "direction": "2",
                                                                                            "type": "message",
                                                                                            "text": "I have a report number."
                                                                                        },
                                                                                        "1": {
                                                                                            "key": "message_have_report_number_response",
                                                                                            "direction": "1",
                                                                                            "type": "message",
                                                                                            "text": "Great. Please enter your GIA report number.",
                                                                                            "time_to_show": "0",
                                                                                            "hide_waves_timeout": "1800"
                                                                                        },
                                                                                        "2": {
                                                                                            "key": "input_report",
                                                                                            "key_response": "message_report_provided",
                                                                                            "direction": "0",
                                                                                            "type": "free_text_report",
                                                                                            "text": "Enter report number",
                                                                                            "button_text": "OK",
                                                                                            "text_response": "My report number is:<br>#{report_number}",
                                                                                            "update_report": "true"
                                                                                        },
                                                                                        "3": {
                                                                                            "key": "message_have_carat_weight",
                                                                                            "direction": "1",
                                                                                            "type": "message",
                                                                                            "text": "Got it. What is the carat weight that appears in the GIA report?",
                                                                                            "time_to_show": "1800"
                                                                                        },
                                                                                        "4": {
                                                                                            "key": "input_carat_weight",
                                                                                            "key_response": "message_carat_weight_provided",
                                                                                            "direction": "0",
                                                                                            "type": "free_text_carat_weight",
                                                                                            "text": "Enter carat weight from report",
                                                                                            "button_text": "OK",
                                                                                            "text_response": "It's #{carat_weight}",
                                                                                            "update_carat_weight": "true"
                                                                                        },
                                                                                        "5": {
                                                                                            "key": "message_have_certificate_all_done",
                                                                                            "direction": "1",
                                                                                            "type": "message",
                                                                                            "text": "That's it for now. We look forward to our call with you <b>#{selected_time_full}. We'll call you at #{new_phone}.</b><br><br>Expect a call from 1(888) 222-0208.</b>",
                                                                                            "stopConversation": "true",
                                                                                            "time_to_show": "1800"
                                                                                        }
                                                                                    }
                                                                                },
                                                                                "button2": {
                                                                                    "text": "I DON'T HAVE",
                                                                                    "response": {
                                                                                        "0": {
                                                                                            "key": "message_dont_have_report",
                                                                                            "direction": "2",
                                                                                            "type": "message",
                                                                                            "text": "I don't have the report handy.",
                                                                                            "time_to_show": "1800"
                                                                                        },
                                                                                        "1": {
                                                                                            "key": "message_dont_have_report_response",
                                                                                            "direction": "1",
                                                                                            "type": "message",
                                                                                            "text": "That's it for now. We look forward to our call with you <b>#{selected_time_full}. We'll call you at #{new_phone}.</b><br><br>Expect a call from 1(888) 222-0208.</b>",
                                                                                            "stopConversation": "true",
                                                                                            "time_to_show": "1800"
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    },
                                                                    "button2": {
                                                                        "text": "I DON'T HAVE",
                                                                        "response": {
                                                                            "0": {
                                                                                "key": "message_dont_have_certificate",
                                                                                "direction": "2",
                                                                                "type": "message",
                                                                                "text": "I don't have a certificate.",
                                                                                "time_to_show": "1800"
                                                                            },
                                                                            "1": {
                                                                                "key": "message_dont_have_certificate_response",
                                                                                "direction": "1",
                                                                                "type": "message",
                                                                                "text": "That's it for now. We look forward to our call with you <b>#{selected_time_full}. We'll call you at #{new_phone}.</b><br><br>Expect a call from 1(888) 222-0208.</b>",
                                                                                "stopConversation": "true",
                                                                                "time_to_show": "1800"
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            "button2": {
                                "text": "LEARN MORE",
                                "dataAutomation": "learn_more_hv",
                                "stopConversation": "true",
                                "action": "open_listing_page"
                            }
                        }
                    }
                }
            },
            "jewelryBox": {
                "0": {
                    "0": {
                        "version": "2.2",
                        "const_messages": {
                            "message_phone_change": {
                                "key": "message_phone_change",
                                "direction": "1",
                                "type": "message",
                                "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                "originalText": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_new_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                "time_to_show": "0",
                                "hide_waves_timeout": "1800"
                            }
                        },
                        "flow": {
                            "0": {
                                "key": "message_welcome_photo_jewelry_box",
                                "direction": "1",
                                "type": "message",
                                "text": "Hi #{user_first_name}, I’m Roy, Worthy’s Chief Gemologist.",
                                "time_to_show": "1000"
                            },
                            "1": {
                                "key": "message_welcome_photo_jewelry_box2",
                                "direction": "1",
                                "type": "message",
                                "text": "To move forward, please upload a group photo <b>showing all the pieces you’d like to sell.</b>",
                                "time_to_show": "1000"
                            },
                            "2": {
                                "key": "message_welcome_photo_jewelry_box2",
                                "direction": "1",
                                "type": "message",
                                "text": "For example: <br> <img class='imageCui' src='https://cdn1.worthy.com/documents/f285165511.a891f41416.user_uploads_2Ftemp.c715d7aa-e135-44fe-a952-adab90fd45d0.JB.png' />",
                                "imageHeight": "41",
                                "time_to_show": "1000"
                            },
                            "3": {
                                "key": "upload_photo_btn",
                                "direction": "0",
                                "type": "add_photo_button",
                                "text": "Upload Photo",
                                "time_to_show": "1000",
                                "hide_waves_timeout": "0",
                                "response": {
                                    "key": "message_photo_being_uploaded",
                                    "direction": "2",
                                    "type": "photo_being_uploaded",
                                    "text": "",
                                    "time_to_show": "0",
                                    "hide_waves_timeout": "0"
                                }
                            },
                            "4": {
                                "key": "upload_photo_method",
                                "direction": "0",
                                "type": "method",
                                "method": "upload_photo",
                                "time_to_show": "0",
                                "hide_waves_timeout": "0",
                                "success": {
                                    "0": {
                                        "key": "message_schedule_after_photo",
                                        "direction": "1",
                                        "type": "message",
                                        "text": "Thanks. would you like to add another photo?",
                                        "time_to_show": "1000",
                                        "hide_waves_timeout": "0"
                                    },
                                    "1": {
                                        "key": "upload_photo_btn2",
                                        "direction": "0",
                                        "type": "add_photo_button_two",
                                        "text": "Upload Photo",
                                        "time_to_show": "1000",
                                        "hide_waves_timeout": "0",
                                        "button1": {
                                            "text": "ADD ANOTHER </br>PHOTO",
                                            "response": {
                                                "0": {
                                                    "key": "message_photo_being_uploaded",
                                                    "direction": "2",
                                                    "type": "photo_being_uploaded",
                                                    "text": "",
                                                    "time_to_show": "0",
                                                    "hide_waves_timeout": "0"
                                                },
                                                "1": {
                                                    "key": "upload_photo_method",
                                                    "direction": "0",
                                                    "type": "method",
                                                    "method": "upload_photo",
                                                    "time_to_show": "0",
                                                    "hide_waves_timeout": "0",
                                                    "add_key_on_fail": "true",
                                                    "success": {
                                                        "0": {
                                                            "key": "message_schedule_after_photo",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "Thanks. would you like to add another photo?",
                                                            "time_to_show": "1000",
                                                            "hide_waves_timeout": "0"
                                                        },
                                                        "1": {
                                                            "key": "upload_photo_btn3",
                                                            "direction": "0",
                                                            "type": "add_photo_button_two",
                                                            "text": "Upload Photo",
                                                            "time_to_show": "1000",
                                                            "hide_waves_timeout": "0",
                                                            "button1": {
                                                                "text": "ADD ANOTHER </br>PHOTO",
                                                                "response": {
                                                                    "0": {
                                                                        "key": "message_photo_being_uploaded",
                                                                        "direction": "2",
                                                                        "type": "photo_being_uploaded",
                                                                        "text": "",
                                                                        "time_to_show": "0",
                                                                        "hide_waves_timeout": "0"
                                                                    },
                                                                    "1": {
                                                                        "key": "upload_photo_method",
                                                                        "direction": "0",
                                                                        "type": "method",
                                                                        "method": "upload_photo",
                                                                        "time_to_show": "0",
                                                                        "hide_waves_timeout": "0",
                                                                        "add_key_on_fail": "true",
                                                                        "success": {
                                                                            "0": {
                                                                                "key": "message_schedule_after_photo",
                                                                                "direction": "1",
                                                                                "type": "message",
                                                                                "text": "Thanks. would you like to add another photo?",
                                                                                "time_to_show": "1000",
                                                                                "hide_waves_timeout": "0"
                                                                            },
                                                                            "1": {
                                                                                "key": "upload_photo_btn4",
                                                                                "direction": "0",
                                                                                "type": "add_photo_button_two",
                                                                                "text": "Upload Photo",
                                                                                "time_to_show": "1000",
                                                                                "hide_waves_timeout": "0",
                                                                                "button1": {
                                                                                    "text": "ADD ANOTHER </br>PHOTO",
                                                                                    "response": {
                                                                                        "0": {
                                                                                            "key": "message_photo_being_uploaded",
                                                                                            "direction": "2",
                                                                                            "type": "photo_being_uploaded",
                                                                                            "text": "",
                                                                                            "time_to_show": "0",
                                                                                            "hide_waves_timeout": "0"
                                                                                        },
                                                                                        "1": {
                                                                                            "key": "upload_photo_method",
                                                                                            "direction": "0",
                                                                                            "type": "method",
                                                                                            "method": "upload_photo",
                                                                                            "time_to_show": "0",
                                                                                            "hide_waves_timeout": "0",
                                                                                            "add_key_on_fail": "true",
                                                                                            "success": {
                                                                                                "0": {
                                                                                                    "key": "message_schedule_after_photo",
                                                                                                    "direction": "1",
                                                                                                    "type": "message",
                                                                                                    "text": "Thanks. would you like to add another photo?",
                                                                                                    "time_to_show": "1000",
                                                                                                    "hide_waves_timeout": "0"
                                                                                                },
                                                                                                "1": {
                                                                                                    "key": "upload_photo_btn5",
                                                                                                    "direction": "0",
                                                                                                    "type": "add_photo_button_two",
                                                                                                    "text": "Upload Photo",
                                                                                                    "time_to_show": "1000",
                                                                                                    "hide_waves_timeout": "0",
                                                                                                    "button1": {
                                                                                                        "text": "ADD ANOTHER </br>PHOTO",
                                                                                                        "response": {
                                                                                                            "0": {
                                                                                                                "key": "message_photo_being_uploaded",
                                                                                                                "direction": "2",
                                                                                                                "type": "photo_being_uploaded",
                                                                                                                "text": "",
                                                                                                                "time_to_show": "0",
                                                                                                                "hide_waves_timeout": "0"
                                                                                                            },
                                                                                                            "1": {
                                                                                                                "key": "upload_photo_method",
                                                                                                                "direction": "0",
                                                                                                                "type": "method",
                                                                                                                "method": "upload_photo",
                                                                                                                "time_to_show": "0",
                                                                                                                "hide_waves_timeout": "0",
                                                                                                                "add_key_on_fail": "true",
                                                                                                                "success": {
                                                                                                                    "0": {
                                                                                                                        "key": "message_schedule_after_photo",
                                                                                                                        "direction": "1",
                                                                                                                        "type": "message",
                                                                                                                        "text": "Great. The next step is to schedule a call with the Worthy team to discuss selling options for your valuables.",
                                                                                                                        "time_to_show": "1000",
                                                                                                                        "hide_waves_timeout": "0"
                                                                                                                    },
                                                                                                                    "1": {
                                                                                                                        "key": "message_schedule_after_photo2",
                                                                                                                        "direction": "1",
                                                                                                                        "type": "message",
                                                                                                                        "text": "When are you available to talk?",
                                                                                                                        "time_to_show": "1000"
                                                                                                                    },
                                                                                                                    "2": {
                                                                                                                        "key": "schedule_appointment_time",
                                                                                                                        "direction": "0",
                                                                                                                        "type": "schedule_appointment",
                                                                                                                        "text": "Select a good time for a call",
                                                                                                                        "time_to_show": "1000",
                                                                                                                        "response_other_day": {
                                                                                                                            "0": {
                                                                                                                                "key": "message_change_day_selection",
                                                                                                                                "direction": "2",
                                                                                                                                "type": "message",
                                                                                                                                "text": "Call me #{selected_day}."
                                                                                                                            },
                                                                                                                            "1": {
                                                                                                                                "key": "message_change_day_selection",
                                                                                                                                "direction": "1",
                                                                                                                                "type": "message",
                                                                                                                                "text": "Sure, what time #{selected_day} works for you?",
                                                                                                                                "jumpTo": "schedule_appointment_time"
                                                                                                                            }
                                                                                                                        },
                                                                                                                        "response_time_selected": {
                                                                                                                            "0": {
                                                                                                                                "key": "message_schedule_appointment_success",
                                                                                                                                "direction": "2",
                                                                                                                                "type": "message",
                                                                                                                                "text": "#{selected_time_day_hour} #{timezone} is great.",
                                                                                                                                "time_to_show": "1000"
                                                                                                                            },
                                                                                                                            "1": {
                                                                                                                                "key": "schedule_appointment",
                                                                                                                                "direction": "1",
                                                                                                                                "type": "method",
                                                                                                                                "method": "schedule_appointment",
                                                                                                                                "success": {
                                                                                                                                    "0": {
                                                                                                                                        "key": "message_schedule_appointment_all_set",
                                                                                                                                        "direction": "1",
                                                                                                                                        "type": "message",
                                                                                                                                        "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                                                                                                                        "time_to_show": "0",
                                                                                                                                        "hide_waves_timeout": "1800"
                                                                                                                                    },
                                                                                                                                    "1": {
                                                                                                                                        "key": "two_buttons_after_schedule",
                                                                                                                                        "direction": "0",
                                                                                                                                        "type": "two_buttons",
                                                                                                                                        "button1": {
                                                                                                                                            "text": "CHANGE PHONE NUMBER",
                                                                                                                                            "response": {
                                                                                                                                                "0": {
                                                                                                                                                    "key": "message_change_phone_selected",
                                                                                                                                                    "direction": "2",
                                                                                                                                                    "type": "message",
                                                                                                                                                    "text": "Call me at a different number."
                                                                                                                                                },
                                                                                                                                                "1": {
                                                                                                                                                    "key": "message_change_phone_response",
                                                                                                                                                    "direction": "1",
                                                                                                                                                    "type": "message",
                                                                                                                                                    "text": "No problem, where should we reach you?",
                                                                                                                                                    "time_to_show": "1800"
                                                                                                                                                },
                                                                                                                                                "2": {
                                                                                                                                                    "key": "input_phone",
                                                                                                                                                    "key_response": "message_phone_provided",
                                                                                                                                                    "direction": "0",
                                                                                                                                                    "type": "free_text_phone",
                                                                                                                                                    "text": "Enter phone",
                                                                                                                                                    "button_text": "OK",
                                                                                                                                                    "text_response": "Call me at #{new_phone}.",
                                                                                                                                                    "update_phone": "true"
                                                                                                                                                }
                                                                                                                                            }
                                                                                                                                        },
                                                                                                                                        "button2": {
                                                                                                                                            "text": "DONE",
                                                                                                                                            "stopConversation": "true",
                                                                                                                                            "response": {
                                                                                                                                                "0": {
                                                                                                                                                    "key": "message_schedule_appointment_done",
                                                                                                                                                    "direction": "2",
                                                                                                                                                    "type": "message",
                                                                                                                                                    "text": "Done.",
                                                                                                                                                    "time_to_show": "1800"
                                                                                                                                                }
                                                                                                                                            }
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                },
                                                                                                                "fail": {
                                                                                                                    "0": {
                                                                                                                        "key": "upload_error",
                                                                                                                        "direction": "1",
                                                                                                                        "type": "message",
                                                                                                                        "text": "Oops, it seems like something went wrong. Would you please try uploading a new photo (either PNG or JPEG)?",
                                                                                                                        "time_to_show": "0",
                                                                                                                        "jump_to_key": "upload_photo_btn5",
                                                                                                                        "hide_waves_timeout": "0"
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    },
                                                                                                    "button2": {
                                                                                                        "text": "CONTINUE",
                                                                                                        "response": {
                                                                                                            "0": {
                                                                                                                "key": "message_schedule_after_photo",
                                                                                                                "direction": "1",
                                                                                                                "type": "message",
                                                                                                                "text": "Great. The next step is to schedule a call with the Worthy team to discuss selling options for your valuables.",
                                                                                                                "time_to_show": "1000",
                                                                                                                "hide_waves_timeout": "0"
                                                                                                            },
                                                                                                            "1": {
                                                                                                                "key": "message_schedule_without_photo",
                                                                                                                "direction": "1",
                                                                                                                "type": "message",
                                                                                                                "text": "When are you available to talk?",
                                                                                                                "time_to_show": "1000"
                                                                                                            },
                                                                                                            "2": {
                                                                                                                "key": "schedule_appointment_time",
                                                                                                                "direction": "0",
                                                                                                                "type": "schedule_appointment",
                                                                                                                "text": "Select a good time for a call",
                                                                                                                "time_to_show": "1000",
                                                                                                                "response_other_day": {
                                                                                                                    "0": {
                                                                                                                        "key": "message_change_day_selection",
                                                                                                                        "direction": "2",
                                                                                                                        "type": "message",
                                                                                                                        "text": "Call me #{selected_day}."
                                                                                                                    },
                                                                                                                    "1": {
                                                                                                                        "key": "message_change_day_selection",
                                                                                                                        "direction": "1",
                                                                                                                        "type": "message",
                                                                                                                        "text": "Sure, what time #{selected_day} works for you?",
                                                                                                                        "jumpTo": "schedule_appointment_time"
                                                                                                                    }
                                                                                                                },
                                                                                                                "response_time_selected": {
                                                                                                                    "0": {
                                                                                                                        "key": "message_schedule_appointment_success",
                                                                                                                        "direction": "2",
                                                                                                                        "type": "message",
                                                                                                                        "text": "#{selected_time_day_hour} #{timezone} is great.",
                                                                                                                        "time_to_show": "3000"
                                                                                                                    },
                                                                                                                    "1": {
                                                                                                                        "key": "schedule_appointment",
                                                                                                                        "direction": "1",
                                                                                                                        "type": "method",
                                                                                                                        "method": "schedule_appointment",
                                                                                                                        "success": {
                                                                                                                            "0": {
                                                                                                                                "key": "message_schedule_appointment_all_set",
                                                                                                                                "direction": "1",
                                                                                                                                "type": "message",
                                                                                                                                "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                                                                                                                "time_to_show": "0",
                                                                                                                                "hide_waves_timeout": "1800"
                                                                                                                            },
                                                                                                                            "1": {
                                                                                                                                "key": "two_buttons_after_schedule",
                                                                                                                                "direction": "0",
                                                                                                                                "type": "two_buttons",
                                                                                                                                "button1": {
                                                                                                                                    "text": "CHANGE PHONE NUMBER",
                                                                                                                                    "response": {
                                                                                                                                        "0": {
                                                                                                                                            "key": "message_change_phone_selected",
                                                                                                                                            "direction": "2",
                                                                                                                                            "type": "message",
                                                                                                                                            "text": "Call me at a different number."
                                                                                                                                        },
                                                                                                                                        "1": {
                                                                                                                                            "key": "message_change_phone_response",
                                                                                                                                            "direction": "1",
                                                                                                                                            "type": "message",
                                                                                                                                            "text": "No problem, where should we reach you?",
                                                                                                                                            "time_to_show": "1800"
                                                                                                                                        },
                                                                                                                                        "2": {
                                                                                                                                            "key": "input_phone",
                                                                                                                                            "key_response": "message_phone_provided",
                                                                                                                                            "direction": "0",
                                                                                                                                            "type": "free_text_phone",
                                                                                                                                            "text": "Enter phone",
                                                                                                                                            "button_text": "OK",
                                                                                                                                            "text_response": "Call me at #{new_phone}.",
                                                                                                                                            "update_phone": "true"
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                },
                                                                                                                                "button2": {
                                                                                                                                    "text": "DONE",
                                                                                                                                    "stopConversation": "true",
                                                                                                                                    "response": {
                                                                                                                                        "0": {
                                                                                                                                            "key": "message_schedule_appointment_done",
                                                                                                                                            "direction": "2",
                                                                                                                                            "type": "message",
                                                                                                                                            "text": "Done.",
                                                                                                                                            "time_to_show": "1800"
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            },
                                                                                            "fail": {
                                                                                                "0": {
                                                                                                    "key": "upload_error",
                                                                                                    "direction": "1",
                                                                                                    "type": "message",
                                                                                                    "text": "Oops, it seems like something went wrong. Would you please try uploading a new photo (either PNG or JPEG)?",
                                                                                                    "time_to_show": "0",
                                                                                                    "jump_to_key": "upload_photo_btn4",
                                                                                                    "hide_waves_timeout": "0"
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                },
                                                                                "button2": {
                                                                                    "text": "CONTINUE",
                                                                                    "response": {
                                                                                        "0": {
                                                                                            "key": "message_schedule_after_photo",
                                                                                            "direction": "1",
                                                                                            "type": "message",
                                                                                            "text": "Great. The next step is to schedule a call with the Worthy team to discuss selling options for your valuables.",
                                                                                            "time_to_show": "1000",
                                                                                            "hide_waves_timeout": "0"
                                                                                        },
                                                                                        "1": {
                                                                                            "key": "message_schedule_without_photo",
                                                                                            "direction": "1",
                                                                                            "type": "message",
                                                                                            "text": "When are you available to talk?",
                                                                                            "time_to_show": "1000"
                                                                                        },
                                                                                        "2": {
                                                                                            "key": "schedule_appointment_time",
                                                                                            "direction": "0",
                                                                                            "type": "schedule_appointment",
                                                                                            "text": "Select a good time for a call",
                                                                                            "time_to_show": "1000",
                                                                                            "response_other_day": {
                                                                                                "0": {
                                                                                                    "key": "message_change_day_selection",
                                                                                                    "direction": "2",
                                                                                                    "type": "message",
                                                                                                    "text": "Call me #{selected_day}."
                                                                                                },
                                                                                                "1": {
                                                                                                    "key": "message_change_day_selection",
                                                                                                    "direction": "1",
                                                                                                    "type": "message",
                                                                                                    "text": "Sure, what time #{selected_day} works for you?",
                                                                                                    "jumpTo": "schedule_appointment_time"
                                                                                                }
                                                                                            },
                                                                                            "response_time_selected": {
                                                                                                "0": {
                                                                                                    "key": "message_schedule_appointment_success",
                                                                                                    "direction": "2",
                                                                                                    "type": "message",
                                                                                                    "text": "#{selected_time_day_hour} #{timezone} is great.",
                                                                                                    "time_to_show": "3000"
                                                                                                },
                                                                                                "1": {
                                                                                                    "key": "schedule_appointment",
                                                                                                    "direction": "1",
                                                                                                    "type": "method",
                                                                                                    "method": "schedule_appointment",
                                                                                                    "success": {
                                                                                                        "0": {
                                                                                                            "key": "message_schedule_appointment_all_set",
                                                                                                            "direction": "1",
                                                                                                            "type": "message",
                                                                                                            "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                                                                                            "time_to_show": "0",
                                                                                                            "hide_waves_timeout": "1800"
                                                                                                        },
                                                                                                        "1": {
                                                                                                            "key": "two_buttons_after_schedule",
                                                                                                            "direction": "0",
                                                                                                            "type": "two_buttons",
                                                                                                            "button1": {
                                                                                                                "text": "CHANGE PHONE NUMBER",
                                                                                                                "response": {
                                                                                                                    "0": {
                                                                                                                        "key": "message_change_phone_selected",
                                                                                                                        "direction": "2",
                                                                                                                        "type": "message",
                                                                                                                        "text": "Call me at a different number."
                                                                                                                    },
                                                                                                                    "1": {
                                                                                                                        "key": "message_change_phone_response",
                                                                                                                        "direction": "1",
                                                                                                                        "type": "message",
                                                                                                                        "text": "No problem, where should we reach you?",
                                                                                                                        "time_to_show": "1800"
                                                                                                                    },
                                                                                                                    "2": {
                                                                                                                        "key": "input_phone",
                                                                                                                        "key_response": "message_phone_provided",
                                                                                                                        "direction": "0",
                                                                                                                        "type": "free_text_phone",
                                                                                                                        "text": "Enter phone",
                                                                                                                        "button_text": "OK",
                                                                                                                        "text_response": "Call me at #{new_phone}.",
                                                                                                                        "update_phone": "true"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            "button2": {
                                                                                                                "text": "DONE",
                                                                                                                "stopConversation": "true",
                                                                                                                "response": {
                                                                                                                    "0": {
                                                                                                                        "key": "message_schedule_appointment_done",
                                                                                                                        "direction": "2",
                                                                                                                        "type": "message",
                                                                                                                        "text": "Done.",
                                                                                                                        "time_to_show": "1800"
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        },
                                                                        "fail": {
                                                                            "0": {
                                                                                "key": "upload_error",
                                                                                "direction": "1",
                                                                                "type": "message",
                                                                                "text": "Oops, it seems like something went wrong. Would you please try uploading a new photo (either PNG or JPEG)?",
                                                                                "time_to_show": "0",
                                                                                "jump_to_key": "upload_photo_btn3",
                                                                                "hide_waves_timeout": "0"
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            "button2": {
                                                                "text": "CONTINUE",
                                                                "response": {
                                                                    "0": {
                                                                        "key": "message_schedule_after_photo",
                                                                        "direction": "1",
                                                                        "type": "message",
                                                                        "text": "Great. The next step is to schedule a call with the Worthy team to discuss selling options for your valuables.",
                                                                        "time_to_show": "1000",
                                                                        "hide_waves_timeout": "0"
                                                                    },
                                                                    "1": {
                                                                        "key": "message_schedule_without_photo",
                                                                        "direction": "1",
                                                                        "type": "message",
                                                                        "text": "When are you available to talk?",
                                                                        "time_to_show": "1000"
                                                                    },
                                                                    "2": {
                                                                        "key": "schedule_appointment_time",
                                                                        "direction": "0",
                                                                        "type": "schedule_appointment",
                                                                        "text": "Select a good time for a call",
                                                                        "time_to_show": "1000",
                                                                        "response_other_day": {
                                                                            "0": {
                                                                                "key": "message_change_day_selection",
                                                                                "direction": "2",
                                                                                "type": "message",
                                                                                "text": "Call me #{selected_day}."
                                                                            },
                                                                            "1": {
                                                                                "key": "message_change_day_selection",
                                                                                "direction": "1",
                                                                                "type": "message",
                                                                                "text": "Sure, what time #{selected_day} works for you?",
                                                                                "jumpTo": "schedule_appointment_time"
                                                                            }
                                                                        },
                                                                        "response_time_selected": {
                                                                            "0": {
                                                                                "key": "message_schedule_appointment_success",
                                                                                "direction": "2",
                                                                                "type": "message",
                                                                                "text": "#{selected_time_day_hour} #{timezone} is great.",
                                                                                "time_to_show": "3000"
                                                                            },
                                                                            "1": {
                                                                                "key": "schedule_appointment",
                                                                                "direction": "1",
                                                                                "type": "method",
                                                                                "method": "schedule_appointment",
                                                                                "success": {
                                                                                    "0": {
                                                                                        "key": "message_schedule_appointment_all_set",
                                                                                        "direction": "1",
                                                                                        "type": "message",
                                                                                        "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                                                                        "time_to_show": "0",
                                                                                        "hide_waves_timeout": "1800"
                                                                                    },
                                                                                    "1": {
                                                                                        "key": "two_buttons_after_schedule",
                                                                                        "direction": "0",
                                                                                        "type": "two_buttons",
                                                                                        "button1": {
                                                                                            "text": "CHANGE PHONE NUMBER",
                                                                                            "response": {
                                                                                                "0": {
                                                                                                    "key": "message_change_phone_selected",
                                                                                                    "direction": "2",
                                                                                                    "type": "message",
                                                                                                    "text": "Call me at a different number."
                                                                                                },
                                                                                                "1": {
                                                                                                    "key": "message_change_phone_response",
                                                                                                    "direction": "1",
                                                                                                    "type": "message",
                                                                                                    "text": "No problem, where should we reach you?",
                                                                                                    "time_to_show": "1800"
                                                                                                },
                                                                                                "2": {
                                                                                                    "key": "input_phone",
                                                                                                    "key_response": "message_phone_provided",
                                                                                                    "direction": "0",
                                                                                                    "type": "free_text_phone",
                                                                                                    "text": "Enter phone",
                                                                                                    "button_text": "OK",
                                                                                                    "text_response": "Call me at #{new_phone}.",
                                                                                                    "update_phone": "true"
                                                                                                }
                                                                                            }
                                                                                        },
                                                                                        "button2": {
                                                                                            "text": "DONE",
                                                                                            "stopConversation": "true",
                                                                                            "response": {
                                                                                                "0": {
                                                                                                    "key": "message_schedule_appointment_done",
                                                                                                    "direction": "2",
                                                                                                    "type": "message",
                                                                                                    "text": "Done.",
                                                                                                    "time_to_show": "1800"
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    },
                                                    "fail": {
                                                        "0": {
                                                            "key": "upload_error",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "Oops, it seems like something went wrong. Would you please try uploading a new photo (either PNG or JPEG)?",
                                                            "time_to_show": "0",
                                                            "jump_to_key": "upload_photo_btn2",
                                                            "hide_waves_timeout": "0"
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "button2": {
                                            "text": "CONTINUE",
                                            "response": {
                                                "0": {
                                                    "key": "message_schedule_after_photo",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "Great. The next step is to schedule a call with the Worthy team to discuss selling options for your valuables.",
                                                    "time_to_show": "1000",
                                                    "hide_waves_timeout": "0"
                                                },
                                                "1": {
                                                    "key": "message_schedule_without_photo",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "When are you available to talk?",
                                                    "time_to_show": "1000"
                                                },
                                                "2": {
                                                    "key": "schedule_appointment_time",
                                                    "direction": "0",
                                                    "type": "schedule_appointment",
                                                    "text": "Select a good time for a call",
                                                    "time_to_show": "1000",
                                                    "response_other_day": {
                                                        "0": {
                                                            "key": "message_change_day_selection",
                                                            "direction": "2",
                                                            "type": "message",
                                                            "text": "Call me #{selected_day}."
                                                        },
                                                        "1": {
                                                            "key": "message_change_day_selection",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "Sure, what time #{selected_day} works for you?",
                                                            "jumpTo": "schedule_appointment_time"
                                                        }
                                                    },
                                                    "response_time_selected": {
                                                        "0": {
                                                            "key": "message_schedule_appointment_success",
                                                            "direction": "2",
                                                            "type": "message",
                                                            "text": "#{selected_time_day_hour} #{timezone} is great.",
                                                            "time_to_show": "3000"
                                                        },
                                                        "1": {
                                                            "key": "schedule_appointment",
                                                            "direction": "1",
                                                            "type": "method",
                                                            "method": "schedule_appointment",
                                                            "success": {
                                                                "0": {
                                                                    "key": "message_schedule_appointment_all_set",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                                                    "time_to_show": "0",
                                                                    "hide_waves_timeout": "1800"
                                                                },
                                                                "1": {
                                                                    "key": "two_buttons_after_schedule",
                                                                    "direction": "0",
                                                                    "type": "two_buttons",
                                                                    "button1": {
                                                                        "text": "CHANGE PHONE NUMBER",
                                                                        "response": {
                                                                            "0": {
                                                                                "key": "message_change_phone_selected",
                                                                                "direction": "2",
                                                                                "type": "message",
                                                                                "text": "Call me at a different number."
                                                                            },
                                                                            "1": {
                                                                                "key": "message_change_phone_response",
                                                                                "direction": "1",
                                                                                "type": "message",
                                                                                "text": "No problem, where should we reach you?",
                                                                                "time_to_show": "1800"
                                                                            },
                                                                            "2": {
                                                                                "key": "input_phone",
                                                                                "key_response": "message_phone_provided",
                                                                                "direction": "0",
                                                                                "type": "free_text_phone",
                                                                                "text": "Enter phone",
                                                                                "button_text": "OK",
                                                                                "text_response": "Call me at #{new_phone}.",
                                                                                "update_phone": "true"
                                                                            }
                                                                        }
                                                                    },
                                                                    "button2": {
                                                                        "text": "DONE",
                                                                        "stopConversation": "true",
                                                                        "response": {
                                                                            "0": {
                                                                                "key": "message_schedule_appointment_done",
                                                                                "direction": "2",
                                                                                "type": "message",
                                                                                "text": "Done.",
                                                                                "time_to_show": "1800"
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                },
                                "fail": {
                                    "0": {
                                        "key": "upload_error",
                                        "direction": "1",
                                        "type": "message",
                                        "text": "Oops, it seems like something went wrong. Would you please try uploading a new photo (either PNG or JPEG)?",
                                        "time_to_show": "0",
                                        "jump_to_key": "upload_photo_btn",
                                        "hide_waves_timeout": "0"
                                    }
                                }
                            }
                        }
                    },
                    "1": {
                        "version": "2.2",
                        "showAvatar": "true",
                        "const_messages": {
                            "message_phone_change": {
                                "key": "message_phone_change",
                                "direction": "1",
                                "type": "message",
                                "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                "originalText": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_new_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                "time_to_show": "0",
                                "hide_waves_timeout": "1800"
                            }
                        },
                        "flow": {
                            "0": {
                                "key": "message_welcome_jewelry_box",
                                "direction": "1",
                                "type": "message",
                                "text": "Welcome back #{user_first_name} I’m Roy, Worthy’s Chief Gemologist. The next step is to schedule a call with the Worthy team to discuss selling options for your valuables.",
                                "time_to_show": "1000"
                            },
                            "1": {
                                "key": "message_welcome_jewelry_box2",
                                "direction": "1",
                                "type": "message",
                                "text": "When are you available to talk?",
                                "time_to_show": "2000"
                            },
                            "2": {
                                "key": "schedule_appointment_time",
                                "direction": "0",
                                "type": "schedule_appointment",
                                "text": "Select a good time for a call",
                                "time_to_show": "1000",
                                "response_other_day": {
                                    "0": {
                                        "key": "message_change_day_selection",
                                        "direction": "2",
                                        "type": "message",
                                        "text": "Call me #{selected_day}."
                                    },
                                    "1": {
                                        "key": "message_change_day_selection",
                                        "direction": "1",
                                        "type": "message",
                                        "text": "Sure, what time #{selected_day} works for you?",
                                        "jumpTo": "schedule_appointment_time"
                                    }
                                },
                                "response_time_selected": {
                                    "0": {
                                        "key": "message_schedule_appointment_success",
                                        "direction": "2",
                                        "type": "message",
                                        "text": "#{selected_time_day_hour} #{timezone} is great.",
                                        "time_to_show": "3000"
                                    },
                                    "1": {
                                        "key": "schedule_appointment",
                                        "direction": "1",
                                        "type": "method",
                                        "method": "schedule_appointment",
                                        "success": {
                                            "0": {
                                                "key": "message_schedule_appointment_all_set",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                                "time_to_show": "0",
                                                "hide_waves_timeout": "1800"
                                            },
                                            "1": {
                                                "key": "two_buttons_after_schedule",
                                                "direction": "0",
                                                "type": "two_buttons",
                                                "button1": {
                                                    "text": "CHANGE PHONE NUMBER",
                                                    "response": {
                                                        "0": {
                                                            "key": "message_change_phone_selected",
                                                            "direction": "2",
                                                            "type": "message",
                                                            "text": "Call me at a different number."
                                                        },
                                                        "1": {
                                                            "key": "message_change_phone_response",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "No problem, where should we reach you?",
                                                            "time_to_show": "1800"
                                                        },
                                                        "2": {
                                                            "key": "input_phone",
                                                            "key_response": "message_phone_provided",
                                                            "direction": "0",
                                                            "type": "free_text_phone",
                                                            "text": "Enter phone",
                                                            "button_text": "OK",
                                                            "text_response": "Call me at #{new_phone}.",
                                                            "update_phone": "true"
                                                        }
                                                    }
                                                },
                                                "button2": {
                                                    "text": "DONE",
                                                    "stopConversation": "true",
                                                    "response": {
                                                        "0": {
                                                            "key": "message_schedule_appointment_done",
                                                            "direction": "2",
                                                            "type": "message",
                                                            "text": "Done.",
                                                            "time_to_show": "1800"
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    "2": {
                        "version": "2.2",
                        "showAvatar": "true",
                        "const_messages": {
                            "message_phone_change": {
                                "key": "message_phone_change",
                                "direction": "1",
                                "type": "message",
                                "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                "originalText": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_new_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                "time_to_show": "0",
                                "hide_waves_timeout": "1800"
                            }
                        },
                        "flow": {
                            "0": {
                                "key": "message_welcome_rescheduled_jewelry_box",
                                "direction": "1",
                                "type": "message",
                                "text": "Welcome back #{user_first_name} this is Roy, Worthy’s Chief Gemologist.<br><br> One of our account executives is already scheduled to call you <b>#{new_selected_time_full} #{timezone}, at #{user_phone}</b>.",
                                "time_to_show": "1000"
                            },
                            "1": {
                                "key": "message_welcome_rescheduled_jewelry_box2",
                                "direction": "1",
                                "type": "message",
                                "text": "Does this still work for you?",
                                "time_to_show": "1000"
                            },
                            "2": {
                                "key": "two_buttons_reschedule",
                                "direction": "0",
                                "type": "two_buttons",
                                "button1": {
                                    "text": "YES, KEEP<br> APPOINTMENT",
                                    "response": {
                                        "0": {
                                            "key": "message_keep_appointment",
                                            "direction": "2",
                                            "type": "message",
                                            "text": "Yes, let's keep the appointment."
                                        },
                                        "1": {
                                            "key": "message_reschedule_appointment_all_set",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "All set. An account executive will call you <b>#{new_selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                            "time_to_show": "0",
                                            "hide_waves_timeout": "1800"
                                        },
                                        "2": {
                                            "key": "two_buttons_after_schedule",
                                            "direction": "0",
                                            "type": "two_buttons",
                                            "button1": {
                                                "text": "CHANGE PHONE NUMBER",
                                                "response": {
                                                    "0": {
                                                        "key": "message_change_phone_selected",
                                                        "direction": "2",
                                                        "type": "message",
                                                        "text": "Call me at a different number."
                                                    },
                                                    "1": {
                                                        "key": "message_change_phone_response",
                                                        "direction": "1",
                                                        "type": "message",
                                                        "text": "No problem, where should we reach you?",
                                                        "time_to_show": "1800"
                                                    },
                                                    "2": {
                                                        "key": "input_phone",
                                                        "key_response": "message_phone_provided",
                                                        "direction": "0",
                                                        "type": "free_text_phone",
                                                        "text": "Enter phone",
                                                        "button_text": "OK",
                                                        "text_response": "Call me at #{new_phone}.",
                                                        "update_phone": "true"
                                                    }
                                                }
                                            },
                                            "button2": {
                                                "text": "DONE",
                                                "stopConversation": "true",
                                                "response": {
                                                    "0": {
                                                        "key": "message_schedule_appointment_done",
                                                        "direction": "2",
                                                        "type": "message",
                                                        "text": "Done.",
                                                        "time_to_show": "1800"
                                                    }
                                                }
                                            }
                                        }
                                    }
                                },
                                "button2": {
                                    "text": "NO,<br> RESCHEDULE",
                                    "response": {
                                        "0": {
                                            "key": "message_no_reschedule",
                                            "direction": "2",
                                            "type": "message",
                                            "text": "Let's reschedule."
                                        },
                                        "1": {
                                            "key": "message_no_reschedule2",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "When are you available to talk?",
                                            "time_to_show": "2000"
                                        },
                                        "2": {
                                            "key": "schedule_appointment_time",
                                            "direction": "0",
                                            "type": "schedule_appointment",
                                            "text": "Select a good time for a call",
                                            "time_to_show": "1000",
                                            "response_other_day": {
                                                "0": {
                                                    "key": "message_change_day_selection",
                                                    "direction": "2",
                                                    "type": "message",
                                                    "text": "Call me #{selected_day}."
                                                },
                                                "1": {
                                                    "key": "message_change_day_selection",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "Sure, what time #{selected_day} works for you?",
                                                    "jumpTo": "schedule_appointment_time"
                                                }
                                            },
                                            "response_time_selected": {
                                                "0": {
                                                    "key": "message_schedule_appointment_success",
                                                    "direction": "2",
                                                    "type": "message",
                                                    "text": "#{selected_time_day_hour} #{timezone} is great.",
                                                    "time_to_show": "3000"
                                                },
                                                "1": {
                                                    "key": "schedule_appointment",
                                                    "direction": "1",
                                                    "type": "method",
                                                    "method": "schedule_appointment",
                                                    "success": {
                                                        "0": {
                                                            "key": "message_schedule_appointment_all_set",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                                            "time_to_show": "0",
                                                            "hide_waves_timeout": "1800"
                                                        },
                                                        "1": {
                                                            "key": "two_buttons_after_schedule",
                                                            "direction": "0",
                                                            "type": "two_buttons",
                                                            "button1": {
                                                                "text": "CHANGE PHONE NUMBER",
                                                                "response": {
                                                                    "0": {
                                                                        "key": "message_change_phone_selected",
                                                                        "direction": "2",
                                                                        "type": "message",
                                                                        "text": "Call me at a different number."
                                                                    },
                                                                    "1": {
                                                                        "key": "message_change_phone_response",
                                                                        "direction": "1",
                                                                        "type": "message",
                                                                        "text": "No problem, where should we reach you?",
                                                                        "time_to_show": "1800"
                                                                    },
                                                                    "2": {
                                                                        "key": "input_phone",
                                                                        "key_response": "message_phone_provided",
                                                                        "direction": "0",
                                                                        "type": "free_text_phone",
                                                                        "text": "Enter phone",
                                                                        "button_text": "OK",
                                                                        "text_response": "Call me at #{new_phone}.",
                                                                        "update_phone": "true"
                                                                    }
                                                                }
                                                            },
                                                            "button2": {
                                                                "text": "DONE",
                                                                "stopConversation": "true",
                                                                "response": {
                                                                    "0": {
                                                                        "key": "message_schedule_appointment_done",
                                                                        "direction": "2",
                                                                        "type": "message",
                                                                        "text": "Done.",
                                                                        "time_to_show": "1800"
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    "3": {
                        "version": "2.2",
                        "showAvatar": "true",
                        "const_messages": {
                            "message_phone_change": {
                                "key": "message_phone_change",
                                "direction": "1",
                                "type": "message",
                                "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                "originalText": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_new_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                "time_to_show": "0",
                                "hide_waves_timeout": "1800"
                            }
                        },
                        "flow": {
                            "0": {
                                "key": "message_welcome_rescheduled_jewelry_box",
                                "direction": "1",
                                "type": "message",
                                "text": "Welcome back #{user_first_name} this is Roy, Worthy’s Chief Gemologist.<br><br> One of our account executives is already scheduled to call you <b>#{new_selected_time_full} #{timezone}, at #{user_phone}</b>.",
                                "time_to_show": "1000"
                            },
                            "1": {
                                "key": "message_welcome_rescheduled_jewelry_box2",
                                "direction": "1",
                                "type": "message",
                                "text": "Does this still work for you?",
                                "time_to_show": "1000"
                            },
                            "2": {
                                "key": "two_buttons_reschedule",
                                "direction": "0",
                                "type": "two_buttons",
                                "button1": {
                                    "text": "YES, KEEP<br> APPOINTMENT",
                                    "response": {
                                        "0": {
                                            "key": "message_keep_appointment",
                                            "direction": "2",
                                            "type": "message",
                                            "text": "Yes, let's keep the appointment."
                                        },
                                        "1": {
                                            "key": "message_reschedule_appointment_all_set",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "All set. An account executive will call you <b>#{new_selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                            "time_to_show": "0",
                                            "hide_waves_timeout": "1800"
                                        },
                                        "2": {
                                            "key": "two_buttons_after_schedule",
                                            "direction": "0",
                                            "type": "two_buttons",
                                            "button1": {
                                                "text": "CHANGE PHONE NUMBER",
                                                "response": {
                                                    "0": {
                                                        "key": "message_change_phone_selected",
                                                        "direction": "2",
                                                        "type": "message",
                                                        "text": "Call me at a different number."
                                                    },
                                                    "1": {
                                                        "key": "message_change_phone_response",
                                                        "direction": "1",
                                                        "type": "message",
                                                        "text": "No problem, where should we reach you?",
                                                        "time_to_show": "1800"
                                                    },
                                                    "2": {
                                                        "key": "input_phone",
                                                        "key_response": "message_phone_provided",
                                                        "direction": "0",
                                                        "type": "free_text_phone",
                                                        "text": "Enter phone",
                                                        "button_text": "OK",
                                                        "text_response": "Call me at #{new_phone}.",
                                                        "update_phone": "true"
                                                    }
                                                }
                                            },
                                            "button2": {
                                                "text": "DONE",
                                                "stopConversation": "true",
                                                "response": {
                                                    "0": {
                                                        "key": "message_schedule_appointment_done",
                                                        "direction": "2",
                                                        "type": "message",
                                                        "text": "Done.",
                                                        "time_to_show": "1800"
                                                    }
                                                }
                                            }
                                        }
                                    }
                                },
                                "button2": {
                                    "text": "NO,<br> RESCHEDULE",
                                    "response": {
                                        "0": {
                                            "key": "message_no_reschedule",
                                            "direction": "2",
                                            "type": "message",
                                            "text": "Let's reschedule."
                                        },
                                        "1": {
                                            "key": "message_no_reschedule2",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "When are you available to talk?",
                                            "time_to_show": "2000"
                                        },
                                        "2": {
                                            "key": "schedule_appointment_time",
                                            "direction": "0",
                                            "type": "schedule_appointment",
                                            "text": "Select a good time for a call",
                                            "time_to_show": "1000",
                                            "response_other_day": {
                                                "0": {
                                                    "key": "message_change_day_selection",
                                                    "direction": "2",
                                                    "type": "message",
                                                    "text": "Call me #{selected_day}."
                                                },
                                                "1": {
                                                    "key": "message_change_day_selection",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "Sure, what time #{selected_day} works for you?",
                                                    "jumpTo": "schedule_appointment_time"
                                                }
                                            },
                                            "response_time_selected": {
                                                "0": {
                                                    "key": "message_schedule_appointment_success",
                                                    "direction": "2",
                                                    "type": "message",
                                                    "text": "#{selected_time_day_hour} #{timezone} is great.",
                                                    "time_to_show": "3000"
                                                },
                                                "1": {
                                                    "key": "schedule_appointment",
                                                    "direction": "1",
                                                    "type": "method",
                                                    "method": "schedule_appointment",
                                                    "success": {
                                                        "0": {
                                                            "key": "message_schedule_appointment_all_set",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                                            "time_to_show": "0",
                                                            "hide_waves_timeout": "1800"
                                                        },
                                                        "1": {
                                                            "key": "two_buttons_after_schedule",
                                                            "direction": "0",
                                                            "type": "two_buttons",
                                                            "button1": {
                                                                "text": "CHANGE PHONE NUMBER",
                                                                "response": {
                                                                    "0": {
                                                                        "key": "message_change_phone_selected",
                                                                        "direction": "2",
                                                                        "type": "message",
                                                                        "text": "Call me at a different number."
                                                                    },
                                                                    "1": {
                                                                        "key": "message_change_phone_response",
                                                                        "direction": "1",
                                                                        "type": "message",
                                                                        "text": "No problem, where should we reach you?",
                                                                        "time_to_show": "1800"
                                                                    },
                                                                    "2": {
                                                                        "key": "input_phone",
                                                                        "key_response": "message_phone_provided",
                                                                        "direction": "0",
                                                                        "type": "free_text_phone",
                                                                        "text": "Enter phone",
                                                                        "button_text": "OK",
                                                                        "text_response": "Call me at #{new_phone}.",
                                                                        "update_phone": "true"
                                                                    }
                                                                }
                                                            },
                                                            "button2": {
                                                                "text": "DONE",
                                                                "stopConversation": "true",
                                                                "response": {
                                                                    "0": {
                                                                        "key": "message_schedule_appointment_done",
                                                                        "direction": "2",
                                                                        "type": "message",
                                                                        "text": "Done.",
                                                                        "time_to_show": "1800"
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                "1": {
                    "0": {
                        "version": "2.3",
                        "const_messages": {
                            "message_phone_change": {
                                "key": "message_phone_change",
                                "direction": "1",
                                "type": "message",
                                "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                "originalText": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_new_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                "time_to_show": "0",
                                "hide_waves_timeout": "1800"
                            }
                        },
                        "flow": {
                            "0": {
                                "key": "message_welcome_photo_jewelry_box_flow0",
                                "direction": "1",
                                "type": "message",
                                "text": "Hi #{user_first_name}, I’m Roy, Worthy’s Chief Gemologist.",
                                "time_to_show": "1000"
                            },
                            "1": {
                                "key": "message_welcome_photo_jewelry_box2",
                                "direction": "1",
                                "type": "message",
                                "text": "To help us get a sense of the valuables you're interested in selling, and to expedite your process, would you please upload a photo of them? You can take it with your phone.",
                                "time_to_show": "1000"
                            },
                            "2": {
                                "key": "upload_photo_btn",
                                "direction": "0",
                                "type": "add_photo_button_two",
                                "bottomText": "Uploading a photo should expedite the process",
                                "text": "Upload Photo",
                                "time_to_show": "1000",
                                "hide_waves_timeout": "0",
                                "button1": {
                                    "text": "UPLOAD </br>PHOTO",
                                    "response": {
                                        "0": {
                                            "key": "message_photo_being_uploaded",
                                            "direction": "2",
                                            "type": "photo_being_uploaded",
                                            "text": "",
                                            "time_to_show": "0",
                                            "hide_waves_timeout": "0"
                                        },
                                        "1": {
                                            "key": "upload_photo_method",
                                            "direction": "0",
                                            "type": "method",
                                            "method": "upload_photo",
                                            "time_to_show": "0",
                                            "hide_waves_timeout": "0",
                                            "add_key_on_fail": "true",
                                            "success": {
                                                "0": {
                                                    "key": "message_schedule_after_photo",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "Great. The next step is to schedule a call with the Worthy team to discuss selling options for your valuables.",
                                                    "time_to_show": "1000",
                                                    "hide_waves_timeout": "0"
                                                },
                                                "1": {
                                                    "key": "message_schedule_after_photo2",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "When are you available to talk?",
                                                    "time_to_show": "1000"
                                                },
                                                "2": {
                                                    "key": "schedule_appointment_time",
                                                    "direction": "0",
                                                    "type": "schedule_appointment",
                                                    "text": "Select a good time for a call",
                                                    "time_to_show": "1000",
                                                    "response_other_day": {
                                                        "0": {
                                                            "key": "message_change_day_selection",
                                                            "direction": "2",
                                                            "type": "message",
                                                            "text": "Call me #{selected_day}."
                                                        },
                                                        "1": {
                                                            "key": "message_change_day_selection",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "Sure, what time #{selected_day} works for you?",
                                                            "jumpTo": "schedule_appointment_time"
                                                        }
                                                    },
                                                    "response_time_selected": {
                                                        "0": {
                                                            "key": "message_schedule_appointment_success",
                                                            "direction": "2",
                                                            "type": "message",
                                                            "text": "#{selected_time_day_hour} #{timezone} is great.",
                                                            "time_to_show": "1000"
                                                        },
                                                        "1": {
                                                            "key": "schedule_appointment",
                                                            "direction": "1",
                                                            "type": "method",
                                                            "method": "schedule_appointment",
                                                            "success": {
                                                                "0": {
                                                                    "key": "message_schedule_appointment_all_set",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                                                    "time_to_show": "0",
                                                                    "hide_waves_timeout": "1800"
                                                                },
                                                                "1": {
                                                                    "key": "two_buttons_after_schedule",
                                                                    "direction": "0",
                                                                    "type": "two_buttons",
                                                                    "button1": {
                                                                        "text": "CHANGE PHONE NUMBER",
                                                                        "response": {
                                                                            "0": {
                                                                                "key": "message_change_phone_selected",
                                                                                "direction": "2",
                                                                                "type": "message",
                                                                                "text": "Call me at a different number."
                                                                            },
                                                                            "1": {
                                                                                "key": "message_change_phone_response",
                                                                                "direction": "1",
                                                                                "type": "message",
                                                                                "text": "No problem, where should we reach you?",
                                                                                "time_to_show": "1800"
                                                                            },
                                                                            "2": {
                                                                                "key": "input_phone",
                                                                                "key_response": "message_phone_provided",
                                                                                "direction": "0",
                                                                                "type": "free_text_phone",
                                                                                "text": "Enter phone",
                                                                                "button_text": "OK",
                                                                                "text_response": "Call me at #{new_phone}.",
                                                                                "update_phone": "true"
                                                                            }
                                                                        }
                                                                    },
                                                                    "button2": {
                                                                        "text": "DONE",
                                                                        "stopConversation": "true",
                                                                        "response": {
                                                                            "0": {
                                                                                "key": "message_schedule_appointment_done",
                                                                                "direction": "2",
                                                                                "type": "message",
                                                                                "text": "Done.",
                                                                                "time_to_show": "1800"
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            "fail": {
                                                "0": {
                                                    "key": "upload_error",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "Oops, it seems like something went wrong. Would you please try uploading a new photo (either PNG or JPEG)?",
                                                    "time_to_show": "0",
                                                    "jump_to_key": "upload_photo_btn",
                                                    "hide_waves_timeout": "0"
                                                }
                                            }
                                        }
                                    }
                                },
                                "button2": {
                                    "text": "SCHEDULE </br>CALL",
                                    "response": {
                                        "0": {
                                            "key": "message_schedule_without_photo",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "When are you available to talk?",
                                            "time_to_show": "1000"
                                        },
                                        "1": {
                                            "key": "schedule_appointment_time",
                                            "direction": "0",
                                            "type": "schedule_appointment",
                                            "text": "Select a good time for a call",
                                            "time_to_show": "1000",
                                            "response_other_day": {
                                                "0": {
                                                    "key": "message_change_day_selection",
                                                    "direction": "2",
                                                    "type": "message",
                                                    "text": "Call me #{selected_day}."
                                                },
                                                "1": {
                                                    "key": "message_change_day_selection",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "Sure, what time #{selected_day} works for you?",
                                                    "jumpTo": "schedule_appointment_time"
                                                }
                                            },
                                            "response_time_selected": {
                                                "0": {
                                                    "key": "message_schedule_appointment_success",
                                                    "direction": "2",
                                                    "type": "message",
                                                    "text": "#{selected_time_day_hour} #{timezone} is great.",
                                                    "time_to_show": "3000"
                                                },
                                                "1": {
                                                    "key": "schedule_appointment",
                                                    "direction": "1",
                                                    "type": "method",
                                                    "method": "schedule_appointment",
                                                    "success": {
                                                        "0": {
                                                            "key": "message_schedule_appointment_all_set",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                                            "time_to_show": "0",
                                                            "hide_waves_timeout": "1800"
                                                        },
                                                        "1": {
                                                            "key": "two_buttons_after_schedule",
                                                            "direction": "0",
                                                            "type": "two_buttons",
                                                            "button1": {
                                                                "text": "CHANGE PHONE NUMBER",
                                                                "response": {
                                                                    "0": {
                                                                        "key": "message_change_phone_selected",
                                                                        "direction": "2",
                                                                        "type": "message",
                                                                        "text": "Call me at a different number."
                                                                    },
                                                                    "1": {
                                                                        "key": "message_change_phone_response",
                                                                        "direction": "1",
                                                                        "type": "message",
                                                                        "text": "No problem, where should we reach you?",
                                                                        "time_to_show": "1800"
                                                                    },
                                                                    "2": {
                                                                        "key": "input_phone",
                                                                        "key_response": "message_phone_provided",
                                                                        "direction": "0",
                                                                        "type": "free_text_phone",
                                                                        "text": "Enter phone",
                                                                        "button_text": "OK",
                                                                        "text_response": "Call me at #{new_phone}.",
                                                                        "update_phone": "true"
                                                                    }
                                                                }
                                                            },
                                                            "button2": {
                                                                "text": "DONE",
                                                                "stopConversation": "true",
                                                                "response": {
                                                                    "0": {
                                                                        "key": "message_schedule_appointment_done",
                                                                        "direction": "2",
                                                                        "type": "message",
                                                                        "text": "Done.",
                                                                        "time_to_show": "1800"
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    "1": {
                        "version": "2.3",
                        "showAvatar": "true",
                        "const_messages": {
                            "message_phone_change": {
                                "key": "message_phone_change",
                                "direction": "1",
                                "type": "message",
                                "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                "originalText": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_new_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                "time_to_show": "0",
                                "hide_waves_timeout": "1800"
                            }
                        },
                        "flow": {
                            "0": {
                                "key": "message_welcome_jewelry_box_flow1",
                                "direction": "1",
                                "type": "message",
                                "text": "Welcome back #{user_first_name} I’m Roy, Worthy’s Chief Gemologist. The next step is to schedule a call with the Worthy team to discuss selling options for your valuables.",
                                "time_to_show": "1000"
                            },
                            "1": {
                                "key": "message_welcome_jewelry_box2",
                                "direction": "1",
                                "type": "message",
                                "text": "When are you available to talk?",
                                "time_to_show": "2000"
                            },
                            "2": {
                                "key": "schedule_appointment_time",
                                "direction": "0",
                                "type": "schedule_appointment",
                                "text": "Select a good time for a call",
                                "time_to_show": "1000",
                                "response_other_day": {
                                    "0": {
                                        "key": "message_change_day_selection",
                                        "direction": "2",
                                        "type": "message",
                                        "text": "Call me #{selected_day}."
                                    },
                                    "1": {
                                        "key": "message_change_day_selection",
                                        "direction": "1",
                                        "type": "message",
                                        "text": "Sure, what time #{selected_day} works for you?",
                                        "jumpTo": "schedule_appointment_time"
                                    }
                                },
                                "response_time_selected": {
                                    "0": {
                                        "key": "message_schedule_appointment_success",
                                        "direction": "2",
                                        "type": "message",
                                        "text": "#{selected_time_day_hour} #{timezone} is great.",
                                        "time_to_show": "3000"
                                    },
                                    "1": {
                                        "key": "schedule_appointment",
                                        "direction": "1",
                                        "type": "method",
                                        "method": "schedule_appointment",
                                        "success": {
                                            "0": {
                                                "key": "message_schedule_appointment_all_set",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                                "time_to_show": "0",
                                                "hide_waves_timeout": "1800"
                                            },
                                            "1": {
                                                "key": "two_buttons_after_schedule",
                                                "direction": "0",
                                                "type": "two_buttons",
                                                "button1": {
                                                    "text": "CHANGE PHONE NUMBER",
                                                    "response": {
                                                        "0": {
                                                            "key": "message_change_phone_selected",
                                                            "direction": "2",
                                                            "type": "message",
                                                            "text": "Call me at a different number."
                                                        },
                                                        "1": {
                                                            "key": "message_change_phone_response",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "No problem, where should we reach you?",
                                                            "time_to_show": "1800"
                                                        },
                                                        "2": {
                                                            "key": "input_phone",
                                                            "key_response": "message_phone_provided",
                                                            "direction": "0",
                                                            "type": "free_text_phone",
                                                            "text": "Enter phone",
                                                            "button_text": "OK",
                                                            "text_response": "Call me at #{new_phone}.",
                                                            "update_phone": "true"
                                                        }
                                                    }
                                                },
                                                "button2": {
                                                    "text": "DONE",
                                                    "stopConversation": "true",
                                                    "response": {
                                                        "0": {
                                                            "key": "message_schedule_appointment_done",
                                                            "direction": "2",
                                                            "type": "message",
                                                            "text": "Done.",
                                                            "time_to_show": "1800"
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    "2": {
                        "version": "2.3",
                        "showAvatar": "true",
                        "const_messages": {
                            "message_phone_change": {
                                "key": "message_phone_change",
                                "direction": "1",
                                "type": "message",
                                "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                "originalText": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_new_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                "time_to_show": "0",
                                "hide_waves_timeout": "1800"
                            }
                        },
                        "flow": {
                            "0": {
                                "key": "message_welcome_rescheduled_jewelry_box_flow2",
                                "direction": "1",
                                "type": "message",
                                "text": "Welcome back #{user_first_name} this is Roy, Worthy’s Chief Gemologist.<br><br> One of our account executives is already scheduled to call you <b>#{new_selected_time_full} #{timezone}, at #{user_phone}</b>.",
                                "time_to_show": "1000"
                            },
                            "1": {
                                "key": "message_welcome_rescheduled_jewelry_box2",
                                "direction": "1",
                                "type": "message",
                                "text": "Does this still work for you?",
                                "time_to_show": "1000"
                            },
                            "2": {
                                "key": "two_buttons_reschedule",
                                "direction": "0",
                                "type": "two_buttons",
                                "button1": {
                                    "text": "YES, KEEP<br> APPOINTMENT",
                                    "response": {
                                        "0": {
                                            "key": "message_keep_appointment",
                                            "direction": "2",
                                            "type": "message",
                                            "text": "Yes, let's keep the appointment."
                                        },
                                        "1": {
                                            "key": "message_reschedule_appointment_all_set",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "All set. An account executive will call you <b>#{new_selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                            "time_to_show": "0",
                                            "hide_waves_timeout": "1800"
                                        },
                                        "2": {
                                            "key": "two_buttons_after_schedule",
                                            "direction": "0",
                                            "type": "two_buttons",
                                            "button1": {
                                                "text": "CHANGE PHONE NUMBER",
                                                "response": {
                                                    "0": {
                                                        "key": "message_change_phone_selected",
                                                        "direction": "2",
                                                        "type": "message",
                                                        "text": "Call me at a different number."
                                                    },
                                                    "1": {
                                                        "key": "message_change_phone_response",
                                                        "direction": "1",
                                                        "type": "message",
                                                        "text": "No problem, where should we reach you?",
                                                        "time_to_show": "1800"
                                                    },
                                                    "2": {
                                                        "key": "input_phone",
                                                        "key_response": "message_phone_provided",
                                                        "direction": "0",
                                                        "type": "free_text_phone",
                                                        "text": "Enter phone",
                                                        "button_text": "OK",
                                                        "text_response": "Call me at #{new_phone}.",
                                                        "update_phone": "true"
                                                    }
                                                }
                                            },
                                            "button2": {
                                                "text": "DONE",
                                                "stopConversation": "true",
                                                "response": {
                                                    "0": {
                                                        "key": "message_schedule_appointment_done",
                                                        "direction": "2",
                                                        "type": "message",
                                                        "text": "Done.",
                                                        "time_to_show": "1800"
                                                    }
                                                }
                                            }
                                        }
                                    }
                                },
                                "button2": {
                                    "text": "NO,<br> RESCHEDULE",
                                    "response": {
                                        "0": {
                                            "key": "message_no_reschedule",
                                            "direction": "2",
                                            "type": "message",
                                            "text": "Let's reschedule."
                                        },
                                        "1": {
                                            "key": "message_no_reschedule2",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "When are you available to talk?",
                                            "time_to_show": "2000"
                                        },
                                        "2": {
                                            "key": "schedule_appointment_time",
                                            "direction": "0",
                                            "type": "schedule_appointment",
                                            "text": "Select a good time for a call",
                                            "time_to_show": "1000",
                                            "response_other_day": {
                                                "0": {
                                                    "key": "message_change_day_selection",
                                                    "direction": "2",
                                                    "type": "message",
                                                    "text": "Call me #{selected_day}."
                                                },
                                                "1": {
                                                    "key": "message_change_day_selection",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "Sure, what time #{selected_day} works for you?",
                                                    "jumpTo": "schedule_appointment_time"
                                                }
                                            },
                                            "response_time_selected": {
                                                "0": {
                                                    "key": "message_schedule_appointment_success",
                                                    "direction": "2",
                                                    "type": "message",
                                                    "text": "#{selected_time_day_hour} #{timezone} is great.",
                                                    "time_to_show": "3000"
                                                },
                                                "1": {
                                                    "key": "schedule_appointment",
                                                    "direction": "1",
                                                    "type": "method",
                                                    "method": "schedule_appointment",
                                                    "success": {
                                                        "0": {
                                                            "key": "message_schedule_appointment_all_set",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                                            "time_to_show": "0",
                                                            "hide_waves_timeout": "1800"
                                                        },
                                                        "1": {
                                                            "key": "two_buttons_after_schedule",
                                                            "direction": "0",
                                                            "type": "two_buttons",
                                                            "button1": {
                                                                "text": "CHANGE PHONE NUMBER",
                                                                "response": {
                                                                    "0": {
                                                                        "key": "message_change_phone_selected",
                                                                        "direction": "2",
                                                                        "type": "message",
                                                                        "text": "Call me at a different number."
                                                                    },
                                                                    "1": {
                                                                        "key": "message_change_phone_response",
                                                                        "direction": "1",
                                                                        "type": "message",
                                                                        "text": "No problem, where should we reach you?",
                                                                        "time_to_show": "1800"
                                                                    },
                                                                    "2": {
                                                                        "key": "input_phone",
                                                                        "key_response": "message_phone_provided",
                                                                        "direction": "0",
                                                                        "type": "free_text_phone",
                                                                        "text": "Enter phone",
                                                                        "button_text": "OK",
                                                                        "text_response": "Call me at #{new_phone}.",
                                                                        "update_phone": "true"
                                                                    }
                                                                }
                                                            },
                                                            "button2": {
                                                                "text": "DONE",
                                                                "stopConversation": "true",
                                                                "response": {
                                                                    "0": {
                                                                        "key": "message_schedule_appointment_done",
                                                                        "direction": "2",
                                                                        "type": "message",
                                                                        "text": "Done.",
                                                                        "time_to_show": "1800"
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    "3": {
                        "version": "2.3",
                        "const_messages": {
                            "message_phone_change": {
                                "key": "message_phone_change",
                                "direction": "1",
                                "type": "message",
                                "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                "originalText": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_new_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                "time_to_show": "0",
                                "hide_waves_timeout": "1800"
                            }
                        },
                        "flow": {
                            "0": {
                                "key": "message_welcome_photo_jewelry_box_flow3",
                                "direction": "1",
                                "type": "message",
                                "text": "Hi #{user_first_name}, I’m Roy, Worthy’s Chief Gemologist.",
                                "time_to_show": "1000"
                            },
                            "1": {
                                "key": "message_welcome_photo_jewelry_box2",
                                "direction": "1",
                                "type": "message",
                                "text": "To help us get a sense of the valuables you're interested in selling, and to expedite your process, would you please upload a photo of them? You can take it with your phone.",
                                "time_to_show": "1000"
                            },
                            "2": {
                                "key": "upload_photo_btn",
                                "direction": "0",
                                "type": "add_photo_button_two",
                                "bottomText": "Uploading a photo should expedite the process",
                                "text": "Upload Photo",
                                "time_to_show": "1000",
                                "hide_waves_timeout": "0",
                                "button1": {
                                    "text": "UPLOAD </br>PHOTO",
                                    "response": {
                                        "0": {
                                            "key": "message_photo_being_uploaded",
                                            "direction": "2",
                                            "type": "photo_being_uploaded",
                                            "text": "",
                                            "time_to_show": "0",
                                            "hide_waves_timeout": "0"
                                        },
                                        "1": {
                                            "key": "upload_photo_method",
                                            "direction": "0",
                                            "type": "method",
                                            "method": "upload_photo",
                                            "time_to_show": "0",
                                            "hide_waves_timeout": "0",
                                            "add_key_on_fail": "true",
                                            "success": {
                                                "0": {
                                                    "key": "message_welcome_rescheduled_jewelry_box",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "Great! One of our account executives is already scheduled to call you <b>#{new_selected_time_full} #{timezone}, at #{user_phone}</b>.",
                                                    "time_to_show": "1000"
                                                },
                                                "1": {
                                                    "key": "message_welcome_rescheduled_jewelry_box2",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "Does this still work for you?",
                                                    "time_to_show": "1000"
                                                },
                                                "2": {
                                                    "key": "two_buttons_reschedule",
                                                    "direction": "0",
                                                    "type": "two_buttons",
                                                    "button1": {
                                                        "text": "YES, KEEP<br> APPOINTMENT",
                                                        "response": {
                                                            "0": {
                                                                "key": "message_keep_appointment",
                                                                "direction": "2",
                                                                "type": "message",
                                                                "text": "Yes, let's keep the appointment."
                                                            },
                                                            "1": {
                                                                "key": "message_reschedule_appointment_all_set",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "All set. An account executive will call you <b>#{new_selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                                                "time_to_show": "0",
                                                                "hide_waves_timeout": "1800"
                                                            },
                                                            "2": {
                                                                "key": "two_buttons_after_schedule",
                                                                "direction": "0",
                                                                "type": "two_buttons",
                                                                "button1": {
                                                                    "text": "CHANGE PHONE NUMBER",
                                                                    "response": {
                                                                        "0": {
                                                                            "key": "message_change_phone_selected",
                                                                            "direction": "2",
                                                                            "type": "message",
                                                                            "text": "Call me at a different number."
                                                                        },
                                                                        "1": {
                                                                            "key": "message_change_phone_response",
                                                                            "direction": "1",
                                                                            "type": "message",
                                                                            "text": "No problem, where should we reach you?",
                                                                            "time_to_show": "1800"
                                                                        },
                                                                        "2": {
                                                                            "key": "input_phone",
                                                                            "key_response": "message_phone_provided",
                                                                            "direction": "0",
                                                                            "type": "free_text_phone",
                                                                            "text": "Enter phone",
                                                                            "button_text": "OK",
                                                                            "text_response": "Call me at #{new_phone}.",
                                                                            "update_phone": "true"
                                                                        }
                                                                    }
                                                                },
                                                                "button2": {
                                                                    "text": "DONE",
                                                                    "stopConversation": "true",
                                                                    "response": {
                                                                        "0": {
                                                                            "key": "message_schedule_appointment_done",
                                                                            "direction": "2",
                                                                            "type": "message",
                                                                            "text": "Done.",
                                                                            "time_to_show": "1800"
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    },
                                                    "button2": {
                                                        "text": "NO,<br> RESCHEDULE",
                                                        "response": {
                                                            "0": {
                                                                "key": "message_no_reschedule",
                                                                "direction": "2",
                                                                "type": "message",
                                                                "text": "Let's reschedule."
                                                            },
                                                            "1": {
                                                                "key": "message_no_reschedule2",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "When are you available to talk?",
                                                                "time_to_show": "2000"
                                                            },
                                                            "2": {
                                                                "key": "schedule_appointment_time",
                                                                "direction": "0",
                                                                "type": "schedule_appointment",
                                                                "text": "Select a good time for a call",
                                                                "time_to_show": "1000",
                                                                "response_other_day": {
                                                                    "0": {
                                                                        "key": "message_change_day_selection",
                                                                        "direction": "2",
                                                                        "type": "message",
                                                                        "text": "Call me #{selected_day}."
                                                                    },
                                                                    "1": {
                                                                        "key": "message_change_day_selection",
                                                                        "direction": "1",
                                                                        "type": "message",
                                                                        "text": "Sure, what time #{selected_day} works for you?",
                                                                        "jumpTo": "schedule_appointment_time"
                                                                    }
                                                                },
                                                                "response_time_selected": {
                                                                    "0": {
                                                                        "key": "message_schedule_appointment_success",
                                                                        "direction": "2",
                                                                        "type": "message",
                                                                        "text": "#{selected_time_day_hour} #{timezone} is great.",
                                                                        "time_to_show": "3000"
                                                                    },
                                                                    "1": {
                                                                        "key": "schedule_appointment",
                                                                        "direction": "1",
                                                                        "type": "method",
                                                                        "method": "schedule_appointment",
                                                                        "success": {
                                                                            "0": {
                                                                                "key": "message_schedule_appointment_all_set",
                                                                                "direction": "1",
                                                                                "type": "message",
                                                                                "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                                                                "time_to_show": "0",
                                                                                "hide_waves_timeout": "1800"
                                                                            },
                                                                            "1": {
                                                                                "key": "two_buttons_after_schedule",
                                                                                "direction": "0",
                                                                                "type": "two_buttons",
                                                                                "button1": {
                                                                                    "text": "CHANGE PHONE NUMBER",
                                                                                    "response": {
                                                                                        "0": {
                                                                                            "key": "message_change_phone_selected",
                                                                                            "direction": "2",
                                                                                            "type": "message",
                                                                                            "text": "Call me at a different number."
                                                                                        },
                                                                                        "1": {
                                                                                            "key": "message_change_phone_response",
                                                                                            "direction": "1",
                                                                                            "type": "message",
                                                                                            "text": "No problem, where should we reach you?",
                                                                                            "time_to_show": "1800"
                                                                                        },
                                                                                        "2": {
                                                                                            "key": "input_phone",
                                                                                            "key_response": "message_phone_provided",
                                                                                            "direction": "0",
                                                                                            "type": "free_text_phone",
                                                                                            "text": "Enter phone",
                                                                                            "button_text": "OK",
                                                                                            "text_response": "Call me at #{new_phone}.",
                                                                                            "update_phone": "true"
                                                                                        }
                                                                                    }
                                                                                },
                                                                                "button2": {
                                                                                    "text": "DONE",
                                                                                    "stopConversation": "true",
                                                                                    "response": {
                                                                                        "0": {
                                                                                            "key": "message_schedule_appointment_done",
                                                                                            "direction": "2",
                                                                                            "type": "message",
                                                                                            "text": "Done.",
                                                                                            "time_to_show": "1800"
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            "fail": {
                                                "0": {
                                                    "key": "upload_error",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "Oops, it seems like something went wrong. Would you please try uploading a new photo (either PNG or JPEG)?",
                                                    "time_to_show": "0",
                                                    "jump_to_key": "upload_photo_btn",
                                                    "hide_waves_timeout": "0"
                                                }
                                            }
                                        }
                                    }
                                },
                                "button2": {
                                    "text": "RESCHEDULE </br>CALL",
                                    "response": {
                                        "0": {
                                            "key": "message_schedule_without_photo",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "One of our account executives is already scheduled to call you <b>#{new_selected_time_full} #{timezone}, at #{user_phone}</b>.",
                                            "time_to_show": "1000"
                                        },
                                        "1": {
                                            "key": "message_welcome_rescheduled_jewelry_box2",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "Does this still work for you?",
                                            "time_to_show": "1000"
                                        },
                                        "2": {
                                            "key": "two_buttons_reschedule",
                                            "direction": "0",
                                            "type": "two_buttons",
                                            "button1": {
                                                "text": "YES, KEEP<br> APPOINTMENT",
                                                "response": {
                                                    "0": {
                                                        "key": "message_keep_appointment",
                                                        "direction": "2",
                                                        "type": "message",
                                                        "text": "Yes, let's keep the appointment."
                                                    },
                                                    "1": {
                                                        "key": "message_reschedule_appointment_all_set",
                                                        "direction": "1",
                                                        "type": "message",
                                                        "text": "All set. An account executive will call you <b>#{new_selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                                        "time_to_show": "0",
                                                        "hide_waves_timeout": "1800"
                                                    },
                                                    "2": {
                                                        "key": "two_buttons_after_schedule",
                                                        "direction": "0",
                                                        "type": "two_buttons",
                                                        "button1": {
                                                            "text": "CHANGE PHONE NUMBER",
                                                            "response": {
                                                                "0": {
                                                                    "key": "message_change_phone_selected",
                                                                    "direction": "2",
                                                                    "type": "message",
                                                                    "text": "Call me at a different number."
                                                                },
                                                                "1": {
                                                                    "key": "message_change_phone_response",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "No problem, where should we reach you?",
                                                                    "time_to_show": "1800"
                                                                },
                                                                "2": {
                                                                    "key": "input_phone",
                                                                    "key_response": "message_phone_provided",
                                                                    "direction": "0",
                                                                    "type": "free_text_phone",
                                                                    "text": "Enter phone",
                                                                    "button_text": "OK",
                                                                    "text_response": "Call me at #{new_phone}.",
                                                                    "update_phone": "true"
                                                                }
                                                            }
                                                        },
                                                        "button2": {
                                                            "text": "DONE",
                                                            "stopConversation": "true",
                                                            "response": {
                                                                "0": {
                                                                    "key": "message_schedule_appointment_done",
                                                                    "direction": "2",
                                                                    "type": "message",
                                                                    "text": "Done.",
                                                                    "time_to_show": "1800"
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            "button2": {
                                                "text": "NO,<br> RESCHEDULE",
                                                "response": {
                                                    "0": {
                                                        "key": "message_no_reschedule",
                                                        "direction": "2",
                                                        "type": "message",
                                                        "text": "Let's reschedule."
                                                    },
                                                    "1": {
                                                        "key": "message_no_reschedule2",
                                                        "direction": "1",
                                                        "type": "message",
                                                        "text": "When are you available to talk?",
                                                        "time_to_show": "2000"
                                                    },
                                                    "2": {
                                                        "key": "schedule_appointment_time",
                                                        "direction": "0",
                                                        "type": "schedule_appointment",
                                                        "text": "Select a good time for a call",
                                                        "time_to_show": "1000",
                                                        "response_other_day": {
                                                            "0": {
                                                                "key": "message_change_day_selection",
                                                                "direction": "2",
                                                                "type": "message",
                                                                "text": "Call me #{selected_day}."
                                                            },
                                                            "1": {
                                                                "key": "message_change_day_selection",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "Sure, what time #{selected_day} works for you?",
                                                                "jumpTo": "schedule_appointment_time"
                                                            }
                                                        },
                                                        "response_time_selected": {
                                                            "0": {
                                                                "key": "message_schedule_appointment_success",
                                                                "direction": "2",
                                                                "type": "message",
                                                                "text": "#{selected_time_day_hour} #{timezone} is great.",
                                                                "time_to_show": "3000"
                                                            },
                                                            "1": {
                                                                "key": "schedule_appointment",
                                                                "direction": "1",
                                                                "type": "method",
                                                                "method": "schedule_appointment",
                                                                "success": {
                                                                    "0": {
                                                                        "key": "message_schedule_appointment_all_set",
                                                                        "direction": "1",
                                                                        "type": "message",
                                                                        "text": "All set. An account executive will call you <b>#{selected_time_full} #{timezone}, at #{user_phone}</b>.<br><br>Please expect a call from 1-888-222-0208.",
                                                                        "time_to_show": "0",
                                                                        "hide_waves_timeout": "1800"
                                                                    },
                                                                    "1": {
                                                                        "key": "two_buttons_after_schedule",
                                                                        "direction": "0",
                                                                        "type": "two_buttons",
                                                                        "button1": {
                                                                            "text": "CHANGE PHONE NUMBER",
                                                                            "response": {
                                                                                "0": {
                                                                                    "key": "message_change_phone_selected",
                                                                                    "direction": "2",
                                                                                    "type": "message",
                                                                                    "text": "Call me at a different number."
                                                                                },
                                                                                "1": {
                                                                                    "key": "message_change_phone_response",
                                                                                    "direction": "1",
                                                                                    "type": "message",
                                                                                    "text": "No problem, where should we reach you?",
                                                                                    "time_to_show": "1800"
                                                                                },
                                                                                "2": {
                                                                                    "key": "input_phone",
                                                                                    "key_response": "message_phone_provided",
                                                                                    "direction": "0",
                                                                                    "type": "free_text_phone",
                                                                                    "text": "Enter phone",
                                                                                    "button_text": "OK",
                                                                                    "text_response": "Call me at #{new_phone}.",
                                                                                    "update_phone": "true"
                                                                                }
                                                                            }
                                                                        },
                                                                        "button2": {
                                                                            "text": "DONE",
                                                                            "stopConversation": "true",
                                                                            "response": {
                                                                                "0": {
                                                                                    "key": "message_schedule_appointment_done",
                                                                                    "direction": "2",
                                                                                    "type": "message",
                                                                                    "text": "Done.",
                                                                                    "time_to_show": "1800"
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "watch": {
                "0": {
                    "version": "1.0",
                    "showAvatar": "true",
                    "flow": {
                        "0": {
                            "key": "message_welcome",
                            "direction": "1",
                            "type": "message",
                            "text": "Hi #{user_first_name}, I'm #{account_manager_name}.",
                            "time_to_show": "0",
                            "hide_waves_timeout": "0"
                        },
                        "1": {
                            "key": "message_welcome_photo_request",
                            "direction": "1",
                            "type": "message",
                            "text": "To get a better understanding of your #{watch_brand} #{watch_model} watch,<br>please upload a photo.",
                            "time_to_show": "0",
                            "hide_waves_timeout": "0"
                        },
                        "2": {
                            "key": "upload_photo_btn",
                            "direction": "0",
                            "type": "add_photo_button",
                            "text": "Upload Photo",
                            "time_to_show": "1000",
                            "hide_waves_timeout": "0",
                            "response": {
                                "key": "message_photo_being_uploaded",
                                "direction": "2",
                                "type": "photo_being_uploaded",
                                "text": "photo is being uploaded",
                                "time_to_show": "0",
                                "hide_waves_timeout": "0"
                            }
                        },
                        "3": {
                            "key": "upload_photo_method",
                            "direction": "0",
                            "type": "method",
                            "method": "upload_photo",
                            "time_to_show": "0",
                            "text": "upload photo method called",
                            "hide_waves_timeout": "0",
                            "success": {
                                "0": {
                                    "key": "message_all_set",
                                    "direction": "1",
                                    "type": "message",
                                    "text": "Great. We'll be in touch as<br>soon as your description<br>has been fully reviewed.<br><br>Please expect a call from<br> 1 (888) 222-0208.",
                                    "time_to_show": "1000",
                                    "hide_waves_timeout": "0"
                                }
                            },
                            "fail": {
                                "0": {
                                    "key": "upload_error",
                                    "direction": "1",
                                    "type": "message",
                                    "text": "Oops, it seems like something went wrong. Can you please try uploading again?",
                                    "time_to_show": "0",
                                    "jump_to_key": "upload_photo_btn",
                                    "hide_waves_timeout": "0"
                                }
                            }
                        }
                    }
                },
                "1": {
                    "version": "1.0",
                    "showAvatar": "true",
                    "flow": {
                        "0": {
                            "key": "message_welcome_back",
                            "direction": "1",
                            "type": "message",
                            "text": "Welcome back #{user_first_name}, I'm #{account_manager_name}.<br>We’ll be in touch as soon as your description has been fully reviewed.<br><br>Please expect a call from 1 (888) 222-0208.",
                            "time_to_show": "0",
                            "hide_waves_timeout": "0"
                        }
                    }
                }
            },
            "missingDetails": {
                "0": {
                    "version": "1",
                    "showAvatar": "true",
                    "const_messages": {
                        "message_address_change": {
                            "key": "message_address_change",
                            "direction": "2",
                            "type": "message",
                            "text": "Oops, I'd like to change the address.",
                            "response": {
                                "key": "message_enter_address_again",
                                "direction": "1",
                                "type": "message",
                                "text": "Sure, no problem. Please enter your address again.",
                                "time_to_show": "2000"
                            }
                        }
                    },
                    "flow": {
                        "0": {
                            "key": "message_welcome_similar_items",
                            "direction": "1",
                            "type": "message",
                            "text": "Hi #{user_first_name}, I'm #{account_manager_name}.<br><br>Thank you for considering us for the sale of your: <br><b>#{item_desc}</b>. <br><br> Based on the information you entered, your ring should do well on our marketplace.",
                            "time_to_show": "0",
                            "hide_waves_timeout": "0"
                        },
                        "1": {
                            "key": "message_welcome_similar_items_proceed",
                            "direction": "1",
                            "type": "message",
                            "text": "How would you like to proceed?",
                            "time_to_show": "0",
                            "hide_waves_timeout": "0"
                        },
                        "2": {
                            "key": "two_buttons_contact_ae",
                            "direction": "0",
                            "type": "two_buttons",
                            "button1": {
                                "text": "Talk to Account Executive",
                                "response": {
                                    "0": {
                                        "key": "message_contact_ae",
                                        "direction": "2",
                                        "type": "message",
                                        "text": "I’d like to talk to an Account Executive."
                                    },
                                    "1": {
                                        "key": "contact_ae_method",
                                        "direction": "0",
                                        "type": "method",
                                        "method": "contact_ae",
                                        "time_to_show": "0"
                                    },
                                    "2": {
                                        "key": "message_we_can_do_that",
                                        "direction": "1",
                                        "type": "message",
                                        "text": "We can do that!<br>An account executive will call you at #{user_phone}.<br><br>Expect a call from <b>1 (888) 222-0208</b>.",
                                        "time_to_show": "1800"
                                    },
                                    "3": {
                                        "key": "button_continue",
                                        "direction": "0",
                                        "type": "one_button",
                                        "text": "Continue Online",
                                        "response": {
                                            "key": "message_lets_continue",
                                            "direction": "2",
                                            "type": "message",
                                            "text": "Let's continue!"
                                        },
                                        "time_to_show": "1000"
                                    }
                                }
                            },
                            "button2": {
                                "text": "Continue Online",
                                "response": {
                                    "0": {
                                        "key": "message_lets_continue_online",
                                        "direction": "2",
                                        "type": "message",
                                        "text": "Let's continue!"
                                    }
                                }
                            }
                        },
                        "3": {
                            "key": "accept_sell_estimation_method",
                            "direction": "0",
                            "type": "method",
                            "method": "accept_sell_estimation",
                            "time_to_show": "0"
                        },
                        "4": {
                            "key": "message_gia",
                            "direction": "1",
                            "type": "message",
                            "text": "Our sellers get the most competitive offers because our buyers trust us.</br></br>To maintain that trust we inspect and authenticate each valuable.",
                            "ignore_time_to_show_other_state": "true",
                            "time_to_show": "4000"
                        },
                        "5": {
                            "key": "message_insurance",
                            "direction": "1",
                            "type": "message",
                            "text": "For authentication, your valuable will be shipped with FedEx and insured up to $100,000, both covered by Worthy.",
                            "ignore_time_to_show_other_state": "true",
                            "time_to_show": "3500"
                        },
                        "6": {
                            "key": "message_fedex_explain_last_name",
                            "direction": "1",
                            "type": "message",
                            "text": "To create your free Fedex label, we'll first need your last name",
                            "ignore_time_to_show_other_state": "true",
                            "time_to_show": "2500"
                        },
                        "7": {
                            "key": "request_last_name",
                            "direction": "0",
                            "key_response": "message_last_name_provided",
                            "type": "request_last_name",
                            "text": "Enter your last name",
                            "button_text": "Done",
                            "update_state": "last_name"
                        },
                        "8": {
                            "key": "message_fedex_explain",
                            "direction": "1",
                            "type": "message",
                            "text": "Great, thank you. Now we'll need your address, please enter it below",
                            "ignore_time_to_show_other_state": "true",
                            "time_to_show": "2500"
                        },
                        "9": {
                            "key": "input_google_maps",
                            "direction": "0",
                            "type": "google_mui_auto_complete",
                            "text": "Enter your address",
                            "map_name": "seller_location"
                        },
                        "10": {
                            "key": "message_got_address",
                            "direction": "1",
                            "type": "message",
                            "text": "I got it, thanks!<br>Is this an apartment or a suite?",
                            "time_to_show": "2500"
                        },
                        "11": {
                            "key": "two_buttons_address_2",
                            "direction": "0",
                            "type": "two_buttons",
                            "text": "1: Apartment/Suite, 2: Neither",
                            "button1": {
                                "text": "APARTMENT / SUITE",
                                "response": {
                                    "0": {
                                        "key": "message_apartment_suite_selected",
                                        "direction": "2",
                                        "type": "message",
                                        "text": "The address is an apartment / suite."
                                    },
                                    "1": {
                                        "key": "message_apartment_suite_request",
                                        "direction": "1",
                                        "type": "message",
                                        "text": "Great!<br>What's your apartment / suite number?",
                                        "time_to_show": "1800"
                                    },
                                    "2": {
                                        "key": "input_address_2",
                                        "key_response": "message_address_2_provided",
                                        "direction": "0",
                                        "type": "free_text",
                                        "text": "Enter apartment/suite number",
                                        "nothing": "It’s not an apartment / suite.",
                                        "update_state": "address2"
                                    }
                                }
                            },
                            "button2": {
                                "text": "NEITHER",
                                "response": {
                                    "0": {
                                        "key": "message_address_2_not_provided",
                                        "direction": "2",
                                        "type": "message",
                                        "text": "It’s not an apartment / suite.",
                                        "time_to_show": "1800"
                                    }
                                }
                            }
                        },
                        "12": {
                            "key": "generate_shipping_label_method",
                            "direction": "0",
                            "type": "method",
                            "method": "generate_shipping_label",
                            "time_to_show": "0"
                        },
                        "13": {
                            "key": "message_fedex_arrange_pickup",
                            "direction": "1",
                            "type": "message",
                            "text": "Ok, we partnered with Fedex to make shipping as easy as possible.",
                            "time_to_show": "2500"
                        },
                        "14": {
                            "key": "shipping_label_ready_method",
                            "direction": "0",
                            "type": "method",
                            "method": "shipping_label_ready",
                            "time_to_show": "0"
                        },
                        "15": {
                            "key": "has_available_pickup_slots",
                            "direction": "0",
                            "type": "method",
                            "method": "check_available_pickup_slots",
                            "time_to_show": "0",
                            "hide_waves_timeout": "0",
                            "has_slots": {
                                "0": {
                                    "key": "message_pick_up_time_works",
                                    "direction": "1",
                                    "type": "message",
                                    "text": "What pickup time slot works best for you?",
                                    "time_to_show": "0",
                                    "hide_waves_timeout": "0"
                                },
                                "1": {
                                    "key": "multiple_buttons_schedule_pickup",
                                    "direction": "0",
                                    "type": "schedule_pickup_time",
                                    "placeholder": "Select pickup time...",
                                    "later": {
                                        "text": "Later"
                                    },
                                    "other": {
                                        "text": "<div class=\"day\">OTHER</div> <div class=\"day\">PICKUP TIME</div>",
                                        "update_state": {
                                            "shipmentPreferences": {
                                                "type": "pickup",
                                                "text": "Seller asked for a different pick time options. please contact ASAP and set up a pickup time"
                                            }
                                        }
                                    },
                                    "stickyButtons": {
                                        "text": "<div class=\"day\">DROP IT OFF</div> <div class=\"day\">MYSELF</div>"
                                    },
                                    "fedex_arrange_response": {
                                        "0": {
                                            "key": "message_i_will_arrange_pickup",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "No problem, I’ll check with FedEx for you. It may take a few moments, please don’t close this window.",
                                            "time_to_show": "2000"
                                        },
                                        "1": {
                                            "key": "schedule_fedex_pickup_method",
                                            "direction": "0",
                                            "type": "method",
                                            "method": "schedule_fedex_pickup",
                                            "time_to_show": "0",
                                            "success": {
                                                "0": {
                                                    "key": "message_success_schedule_pickup",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "All done, please see the important packing instructions and pre paid shipping label that I've just emailed to you.<br><br> We also attached <b>Worthy’s Certificate of Property Insurance</b> for your reference. Call us anytime at <a href='tel: 18882220208'>1 (888) 222-0208 </a>"
                                                },
                                                "1": {
                                                    "key": "message_shipping_label_details",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "<b>Your pickup is confirmed for #{schedule_time_text} at #{schedule_pickup_address}</b><br><br>Phone: #{user_phone}<br>Email: #{user_email}<br>Insurance: up to $100,000",
                                                    "time_to_show": "3000"
                                                },
                                                "2": {
                                                    "key": "multiple_buttons_details_correction",
                                                    "direction": "0",
                                                    "type": "update_pickup_details",
                                                    "placeholder": "Need anything else?",
                                                    "buttons": {
                                                        "0": {
                                                            "label": "Done",
                                                            "action": "done",
                                                            "responseText": "Done.",
                                                            "followUpMessage": "update_details_done"
                                                        },
                                                        "1": {
                                                            "label": "Change time",
                                                            "action": "update_pickup_details_time",
                                                            "responseText": "I would like to change my pickup time.",
                                                            "followUpMessage": "update_details_change_time"
                                                        },
                                                        "2": {
                                                            "label": "Change address",
                                                            "action": "update_pickup_details_address",
                                                            "responseText": "I would like to change my pickup address.",
                                                            "followUpMessage": "update_details_action_required"
                                                        },
                                                        "3": {
                                                            "label": "Change email",
                                                            "action": "update_pickup_details_email",
                                                            "responseText": "I would like to change my email.",
                                                            "followUpMessage": "update_details_action_required"
                                                        },
                                                        "4": {
                                                            "label": "Change phone",
                                                            "action": "update_pickup_details_phone",
                                                            "responseText": "I would like to change my phone.",
                                                            "followUpMessage": "update_details_action_required"
                                                        },
                                                        "5": {
                                                            "label": "I have some questions, can we talk?",
                                                            "action": "update_pickup_details_learn_more",
                                                            "responseText": "I have some questions, can we talk?",
                                                            "followUpMessage": "update_details_action_required"
                                                        },
                                                        "6": {
                                                            "label": "Sell another jewelry piece",
                                                            "action": "update_pickup_details_sell_another",
                                                            "responseText": "I would like to sell another jewelry piece",
                                                            "followUpMessage": "update_details_sell_another_jewelry"
                                                        }
                                                    },
                                                    "update_pickup_details_response": {
                                                        "0": {
                                                            "key": "create_update_pickup_details_task",
                                                            "direction": "0",
                                                            "type": "method",
                                                            "method": "update_pickup_details",
                                                            "update_details_done": {
                                                                "0": {
                                                                    "key": "message_update_pickup_details_all_good",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "Great! While you’re getting ready to ship, check out<br><a href='https://www.worthy.com/about/reviews' class='our-reviews' target='_blank'>Our reviews</a>",
                                                                    "time_to_show": "0"
                                                                }
                                                            },
                                                            "update_details_all_good": {
                                                                "0": {
                                                                    "key": "message_update_pickup_details_all_good",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "Great, feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                                                    "time_to_show": "0"
                                                                }
                                                            },
                                                            "update_details_change_time": {
                                                                "0": {
                                                                    "key": "update_details_change_time",
                                                                    "direction": "0",
                                                                    "type": "method",
                                                                    "method": "update_details_change_time",
                                                                    "jump_to_key": "multiple_buttons_schedule_pickup",
                                                                    "message": {
                                                                        "key": "update_details_change_time_message",
                                                                        "direction": "1",
                                                                        "type": "message",
                                                                        "text": "Sure, no problem. I canceled your scheduled pickup.<br><br>Please select a new pickup time below.",
                                                                        "time_to_show": "0"
                                                                    }
                                                                }
                                                            },
                                                            "update_details_action_required": {
                                                                "0": {
                                                                    "key": "message_update_pickup_details_action_required",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "OK, we will contact you shortly.",
                                                                    "time_to_show": "0"
                                                                }
                                                            },
                                                            "update_details_sell_another_jewelry": {
                                                                "0": {
                                                                    "key": "message_update_pickup_details_sell_another_jewelry",
                                                                    "direction": "1",
                                                                    "type": "message",
                                                                    "text": "That's great! Just add it (and any others) to the box with your other valuable and send it in. We'll take care of it.",
                                                                    "time_to_show": "0"
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            "fail": {
                                                "0": {
                                                    "key": "message_fail_schedule_pickup",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "It looks like FedEx is unavailable right now.<br><br>I’ll try again later and contact you once I have your pickup confirmation."
                                                }
                                            }
                                        }
                                    },
                                    "fedex_more_slots": {
                                        "0": {
                                            "key": "message_schedule_pickup_other",
                                            "direction": "2",
                                            "type": "message",
                                            "text": "None of the time slots work for me. Could you show me more options?",
                                            "hide_waves_timeout": "1800"
                                        },
                                        "1": {
                                            "key": "message_i_will_back_to_you",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "No problem. I will get back to you to schedule a pickup time. Expect a call from <a href='tel: 18882220208'>1 (888) 222-0208</a>.",
                                            "time_to_show": "2000"
                                        },
                                        "2": {
                                            "key": "message_if_any_questions",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "Feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                            "time_to_show": "3000"
                                        },
                                        "3": {
                                            "key": "update_shipment_preferences_method",
                                            "direction": "0",
                                            "type": "method",
                                            "method": "update_shipment_preferences",
                                            "time_to_show": "0"
                                        }
                                    },
                                    "fedex_drop_off_locations": {
                                        "0": {
                                            "key": "message_schedule_pickup_drop_off",
                                            "direction": "2",
                                            "type": "message",
                                            "text": "I prefer to drop it off by myself",
                                            "hide_waves_timeout": "1800"
                                        },
                                        "1": {
                                            "key": "message_drop_off_locations",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "No problem, here are a few FedEx drop off locations next to your address.",
                                            "time_to_show": "2000"
                                        },
                                        "2": {
                                            "key": "update_drop_off_locations",
                                            "direction": "0",
                                            "type": "method",
                                            "method": "update_drop_off",
                                            "time_to_show": "0",
                                            "success": {
                                                "0": {
                                                    "key": "message_shipping_label_details",
                                                    "direction": "1",
                                                    "type": "message",
                                                    "text": "Please follow the important packing instructions I just emailed you at:<br><br><b>#{user_email}</b><br><br>The pre-paid shipping label is also enclosed in this email.",
                                                    "time_to_show": "0",
                                                    "hide_waves_timeout": "1800"
                                                }
                                            }
                                        },
                                        "3": {
                                            "key": "message_if_any_questions",
                                            "direction": "1",
                                            "type": "message",
                                            "text": "Feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                            "time_to_show": "3000"
                                        },
                                        "4": {
                                            "key": "multiple_buttons_details_correction",
                                            "direction": "0",
                                            "type": "update_drop_off_details",
                                            "placeholder": "Need anything else?",
                                            "buttons": {
                                                "0": {
                                                    "label": "Done",
                                                    "action": "done",
                                                    "responseText": "Done.",
                                                    "followUpMessage": "update_details_done"
                                                },
                                                "1": {
                                                    "label": "Change email",
                                                    "action": "update_drop_off_details_email",
                                                    "responseText": "I would like to change my email.",
                                                    "followUpMessage": "update_details_action_required"
                                                },
                                                "2": {
                                                    "label": "Change phone",
                                                    "action": "update_drop_off_details_phone",
                                                    "responseText": "I would like to change my phone.",
                                                    "followUpMessage": "update_details_action_required"
                                                },
                                                "3": {
                                                    "label": "I have some questions, can we talk?",
                                                    "action": "update_drop_off_details_learn_more",
                                                    "responseText": "I have some questions, can we talk?",
                                                    "followUpMessage": "update_details_action_required"
                                                },
                                                "4": {
                                                    "label": "Sell another jewelry piece",
                                                    "action": "update_drop_off_details_sell_another",
                                                    "responseText": "I would like to sell another jewelry piece",
                                                    "followUpMessage": "update_details_sell_another_jewelry"
                                                }
                                            },
                                            "update_drop_off_details_response": {
                                                "0": {
                                                    "key": "create_update_pickup_details_task",
                                                    "direction": "0",
                                                    "type": "method",
                                                    "method": "update_drop_off_details",
                                                    "update_details_done": {
                                                        "0": {
                                                            "key": "message_update_drop_off_details_all_good",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "Great! While you’re getting ready to ship, check out<br><a href='https://www.worthy.com/about/reviews' class='our-reviews' target='_blank'>Our reviews</a>",
                                                            "time_to_show": "0"
                                                        }
                                                    },
                                                    "update_details_action_required": {
                                                        "0": {
                                                            "key": "message_update_drop_off_details_action_required",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "OK, we will contact you shortly.",
                                                            "time_to_show": "0"
                                                        }
                                                    },
                                                    "update_details_sell_another_jewelry": {
                                                        "0": {
                                                            "key": "message_update_drop_off_details_sell_another_jewelry",
                                                            "direction": "1",
                                                            "type": "message",
                                                            "text": "That's great! Just add it (and any others) to the box with your other valuable and send it in. We'll take care of it.",
                                                            "time_to_show": "0"
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "time_to_show": "0"
                                }
                            },
                            "has_no_slots": {
                                "0": {
                                    "key": "message_pick_up_time_no_slots",
                                    "direction": "1",
                                    "type": "message",
                                    "text": "Unfortunately it seems like there are currently no available pickup time slots for your address.</br> You can still drop it off yourself or contact an Account Executive for assistance.",
                                    "time_to_show": "0",
                                    "hide_waves_timeout": "0"
                                },
                                "1": {
                                    "key": "two_buttons_no_slots_response",
                                    "direction": "0",
                                    "type": "two_buttons",
                                    "button1": {
                                        "text": "Drop it off Myself",
                                        "response": {
                                            "0": {
                                                "key": "message_schedule_pickup_drop_off",
                                                "direction": "2",
                                                "type": "message",
                                                "text": "I prefer to drop it off by myself",
                                                "hide_waves_timeout": "1800"
                                            },
                                            "1": {
                                                "key": "message_drop_off_locations",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "No problem, here are a few FedEx drop off locations next to your address.",
                                                "time_to_show": "2000"
                                            },
                                            "2": {
                                                "key": "update_drop_off_locations",
                                                "direction": "0",
                                                "type": "method",
                                                "method": "update_drop_off",
                                                "time_to_show": "0",
                                                "success": {
                                                    "0": {
                                                        "key": "message_shipping_label_details",
                                                        "direction": "1",
                                                        "type": "message",
                                                        "text": "Please follow the important packing instructions I just emailed you at:<br><br><b>#{user_email}</b><br><br>The pre-paid shipping label is also enclosed in this email.",
                                                        "time_to_show": "0",
                                                        "hide_waves_timeout": "1800"
                                                    }
                                                }
                                            },
                                            "3": {
                                                "key": "message_if_any_questions",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "Feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                                "time_to_show": "3000"
                                            },
                                            "4": {
                                                "key": "multiple_buttons_details_correction",
                                                "direction": "0",
                                                "type": "update_drop_off_details",
                                                "placeholder": "Need anything else?",
                                                "buttons": {
                                                    "0": {
                                                        "label": "Done",
                                                        "action": "done",
                                                        "responseText": "Done.",
                                                        "followUpMessage": "update_details_done"
                                                    },
                                                    "1": {
                                                        "label": "Change email",
                                                        "action": "update_drop_off_details_email",
                                                        "responseText": "I would like to change my email.",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "2": {
                                                        "label": "Change phone",
                                                        "action": "update_drop_off_details_phone",
                                                        "responseText": "I would like to change my phone.",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "3": {
                                                        "label": "I have some questions, can we talk?",
                                                        "action": "update_drop_off_details_learn_more",
                                                        "responseText": "I have some questions, can we talk?",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "4": {
                                                        "label": "Sell another jewelry piece",
                                                        "action": "update_drop_off_details_sell_another",
                                                        "responseText": "I would like to sell another jewelry piece",
                                                        "followUpMessage": "update_details_sell_another_jewelry"
                                                    }
                                                },
                                                "update_drop_off_details_response": {
                                                    "0": {
                                                        "key": "create_update_pickup_details_task",
                                                        "direction": "0",
                                                        "type": "method",
                                                        "method": "update_drop_off_details",
                                                        "update_details_done": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_all_good",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "Great! While you’re getting ready to ship, check out<br><a href='https://www.worthy.com/about/reviews' class='our-reviews' target='_blank'>Our reviews</a>",
                                                                "time_to_show": "0"
                                                            }
                                                        },
                                                        "update_details_action_required": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_action_required",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "OK, we will contact you shortly.",
                                                                "time_to_show": "0"
                                                            }
                                                        },
                                                        "update_details_sell_another_jewelry": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_sell_another_jewelry",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "That's great! Just add it (and any others) to the box with your other valuable and send it in. We'll take care of it.",
                                                                "time_to_show": "0"
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "time_to_show": "0"
                                    },
                                    "button2": {
                                        "text": "Talk to Account Executive",
                                        "response": {
                                            "0": {
                                                "key": "message_contact_ae",
                                                "direction": "2",
                                                "type": "message",
                                                "text": "I’d like to talk to an Account Executive."
                                            },
                                            "1": {
                                                "key": "contact_ae_method",
                                                "direction": "0",
                                                "type": "method",
                                                "method": "contact_ae",
                                                "time_to_show": "0"
                                            },
                                            "2": {
                                                "key": "message_we_can_do_that",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "We can do that!<br>An account executive will call you at #{user_phone}.<br><br>Expect a call from <b>1 (888) 222-0208</b>.",
                                                "time_to_show": "1800"
                                            }
                                        }
                                    }
                                }
                            },
                            "fedex_error": {
                                "0": {
                                    "key": "message_no_pickup_availability",
                                    "direction": "1",
                                    "type": "message",
                                    "text": "Looks like FedEx is unavailable right now.</br> You can still drop it off yourself or contact an Account Executive for assistance.",
                                    "time_to_show": "0",
                                    "hide_waves_timeout": "0"
                                },
                                "1": {
                                    "key": "two_buttons_no_slots_response",
                                    "direction": "0",
                                    "type": "two_buttons",
                                    "button1": {
                                        "text": "Drop it off Myself",
                                        "response": {
                                            "0": {
                                                "key": "message_schedule_pickup_drop_off",
                                                "direction": "2",
                                                "type": "message",
                                                "text": "I prefer to drop it off by myself",
                                                "hide_waves_timeout": "1800"
                                            },
                                            "1": {
                                                "key": "message_drop_off_locations",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "No problem, here are a few FedEx drop off locations next to your address.",
                                                "time_to_show": "2000"
                                            },
                                            "2": {
                                                "key": "update_drop_off_locations",
                                                "direction": "0",
                                                "type": "method",
                                                "method": "update_drop_off",
                                                "time_to_show": "0",
                                                "success": {
                                                    "0": {
                                                        "key": "message_shipping_label_details",
                                                        "direction": "1",
                                                        "type": "message",
                                                        "text": "Please follow the important packing instructions I just emailed you at:<br><br><b>#{user_email}</b><br><br>The pre-paid shipping label is also enclosed in this email.",
                                                        "time_to_show": "0",
                                                        "hide_waves_timeout": "1800"
                                                    }
                                                }
                                            },
                                            "3": {
                                                "key": "message_if_any_questions",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "Feel free to call me if you have any questions, just ask for #{account_manager_name}.",
                                                "time_to_show": "3000"
                                            },
                                            "4": {
                                                "key": "multiple_buttons_details_correction",
                                                "direction": "0",
                                                "type": "update_drop_off_details",
                                                "placeholder": "Need anything else?",
                                                "buttons": {
                                                    "0": {
                                                        "label": "Done",
                                                        "action": "done",
                                                        "responseText": "Done.",
                                                        "followUpMessage": "update_details_done"
                                                    },
                                                    "1": {
                                                        "label": "Change email",
                                                        "action": "update_drop_off_details_email",
                                                        "responseText": "I would like to change my email.",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "2": {
                                                        "label": "Change phone",
                                                        "action": "update_drop_off_details_phone",
                                                        "responseText": "I would like to change my phone.",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "3": {
                                                        "label": "I have some questions, can we talk?",
                                                        "action": "update_drop_off_details_learn_more",
                                                        "responseText": "I have some questions, can we talk?",
                                                        "followUpMessage": "update_details_action_required"
                                                    },
                                                    "4": {
                                                        "label": "Sell another jewelry piece",
                                                        "action": "update_drop_off_details_sell_another",
                                                        "responseText": "I would like to sell another jewelry piece",
                                                        "followUpMessage": "update_details_sell_another_jewelry"
                                                    }
                                                },
                                                "update_drop_off_details_response": {
                                                    "0": {
                                                        "key": "create_update_pickup_details_task",
                                                        "direction": "0",
                                                        "type": "method",
                                                        "method": "update_drop_off_details",
                                                        "update_details_done": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_all_good",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "Great! While you’re getting ready to ship, check out<br><a href='https://www.worthy.com/about/reviews' class='our-reviews' target='_blank'>Our reviews</a>",
                                                                "time_to_show": "0"
                                                            }
                                                        },
                                                        "update_details_action_required": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_action_required",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "OK, we will contact you shortly.",
                                                                "time_to_show": "0"
                                                            }
                                                        },
                                                        "update_details_sell_another_jewelry": {
                                                            "0": {
                                                                "key": "message_update_drop_off_details_sell_another_jewelry",
                                                                "direction": "1",
                                                                "type": "message",
                                                                "text": "That's great! Just add it (and any others) to the box with your other valuable and send it in. We'll take care of it.",
                                                                "time_to_show": "0"
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "time_to_show": "0"
                                    },
                                    "button2": {
                                        "text": "Talk to Account Executive",
                                        "response": {
                                            "0": {
                                                "key": "message_contact_ae",
                                                "direction": "2",
                                                "type": "message",
                                                "text": "I’d like to talk to an Account Executive."
                                            },
                                            "1": {
                                                "key": "contact_ae_method",
                                                "direction": "0",
                                                "type": "method",
                                                "method": "contact_ae",
                                                "time_to_show": "0"
                                            },
                                            "2": {
                                                "key": "message_we_can_do_that",
                                                "direction": "1",
                                                "type": "message",
                                                "text": "We can do that!<br>An account executive will call you at #{user_phone}.<br><br>Expect a call from <b>1 (888) 222-0208</b>.",
                                                "time_to_show": "1800"
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        "16": {
                            "key": "button_phone",
                            "direction": "0",
                            "type": "one_button_phone",
                            "text": "Call 1 (888) 222-0208",
                            "time_to_show": "3000",
                            "phone": "18882220208"
                        }
                    }
                }
            }
        },
        "header": {
            "faqs": {
                "name": "FAQs",
                "title": {
                    "desktop": "FREQUENTLY ASKED QUESTIONS",
                    "mobile": "FAQs"
                },
                "contentJB": {
                    "0": {
                        "q": "What do you consider a Jewelry Box?",
                        "a": "A Jewelry Box is three or more pieces of jewelry sent together.  The total value of a jewelry box should be over $1000. We offer a unique process that makes it easy to sell all these valuables at once."
                    },
                    "1": {
                        "q": "How do I get started selling a Jewelry Box?",
                        "a": [
                            {
                                "p": "To start, click on the “Multiple” icon on our homepage. In the following step you will need to select which valuables you would like to sell and upload a single photo containing all of your valuables for us to review. Then your account executive will guide you through the next steps of securely packing and shipping your jewelry pieces to us, fully insured."
                            },
                            {
                                "p": "Once your valuables arrive at our NYC offices, each piece will be cleaned, photographed and evaluated. When ready for auction, you will set a reserve price for each valuable and when all of your auctions have concluded you will see the results, choose the offers you’re interested in, and get paid in one installment."
                            },
                            {
                                "ul": [
                                    "Valuables not eligible for auction may receive a Quick Sale offer instead.",
                                    "Valuables that are not sold at the end of the process will be shipped back to you, fully insured, free of charge."
                                ]
                            }
                        ]
                    },
                    "2": {
                        "q": "Why should I sell my collection of valuables through Worthy?",
                        "a": "Worthy provides full professional services for all of your valuables, including cleaning, photography, evaluation, preparation for sale and auction in a very transparent and seamless process.  Our network of professional buyers ensures high bids so that you can get more for your jewelry."
                    },
                    "3": {
                        "q": "Who are Worthy’s partners?",
                        "a": "Worthy partners with industry leaders in shipping, insurance and grading. Our partners include FedEx, PayPal, Lloyd’s of LondonHanover Insurance, and the Gemological Institute of America, to ensure a smooth and secure auction process every step of the way.",
                        "images": [
                            "fedex.png",
                            "paypal.png",
                            "lloyds.svg",
                            "GIA.png"
                        ]
                    },
                    "4": {
                        "q": "Why do I need to ship my jewelry?",
                        "a": "In order for buyers to bid with confidence, they need to know that every item is authenticated and that the selling description is guaranteed. That is how we get buyers to bid for the full value of your valuables. Furthermore, a large part of the work that we conduct on your behalf is done while in our possession such as the high resolution photography, buyer targeting, and final transaction. It is crucial that we are able to physically see your valuables and assure that they are going to the right people at the right price."
                    },
                    "5": {
                        "q": "Is it safe to send my jewelry?",
                        "a": "We've put every practice in place to make your experience a positive one, from start to finish. We’ve partnered with premium worldwide companies, including FedEx for shipping, Lloyd’s of London for insurance, Brinks for security, and GIA and IGI for diamond grading and authentication, to ensure safety and transparency at all points. Additionally, your valuables are tracked every step of the way and your package is opened at our headquarters under video surveillance."
                    },
                    "6": {
                        "q": "Am I obligated to sell my valuables once I ship them?",
                        "a": "Not at all. Once your valuables have been evaluated for auction and/or Quick Sale, you are free to choose only the offers you’d like. If the offers do not meet or exceed your expectations, or you changed your mind, you can request to have your valuable(s) returned to you, free of charge and fully insured."
                    },
                    "7": {
                        "q": "How do I know you won't swap my diamonds?",
                        "a": "Trust from both sellers and buyers is essential to our business. It is why every valuable that arrives at our headquarters is received and opened under camera surveillance and receives a designated, trackable number from the grading lab."
                    },
                    "8": {
                        "q": "How do I change my pickup time?",
                        "a": "If the scheduled pickup time no longer works for you, please call us at 1 (888) 222-0208 to reschedule."
                    },
                    "9": {
                        "q": "Why is grading necessary?",
                        "a": "All diamonds auctioned on our site are graded and come with an accompanying grading report. Diamond and other jewelry gradings conducted by industry-leading labs give buyers the confidence needed to trust the descriptions provided and place higher bids on diamonds being auctioned."
                    },
                    "10": {
                        "q": "When will I get paid?",
                        "a": "Payment is processed shortly after your sales conclude. Payment is not made until all of the valuables in your jewelry box have completed the process. If you selected PayPal as your payment method, it is almost immediate. Bank transfers can take 1 to 2 business days depending on your financial institution, while checks typically arrive within 4 to 5 business days."
                    },
                    "11": {
                        "q": "How much does it cost to work with Worthy?",
                        "a": "Our fees are respective to your earnings. So we share a common interest - to get you more. Everything we do is designed to get you more, even the way we've structured our commission. The commission we take is subject to a successful auction and is a percentage of the final sale price. We only get paid when you do, and only benefit when you walk away with more.",
                        "table": {
                            "header": {
                                "0": "Transaction",
                                "1": "Seller Fees*"
                            },
                            "body": {
                                "0": [
                                    "Up to $5,000",
                                    "<span style='position:static; color:red; text-decoration:line-through'>22%</span> 18%"
                                ],
                                "1": [
                                    "$5,001 - $15,000",
                                    "<span style='position:static; color:red; text-decoration:line-through'>15%</span> 14%"
                                ],
                                "2": [
                                    "$50,001 - $30,000",
                                    "<span style='position:static; color:red; text-decoration:line-through'>15%</span> 12%"
                                ],
                                "3": [
                                    "$30,001 - Above",
                                    "<span style='position:static; color:red; text-decoration:line-through'>14%</span> 10%"
                                ]
                            }
                        },
                        "feeCommentBottom": "For Jewelry Box (3 or more items), a flat fee of <span style='position: static;color:red;text-decoration:line-through'>22%</span>18%* applies<br>* Limited time offer"
                    },
                    "12": {
                        "q": "Where can I read more about Worthy?",
                        "a": "Publications such as the New York Times, Forbes, and INC magazine have featured Worthy. You can also read about us in The Huffington Post, The Pittsburgh Gazette, and Thrive Global."
                    }
                },
                "content": {
                    "0": {
                        "q": "How does this work?",
                        "a": [
                            {
                                "ul": [
                                    "Describe your valuable to the best of your ability.",
                                    "Send your valuable, secured and insured to our headquarters for authentication. ",
                                    "We’ll have it professionally graded and photographed.",
                                    "Our gemologists will recommended a selling reserve, but it is up to you to set a reserve price you are comfortable with. ",
                                    "Buyers from around the world will place bids on your valuable. If the highest bid reaches or exceeds the reserve, your valuable is sold and you receive the funds shortly after, minus the <span class='under'> commission fee.</span> "
                                ],
                                "type": "decimal"
                            }
                        ]
                    },
                    "1": {
                        "q": "Why do I need to ship my valuable?",
                        "a": "We ask that our clients take advantage of our fully insured shipping so that we can have their jewelry evaluated by the world-leading experts. The grading not only provides transparency and objectivity in the diamond auction process, it also instills trust from our buyers, resulting in high competitive bids.",
                        "images": [
                            "companies.png"
                        ],
                        "mobileImages": [
                            "companies-mobile.png"
                        ]
                    },
                    "2": {
                        "q": "Is it safe to send my valuable?",
                        "a": "We've put every practice in place to make your experience a positive one and only work with partners that we can trust. We cover the cost of shipping and insurance throughout the entire process. Your valuable is tracked throughout every step of the way and under 24-hour video surveillance."
                    },
                    "3": {
                        "q": "Am I obligated to sell my item once I ship it?",
                        "a": "Sending your item does not obligate you to sell. Once your valuable has been graded, our gemologists will provide you with a recommended reserve price, but it is up to you to set a price you are comfortable with. If the highest offer at auction does not meet or exceed that reserve, you can request the secure and insured return of your item, free of charge."
                    },
                    "4": {
                        "q": "How do I change my pickup time?",
                        "a": "If the arranged pickup time no longer fits your schedule, please call us at 1(888) 222-0208 to reschedule."
                    },
                    "5": {
                        "q": "Can I track my item?",
                        "a": "You will receive updates about your valuable every step of the way. From the time it leaves your house through the end of the auction, you will know where your jewelry is."
                    },
                    "6": {
                        "q": "What are your fees?",
                        "topText": "Our fees are respective to your earnings. So we share a common interest - to get you more. Everything we do is designed to get you more, even the way we've structured our commission. The commission we take is subject to a successful auction and is a percentage of the final sale price. We only get paid when you do, and only benefit when you walk away with more. Check our fee table:",
                        "table": {
                            "header": {
                                "0": "Transaction",
                                "1": "Seller Fees*"
                            },
                            "body": {
                                "0": [
                                    "Up to $5,000",
                                    "<span style='position:relative;color:red;text-decoration:line-through'>22%</span> 18%"
                                ],
                                "1": [
                                    "$5,001 - $15,000",
                                    "<span style='position:relative;color:red;text-decoration:line-through'>15%</span> 14%"
                                ],
                                "2": [
                                    "$15,001 - $30,000",
                                    "<span style='position:relative;color:red;text-decoration:line-through'>15%</span> 12%"
                                ],
                                "3": [
                                    "$30,001 - Above",
                                    "<span style='position:relative;color:red;text-decoration:line-through'>14%</span> 10%"
                                ]
                            }
                        },
                        "feeCommentBottom": "<p style='margin: 5px 0'>For Jewelry Box (3 or more items), a flat fee of <span style='position:relative;color:red;text-decoration:line-through'>22%</span> 18%* applies. </p> <p style='margin: 5px 0'>* Limited time offer</p>"
                    },
                    "7": {
                        "q": "Why should I choose Worthy over eBay?",
                        "a": "At Worthy, we’re committed to offering a win-win experience for both sides. While Worthy and eBay are both marketplaces, at Worthy, our experts authenticate and professionally grade all valuables before sale, earning our buyers' trust. We sell exclusively to a network of professional buyers, who are more likely to bid more for high-quality valuables, thus earning you more. Sellers who choose Worthy enjoy higher chances of selling and a shorter time to sale than on eBay. Finally, our expert team provides professional updates and consultation every step of the way, so you know exactly what's happening with your valuable and enjoy full control."
                    },
                    "8": {
                        "q": "When will I get paid?",
                        "a": "Payment is processed shortly after your auction concludes. If you selected PayPal as your payment method, it is almost immediate. Bank transfers can take 1-2 business days depending on your financial institution. Payments can also be sent via check within 4-5 business days."
                    },
                    "9": {
                        "q": " Where can I read more about Worthy?",
                        "a": "Publications such as the New York Times, Forbes, INC magazine, the Washington Post and Thrive Global have covered Worthy. Check out our press page to see what people are saying about Worthy."
                    }
                }
            },
            "menu": {
                "titles": {
                    "sellYourItem": "Sell Your Item",
                    "howItWorks": "How it works",
                    "recentAuctions": "Recently sold",
                    "sellingSafely": "Selling Safely",
                    "acceptItems": "Accepted Items",
                    "aboutUs": "About us",
                    "about": "About",
                    "contactUs": "Contact Us",
                    "scholarship": "Scholarship",
                    "certsAndLicenses": "Certifications & Licenses",
                    "reviews": "Reviews",
                    "successStories": "Success Stories",
                    "faqs": "FAQs",
                    "board": "Board",
                    "press": "Press",
                    "blog": "Blog",
                    "promotions": "Promotions",
                    "sell": "Sell",
                    "sellDiamonds": "Sell Diamonds",
                    "sellWatches": "Sell Watches",
                    "sellJewelry": "Sell Jewelry",
                    "sellEngagementRing": "Sell Engagement Ring",
                    "sellDiamondRing": "Sell Diamond Ring",
                    "sellWeddingRing": "Sell Wedding Ring",
                    "hi": "Hi, {userName}",
                    "myAccount": "My jewelry",
                    "settings": "Settings",
                    "referAFriend": "Refer a friend",
                    "logOut": "Log out",
                    "logIn": "Log in",
                    "learn": "Learn"
                }
            },
            "sellBtn": {
                "desktop": "Start Selling",
                "mobile": "Sell Your Jewelry"
            }
        },
        "banner": {
            "button": "GET OFFER",
            "title": "Special Offer: Get discounted fees when you ship by 2/13!"
        },
        "footerCui": {
            "headerText": "Reviews & More",
            "videos": {
                "0": {
                    "id": "Ac4hSvhL8RQ",
                    "thumbnail": "sabrina.png",
                    "title": "Sabrina, CA"
                },
                "1": {
                    "id": "kEjqT6X6tEA",
                    "thumbnail": "christa.png",
                    "title": "Christa, TX"
                },
                "2": {
                    "id": "04Mt4bDCM18",
                    "thumbnail": "melinda.png",
                    "title": "Melinda, TX"
                },
                "3": {
                    "id": "aKv0f24KRRs",
                    "thumbnail": "howItWorks.png",
                    "title": "How it works",
                    "subTitle": "By Worthy"
                },
                "4": {
                    "id": "BzvtXBK0IZI",
                    "thumbnail": "aTourAtWorthy.png",
                    "title": "A tour at worthy",
                    "subTitle": "By Emma Johnson"
                }
            }
        },
        "components": {
            "soldItemPreview": {
                "soldFor": "Sold for"
            },
            "scheduleCall": {
                "title": "Schedule Call",
                "empty": {
                    "text": "Unfortunately, we don’t have any open time slots at the moment. Feel free to call us at 1 (888) 222-0208 or go ahead and schedule a free pickup."
                },
                "phone": {
                    "textWithoutPhone": "'Enter the number you would like our VIP team to call you at.",
                    "textWithPhone": "Please select the number you would like our VIP team to call you at.",
                    "radio1": "Continue with ",
                    "radio2": "Enter a new phone number",
                    "phoneInputLabel": "Phone number",
                    "firstCTA": "Next",
                    "secondCTA": "Update"
                },
                "schedule": {
                    "text": "Now select when you prefer our VIP team to contact you.",
                    "selectCallTimePlaceholder": "VIP call time slots",
                    "firstCTA": "Edit Number",
                    "secondCTA": "Schedule"
                },
                "done": {
                    "title": "All Done",
                    "text": "Our VIP team will call you:"
                }
            }
        },
        "preAuctionServices": {
            "title": "Pre-Auction Services",
            "description": "We work to give your valuable the best starting point at auction. And it’s free.",
            "cleaning": {
                "title": "Cleaning",
                "description": "This involves carefully removing dirt or tarnish from jewelry to make it sparkle."
            },
            "photographing": {
                "title": "Beauty Shots",
                "description": "Your valuable is professionally photographed in high definition."
            },
            "grading": {
                "title": "3rd Party Grading",
                "description": "Industry-leading diamond grading labs such as GIA, GHI and IGI inspect every valuable we receive."
            }
        },
        "listingPage": {
            "title": "Review before shipping",
            "nextUp": {
                "next": "Next Up:",
                "freeAndSecure": "Free & secure shipping",
                "pickup": {
                    "label": "Your ",
                    "linkText": "scheduled FedEx pickup"
                },
                "dropOff": {
                    "label": "Drop off your valuable at a ",
                    "linkText": "staffed FedEx location"
                }
            },
            "versions": {
                "v1": "2.0",
                "v3": "2.1.1"
            },
            "stickyBtnContentSchedule": "Schedule Pickup",
            "stickyBtnContentEdit": "Edit Pickup",
            "freeShipBack": "Free ship-back is possible at any time!",
            "labelRadioGroup": "Pickup",
            "labelDropOff": "FedEx drop-off",
            "labelOfficeDropOff": "Drop off In-person at Worthy",
            "choosePickupTimePlaceholder": "Pickup time slot",
            "labelPrivateResidence": "It's a private residence",
            "labelAddress": "Address",
            "labelPhone": "Phone number",
            "labelApt": "Apartment/suite No.",
            "labelNewAddress": "New address",
            "typingInMessage": "Keep typing, the select address above",
            "addressErrorMessage": "Enter street no. & name, city, state",
            "draftWelcome": {
                "welcomeText": "You're all set! ",
                "nextWord": "Next:",
                "linkText": "schedule shipment"
            },
            "setting": "Setting",
            "shape": "Shape",
            "carat": "Center Stone Carat",
            "color": "Color",
            "clarity": "Clarity",
            "brand": "Brand",
            "other": "Other",
            "next": "Next",
            "back": "Back",
            "finish": "Finish",
            "schedule": "Schedule",
            "close": "Close",
            "addPhoto": "Add photo",
            "editAddress": "Edit Address",
            "setUpShipmentTitle": "Set Up Shipment",
            "scheduleShipmentTitle": "Schedule Shipment",
            "scheduleOfficeDropTitle": "Schedule In-Person Office Drop-Off",
            "allSet": "All Set!",
            "setUpShipmentStepPhoneStep": "To create your complimentary FedEx label, start by entering a valid phone number.",
            "setUpShipmentStepAddressStep": "Now please enter the address you’ll be shipping your valuable from.",
            "setUpShipmentStepAddressStepFirst": "Continue or enter a new address below.",
            "setUpShipmentStepPickupStep": "Now select a time slot for your free pickup from %address%.",
            "setUpShipmentStepPickupStepLast": "Lastly, select a time slot for your free pickup from %address%.",
            "setUpShipmentStepOneEditAddress": "Please enter a new address to create an updated shipping label.",
            "setUpShipmentFedexNoResults": "There are currently no available pickup time slots. But you can still drop your valuable off.",
            "setUpShipmentFedexIssue": "There seems to be an issue with our connection to Fedex. An account executives will be in touch to schedule your pickup manually.",
            "setUpShipmentPickupStep": {
                "pickup": "All done! You should find an email with your <b>pickup information</b>, an <b>insurance certificate</b>, a <b>FedEx shipping label</b> and <b>shipping instructions</b> in your inbox shortly.",
                "dropoff": "All done! You should find an email with <b>drop off locations</b>, an <b>insurance certificate</b>, a <b>FedEx shipping label</b> and <b>shipping instructions</b> in your inbox shortly."
            },
            "anyFedexLocation": "At any staffed FedEx location",
            "stopByOurOffice": "At our office at 25 W 45th St., 2nd Floor, New York, NY",
            "noSlots": "No available time slots",
            "scheduledShipmentNotificationAllSet": "Your complimentary pickup is all set!",
            "scheduledShipmentNotificationDropOffOverPickup": "Drop off has been updated in your preferences.",
            "scrollDown": "Scroll down",
            "shippingKit": "Your shipping kit will be shipped to you shortly.",
            "scheduledShipmentNotificationDownloadShippingLabel": "to download your shipping label.",
            "scheduledShipmentNotificationInsuranceInfo": "for insurance information and more.",
            "scheduledShipmentNotificationForMore": "for more information.",
            "itemPropertiesToBeDefined": {
                "ring": [
                    "Metal Type",
                    "Style",
                    "Metal Weight (g)",
                    "Ring Size",
                    "Brand",
                    "Antique",
                    "Art Deco",
                    "Extra Info"
                ],
                "loose diamond": [
                    "Shape",
                    "Length (mm)",
                    "Width (mm)",
                    "Depth (mm)",
                    "Carat Weight",
                    "Color",
                    "Color Shade",
                    "Clarity",
                    "Cut Grade",
                    "Finish",
                    "Polish",
                    "Symmetry",
                    "Fluorescence Intensity",
                    "Fluorescence Color",
                    "Table (%)",
                    "Girdle",
                    "Diamond Treated",
                    "Clarity enhanced",
                    "Chips",
                    "Chip Description",
                    "Inclusion location",
                    "Inclusion Grade",
                    "Inclusion Description",
                    "Culet Size",
                    "Culet Condition",
                    "Certificate",
                    "Certificate Number",
                    "Laser inscription",
                    "Color enhanced",
                    "Clarity Enhancement Type",
                    "Color Enhancement Type",
                    "Inclusion Type",
                    "Blemishes location",
                    "Blemishes Type",
                    "Blemishes Description",
                    "Laser inscription content",
                    "Setting Type",
                    "Carat Weight To",
                    "Depth %",
                    "Visual Inspection",
                    "Fancy Color Intensity",
                    "Fancy Color Overtone",
                    "Fancy Color",
                    "Extra Info"
                ]
            },
            "toBeDefined": "TBD",
            "scheduleTitle": "Shall We?",
            "scheduleButtonNotSecure": "Schedule Free Pickup",
            "scheduleVIPCall": "Schedule Call",
            "consultAnExpert": "Talk With Us",
            "setUpShipment": "Set Up Shipment",
            "moreSimilar": "More Similar Valuables",
            "attrAlert": "<a> %propertiesNum% additional attributes </a> will be added by lab experts.",
            "attrPopupTitle": "Additional attributes",
            "attrPopupContent": "During grading, the following details of your ring will be professionally examined.\n\n%table%",
            "similarItemsTitle": "Recent Auctions",
            "whatToExpectTitle": "What to Expect Next",
            "you": "You",
            "worthy": "Complimentary by Worthy",
            "cuiTitle": "SCHEDULE SHIPMENT",
            "fakeDoorTitle": "Coming Soon...",
            "fakeDoorText": "You can’t edit this information here just yet.\nBut don’t worry, after grading, the most accurate information about your ring will be entered by our lab experts.",
            "steps": [
                "Describe valuable",
                "Shipping",
                "Authentication",
                "Cleaning",
                "Beauty shots",
                "Grading at 3rd party lab",
                "Gathering buyers",
                "Set your reserve & start auction",
                "Watch bidding online",
                "Get paid"
            ],
            "stepsLabels": {
                "done": "Done",
                "current": "Up Next"
            },
            "stepsPopups": [
                {
                    "comment": "Do not delete this placeholder element, it is the very first item submission step which is always fulfilled. Check Listing Page for the reference."
                },
                {
                    "title": "Shipping",
                    "text": "Our marketplace consists of professional buyers who trust us to verify every valuable before it is listed on Worthy’s marketplace. Shipment to us is free of charge via FedEx and is fully insured by brokers at Lloyd’s of London."
                },
                {
                    "title": "Authentication",
                    "text": "Your fully insured valuable arrives at Worthy offices via FedEx, in a secured and safe delivery. It is then checked into our system by our dedicated lab team. Your trust and the security of your valuable are important to us. Therefore, unpacking is tracked and monitored by cameras."
                },
                {
                    "title": "Cleaning",
                    "text": "Your valuable will remain safe and intact during cleaning. The process involves carefully removing dirt or tarnish from jewelry to improve its appearance and make it sparkle."
                },
                {
                    "title": "Beauty Shots",
                    "text": "Your valuable is professionally photographed in high-definition from every angle so that buyers can get a closer look and place high bids with confidence."
                },
                {
                    "title": "Grading at 3rd Party Lab",
                    "text": "Certified gemologists and industry-leading labs such as GIA, GHI and IGI inspect every valuable we receive as part of our complimentary auction preparation process.\nColor, clarity, brand and symmetry are just a few parameters in diamond grading."
                },
                {
                    "title": "Gathering Buyers",
                    "text": "Hundreds of professional diamond and jewelry buyers use the Worthy marketplace on a daily basis to find the best valuables for their clients. Our team of account executives maintains close relationships with buyers to understand what they are looking for and let them know about valuables that may interest them."
                },
                {
                    "title": "Set Your Reserve & Start Auction",
                    "text": "We'll let you know as soon as your %valuable% is ready for auction. At this point, you'll need to decide how much you’re willing to sell %preposition% for and start your auction. If one of the bids meets or exceeds your reserve price, consider your %valuable% sold! If your reserve price isn't met, you have the option to either accept the highest bid or have your %valuable% sent back to you fully insured, free of charge."
                },
                {
                    "title": "Watch Bidding Online",
                    "text": "Once your auction has started, you can watch it live on your auction page. Don't miss a thing!"
                },
                {
                    "title": "Get Paid",
                    "text": "Once the sale is complete, your payment via your chosen payment method is processed almost immediately. Receipt of the payment varies depending on the method selected, as follows: PayPal: 1-2 business days Bank transfer (ACH): 2-3 business days Checks: 4-5 business days"
                }
            ],
            "readMore": "Learn More",
            "faqSection": {
                "title": "You’re Probably Wondering...",
                "faqs": [
                    {
                        "bullet": "What are Worthy’s fees?",
                        "expandText": "Our fees are respective to your earnings. So we share a common interest - to get you more.<br/>Everything we do is designed to get you more, even the way we've structured our commission. The commission we take is subject to a successful auction and is a percentage of the final sale price. We only get paid when you do, and only benefit when you walk away with more.<br/><br/>Check our fee table:<br/><br/> {fees_table}<br/>* For jewelry Box (3 or more items), a flat fee of <span class='deleted'> 22% </span> 18% applies. <br/> * Limited time offer <br/>"
                    },
                    {
                        "bullet": "Can I get an estimate before I ship my valuable?",
                        "expandText": "Each {item_type} comes with a complex set of attributes that affect its worth, so it is difficult to assess value without conducting a detailed, hands-on, inspection. That being said, there are a few ways for you to get an idea of what your valuable may be worth before shipping. You can browse our <a id='recent-auction-link' class='textLink'> recent auctions </a> to find similar valuables to yours (and how much they sold for), or if you have a certificate for your diamond we might be able to come up with a rough estimate prior to shipping. Give us a call at <a class='phoneNumber' href='tel: 18882220208'>1 (888) 222-0208 </a> or chat with us for more information."
                    },
                    {
                        "bullet": "Can I back out of the process at any time?",
                        "expandText": "Prior to auction there is no obligation of any kind. Once you agree to a reserve price, you are committed to selling your valuable for that price. If the highest bid falls below the reserve price, or you receive a Quick Sale offer, you have the option to decline and have your valuable sent back to you fully insured, free of charge."
                    },
                    {
                        "bullet": "Why do I need to ship my valuable?",
                        "expandText": "In order for buyers to bid with confidence, they need to know that every item is authenticated and that the selling description is guaranteed. That is how we get buyers to bid for the full value of the item. Furthermore, a large part of the work that we conduct on your behalf is done while in our possession such as the high resolution photography, buyer targeting, and final transaction. It is crucial that we are able to physically see your item and assure that it is going to the right people at the right price."
                    },
                    {
                        "bullet": "How will Worthy protect my valuable?",
                        "expandText": "We take very serious measures to keep valuables safe. Shipping to our New York headquarters is handled via FedEx and fully insured by Lloyd’s of London. Once your valuable reaches us, it is checked into our system and unpacked and monitored under camera surveillance. Every step thereafter is tracked, too."
                    }
                ]
            },
            "chat": {
                "title": "Chat With Us",
                "text": "Get your questions answered right away with one click.",
                "button": "Chat Now",
                "welcomeMessage": "Hi {name}, do you have any questions about our process? I'd be happy to help!"
            },
            "listingUploadPhoto": {
                "skip": "Skip",
                "continue": "Continue",
                "title": "Upload Photos",
                "optionalText": "Add 1-4 photo(s)",
                "optionalSubText": "Add (optional)",
                "text": "Please upload at least one top view photo of your {item_type} and of any documentation you may have."
            },
            "remindLater": {
                "text": "Maybe Later",
                "popup1": {
                    "title": "How Much Later?",
                    "description": "Would you like to get an email to remind you to ship your {itemType}?",
                    "remindInDays": {
                        "1": "Remind Me Tomorrow",
                        "7": "Remind Me Next Week",
                        "14": "Remind Me In Two Weeks"
                    }
                },
                "popup2": {
                    "title": "You Got It!",
                    "description": "We'll send you an email reminder {remindAt}."
                }
            }
        },
        "listingPageLight": {
            "subtitle": "Ship securely to prepare for auction",
            "versions": {
                "v1": "1.0",
                "v2": "1.2"
            },
            "itemDetails": {
                "photos": "Photos",
                "certificate": "GIA Report",
                "certificateNumber": "{provider} report no. {number}",
                "addCertificate": "Add GIA Report Info",
                "studioPhotos": "Studio Photos",
                "tbd": "TBD",
                "labReport": "Lab report",
                "addPhoto": "Add photo",
                "packageContents": "Package contents",
                "cancel": "Cancel",
                "add": "Add"
            },
            "additionalInfo": {
                "title": "Want To Learn More?",
                "list": [
                    {
                        "caption": "Our process",
                        "slug": "process"
                    },
                    {
                        "caption": "FAQs",
                        "slug": "faq"
                    },
                    {
                        "caption": "Similar deals",
                        "slug": "deals"
                    },
                    {
                        "caption": "Shipping",
                        "slug": "shipping",
                        "description": "Our marketplace consists of professional buyers who trust us to verify every valuable before it is listed on Worthy’s marketplace. Shipment to us is free of charge via FedEx and is fully insured by brokers at Lloyd’s of London."
                    },
                    {
                        "caption": "Authentication",
                        "slug": "auth",
                        "description": "Your fully insured valuable arrives at Worthy offices via FedEx, in a secured and safe delivery. It is then checked into our system by our dedicated lab team. Your trust and the security of your valuable are important to us. Therefore, unpacking is tracked and monitored by cameras. "
                    },
                    {
                        "caption": "Professional Photos",
                        "slug": "photos",
                        "description": "Your valuable is professionally photographed in high-definition from every angle so that buyers can get a closer look and place high bids with confidence."
                    },
                    {
                        "caption": "Cleaning",
                        "slug": "cleaning",
                        "description": "Your valuable will remain safe and intact during cleaning. The process involves carefully removing dirt or tarnish from jewelry to improve its appearance and make it sparkle for auction."
                    },
                    {
                        "caption": "Grading",
                        "slug": "grading",
                        "description": "Gemologists and industry-leading labs such as GIA, GSI and IGI inspect every valuable we receive. Once grading is complete a grading certificate is issued. This documentation helps your diamond sell faster and for a higher price. "
                    },
                    {
                        "caption": "Auction",
                        "slug": "auction",
                        "description": "We’ll let you know as soon as your valuable is ready for auction. At this point, you’ll need to decide how much you’re willing to sell it for and start your auction. If one of the bids meets or exceeds your reserve price, consider your valuable sold! If your reserve price isn’t met, you have the option to either accept the highest bid or have your valuable sent back to you fully insured, free of charge."
                    },
                    {
                        "caption": "Getting Paid",
                        "slug": "payment",
                        "description": "Once the sale is complete, your payment via your chosen payment method is processed almost immediately. Receipt of the payment varies depending on the method selected, as follows:\n\nPayPal: 1-2 business days \nBank transfer (ACH): 2-3 business days\nChecks: 4-5 business days"
                    }
                ]
            },
            "upNext": {
                "upperTitle": "Up next",
                "title": "Authentication & Cleaning",
                "title_scheduling": "Scheduling",
                "serviceFedex": "FedEx pickup or drop off",
                "reScheduleButton": "Re-schedule Call",
                "insurance": " Insurance ",
                "upTo": "up to $50,000",
                "insuranceCoverage": "Insurance coverage",
                "sellerNote": "Our gemology team is currently reviewing your item and we will notify you once the review is complete."
            }
        },
        "shipmentInformation": {
            "titleGeneral": "Shipping",
            "titlePickup": "Scheduled Pickup",
            "scheduleShipmentButton": "Schedule Secure Shipment",
            "editPickupButton": "Edit Pickup",
            "schedulePickupButton": "Schedule Pickup",
            "downloadShippingLabel": "Download Shipping Label",
            "insurance": {
                "valueText": "Full coverage",
                "certificateLink": "insurance certificate"
            }
        },
        "completeYourAccount": {
            "notificationText": "Your account is ",
            "notificationLink": "missing some information",
            "modalStep1": {
                "title": "Complete Your Account",
                "description": "To complete setting up your account please enter your phone number.",
                "buttonSave": "Save"
            },
            "modalStep2": {
                "title": "Done!",
                "description": "Your account is all set."
            }
        },
        "uploadImageFailure": "Something went wrong during image uploading",
        "uploadImageWrongFormat": "Improper image format. Either PNG or JPEG are allowed",
        "uploadImageOptionalCapture": "Optional",
        "uploadImageFailureGeneral": "Something went wrong. Please skip to move forward",
        "homepage": {
            "title": "",
            "navigator": {
                "title": "Auction Jewelry The Smart Way",
                "subtitle": "",
                "buttons": [
                    {
                        "type": "one_button",
                        "text": "Sell Your Jewelry",
                        "href": "#"
                    }
                ]
            },
            "submissionForm": {
                "title": "Describe your valuable"
            },
            "howItWorks": {
                "title": "How it works",
                "subtitle": "Let's get the most for your valuable. <br> It's easy as 1-2-3",
                "stepPreview": {
                    "step1": {
                        "num": "01",
                        "desc": "Free Secure Pickup",
                        "content": "Schedule a free pickup by FedEx, fully <br> insured by Lloyd's of London.",
                        "period": "1 day"
                    },
                    "step2": {
                        "num": "02",
                        "desc": "We Do All the Work",
                        "content": "Expert gemologists from GIA prepare <br> your jewelry for auction. Just watch <br> the offers roll in.",
                        "period": "5 Days"
                    },
                    "step3": {
                        "num": "03",
                        "desc": "get paid",
                        "content": "Congratulations! Your reserve price <br> was met. Get paid instantly.",
                        "period": "2-5 days"
                    }
                }
            },
            "reviews": {
                "title": "reviews",
                "userReviews": [
                    {
                        "platform": "Google",
                        "text": "The communication, shipping, auction, and payment was absolutely a dream!",
                        "user": "Jennifer B"
                    },
                    {
                        "platform": "Trustpilot",
                        "text": "Security is very important to Worthy. I trusted Worthy completely with my diamond.",
                        "user": "Lee M"
                    },
                    {
                        "platform": "Facebook",
                        "text": "The shipping went smoothly and they kept us updated at every step in the process.",
                        "user": "Daniel P"
                    }
                ]
            },
            "asFeaturedIn": {
                "title": "As Featured In",
                "quotes": [
                    {
                        "platform": "New york times",
                        "text": "The staff understands the journey of their customers."
                    },
                    {
                        "platform": "Forbes",
                        "text": "Worthy makes the seller feel comfortable in many ways."
                    },
                    {
                        "platform": "Inc",
                        "text": "A tech-based solution to an age-old problem."
                    }
                ]
            },
            "stats": {
                "records": [
                    {
                        "name": "estimation",
                        "iconClass": "ring",
                        "text": "Total Item worth"
                    },
                    {
                        "name": "item_worth",
                        "iconClass": "micros",
                        "text": "Items reviewed & estimated"
                    },
                    {
                        "name": "partner",
                        "iconClass": "glob",
                        "text": "Buyers online"
                    }
                ]
            },
            "commitment": {
                "title": "Unbiased professionals you can trust",
                "subtitle": "Buyers Trust GIA. It will help you sell for more!",
                "text": "We are proudly working with the world’s leading gemology lab to bring you the most professional, accurate and trustworthy evaluations."
            },
            "featuresAndNewsLetter": {
                "title": "worthy living | features",
                "newsletter": {
                    "title": "Sign up to get the latest in luxury news:",
                    "input": {
                        "placeholder": "Enter your email here"
                    },
                    "button": "GET OUR NEWSLETTER",
                    "afterSubmission": {
                        "h3": "Subscription was successful",
                        "h5": "Our next issue is coming soon..."
                    }
                }
            },
            "hamburger": {
                "titles": {
                    "howItWorks": "How it works",
                    "recentlySold": "Recently sold",
                    "reviews": "Reviews",
                    "learn": "Learn",
                    "logIn": "Log in",
                    "myAccount": "My jewelry",
                    "referAfriend": "Refer a friend"
                },
                "expertTitles": {
                    "DIY": "DIY Resources & Tools",
                    "consult": "Get Expert Opinion",
                    "sell": "Start Selling",
                    "continue": "Continue Selling"
                }
            },
            "liveAuction": {
                "title": "ring on auction"
            },
            "recentDeals": {
                "title": "recently sold rings"
            }
        },
        "footer": {
            "tabs": [
                {
                    "name": "about us",
                    "items": [
                        "about",
                        "how it works",
                        "reviews",
                        "contact us",
                        "refer a friend",
                        "FAQs",
                        "accepted items",
                        "worthy in the press",
                        "scholarship"
                    ]
                },
                {
                    "name": "seller protection",
                    "items": [
                        "selling safely",
                        "certifications & licenses",
                        "diamond grading",
                        "terms & conditions",
                        "privacy policy"
                    ]
                },
                {
                    "name": "explore",
                    "items": [
                        "sell jewelry",
                        "sell engagement ring",
                        "sell wedding ring",
                        "sell diamonds",
                        "sell watches",
                        "blog",
                        "promotions",
                        "famous diamonds",
                        "local worthy jewelers"
                    ]
                },
                {
                    "name": "business",
                    "items": [
                        "become a business seller",
                        "become a buyer",
                        "buyer login"
                    ]
                }
            ],
            "logos": [
                [
                    {
                        "name": "insured"
                    },
                    {
                        "name": "bbb"
                    },
                    {
                        "name": "brinks"
                    }
                ],
                [
                    {
                        "name": "gia"
                    },
                    {
                        "name": "paypal"
                    },
                    {
                        "name": "hanover"
                    }
                ]
            ]
        },
        "survey": {
            "default": {
                "version": "1.7",
                "title": "Customize Your Experience",
                "subTitle": "",
                "thankYouSubTitle": "We appreciate your feedback.",
                "thankYouFooterTitle": "Recommended for you",
                "thankYouFooterSubTitle": "---> Explore our <a href='{app_url}/learn' target='_blank' style='text-decoration: none; color: #F5A723'>learning center</span>",
                "hideThankYouStep": true,
                "questions": [
                    {
                        "id": 0,
                        "type": "singleChoice",
                        "key": "when_are_you_likely_to_sell",
                        "eventText": "likelyhoodToSellJewelryQuestion",
                        "q": "When are you likely to sell your jewelry?",
                        "answers": [
                            "Next 30 days",
                            "Next 3 months",
                            "Within 1 year",
                            "I am not sure I want to sell"
                        ],
                        "other": false
                    },
                    {
                        "id": 1,
                        "type": "freeText",
                        "eventText": "anythingElseAboutRingQuestion",
                        "key": "is_there_anything_else_you_would_like_to_tell_us_about_the_ring?",
                        "q": "Is there anything else you would like to tell us about your jewelry?",
                        "answers": [],
                        "other": false,
                        "inputProps": {
                            "rows": 4
                        }
                    }
                ]
            },
            "colorNClarity": {
                "version": "1.6",
                "title": "A Few More Questions",
                "subTitle": "Just a few last details about your jewelry to help speed up the process.",
                "thankYouSubTitle": "We appreciate your feedback.",
                "thankYouFooterTitle": "Recommended for you",
                "thankYouFooterSubTitle": "---> Explore our <a href='{app_url}/learn' target='_blank' style='text-decoration: none; color: #F5A723'>learning center</span>",
                "hideThankYouStep": true,
                "questions": [
                    {
                        "id": 0,
                        "type": "singleChoice",
                        "key": "when_are_you_likely_to_sell",
                        "eventText": "likelyhoodToSellJewelryQuestion",
                        "q": "When are you likely to sell your jewelry?",
                        "answers": [
                            "Next 30 days",
                            "Next 3 months",
                            "Within 1 year",
                            "I am not sure I want to sell"
                        ],
                        "other": false
                    },
                    {
                        "id": 1,
                        "type": "chocolateTableChoice",
                        "key": "what_is_the_center_diamonds_color_grade",
                        "eventText": "centerDiamondColorQuestion",
                        "q": "What is the center diamond’s color grade?",
                        "answers": [
                            "D",
                            "E",
                            "F",
                            "G",
                            "H",
                            "I",
                            "J",
                            "K",
                            "L",
                            "M-Z",
                            "Fancy",
                            "Not Sure"
                        ],
                        "other": false
                    },
                    {
                        "id": 2,
                        "type": "chocolateTableChoice",
                        "key": "what_is_the_center_diamonds_clarity_grade",
                        "eventText": "centerDiamondClarityQuestion",
                        "q": "What is the center diamond’s clarity grade?",
                        "answers": [
                            "FL",
                            "IF",
                            "VVS1",
                            "VVS2",
                            "VS1",
                            "VS2",
                            "SI1",
                            "SI2",
                            "I1",
                            "I2",
                            "I3",
                            "Not Sure"
                        ],
                        "other": false
                    },
                    {
                        "id": 3,
                        "type": "freeText",
                        "eventText": "anythingElseAboutRingQuestion",
                        "key": "is_there_anything_else_you_would_like_to_tell_us_about_the_ring?",
                        "q": "Is there anything else you would like to tell us about the ring?",
                        "answers": [],
                        "other": false
                    }
                ]
            },
            "gemstoneColorNClarity": {
                "version": "1.6",
                "title": "A Few More Questions",
                "subTitle": "Just a few last details about your jewelry to help speed up the process.",
                "thankYouSubTitle": "We appreciate your feedback.",
                "thankYouFooterTitle": "Recommended for you",
                "thankYouFooterSubTitle": "---> Explore our <a href='{app_url}/learn' target='_blank' style='text-decoration: none; color: #F5A723'>learning center</span>",
                "hideThankYouStep": true,
                "questions": [
                    {
                        "id": 0,
                        "type": "singleChoice",
                        "key": "when_are_you_likely_to_sell",
                        "q": "When are you likely to sell your jewelry?",
                        "eventText": "likelyhoodToSellJewelryQuestion",
                        "answers": [
                            "Next 30 days",
                            "Next 3 months",
                            "Within 1 year",
                            "I am not sure I want to sell"
                        ],
                        "other": false
                    },
                    {
                        "id": 1,
                        "type": "chocolateTableChoice",
                        "key": "what_is_the_center_diamonds_color_grade",
                        "eventText": "centerDiamondColorQuestion",
                        "q": "What is the center diamond’s color grade?",
                        "answers": [
                            "black",
                            "colorless",
                            "purple",
                            "blue",
                            "brown",
                            "gray",
                            "green",
                            "orange",
                            "pink",
                            "red",
                            "white",
                            "yellow",
                            "multicolored",
                            "NA"
                        ],
                        "other": false
                    },
                    {
                        "id": 2,
                        "type": "freeText",
                        "key": "is_there_anything_else_you_would_like_to_tell_us_about_the_ring?",
                        "q": "Is there anything else you would like to tell us about the ring?",
                        "eventText": "anythingElseAboutRingQuestion",
                        "answers": [],
                        "other": false
                    }
                ]
            },
            "giaCertificateOrProperties": {
                "version": "1.7",
                "title": "A Few More Questions",
                "subTitle": "Just a few last details about your jewelry to help speed up the process.",
                "hideThankYouStep": true,
                "questions": [

                    {
                        "id": 0,
                        "type": "singleChoice",
                        "key": "when_are_you_likely_to_sell",
                        "eventText": "likelyhoodToSellJewelryQuestion",
                        "q": "When are you likely to sell your jewelry?",
                        "answers": [
                            "Next 30 days",
                            "Next 3 months",
                            "Within 1 year",
                            "I am not sure I want to sell"
                        ],
                        "other": false
                    },
                    {
                        "id": 1,
                        "type": "buttons",
                        "key": "do_you_have_gia_certificate",
                        "q": "Do you have a GIA report?",
                        "eventText": "certificateQuestion",
                        "action": "updateCertificatePresence",
                        "buttons": [
                            {
                                "key": "yes",
                                "text": "Yes, I have one",
                                "value": false,
                                "type": "primary"
                            },
                            {
                                "key": "no",
                                "text": "No, I don’t have one",
                                "value": true,
                                "type": "secondary"
                            }
                        ]
                    },
                    {
                        "id": 1,
                        "title": "GIA Report Details",
                        "type": "text",
                        "key": "gia_cert_number",
                        "backButton": true,
                        "eventText": "certificateNumberQuestion",
                        "q": "If you know the GIA report number, please enter it below",
                        "inputProps": {
                            "inputmode": "numeric",
                            "min": 0,
                            "max": 9999999999
                        }
                    },
                    {
                        "id": 2,
                        "type": "chocolateTableChoice",
                        "key": "what_is_the_center_diamonds_color_grade",
                        "eventText": "centerDiamondColorQuestion",
                        "q": "What is the center diamond’s color grade?",
                        "answers": [
                            "D",
                            "E",
                            "F",
                            "G",
                            "H",
                            "I",
                            "J",
                            "K",
                            "L",
                            "M-Z",
                            "Fancy",
                            "Not Sure"
                        ],
                        "other": false
                    },
                    {
                        "id": 3,
                        "type": "chocolateTableChoice",
                        "key": "what_is_the_center_diamonds_clarity_grade",
                        "eventText": "centerDiamondClarityQuestion",
                        "q": "What is the center diamond’s clarity grade?",
                        "answers": [
                            "FL",
                            "IF",
                            "VVS1",
                            "VVS2",
                            "VS1",
                            "VS2",
                            "SI1",
                            "SI2",
                            "I1",
                            "I2",
                            "I3",
                            "Not Sure"
                        ],
                        "other": false
                    },
                    {
                        "id": 4,
                        "type": "weight",
                        "key": "center_diamond_carat_weight",
                        "eventText": "centerDiamondCaratWeight",
                        "q": "If you know the exact carat weight of your diamond, please enter it below:"
                    },
                    {
                        "id": 5,
                        "type": "freeText",
                        "eventText": "anythingElseAboutRingQuestion",
                        "key": "is_there_anything_else_you_would_like_to_tell_us_about_the_ring?",
                        "q": "Is there anything else you would like to tell us about your jewelry?",
                        "answers": [],
                        "other": false,
                        "inputProps": {
                            "rows": 4
                        }
                    }

                ]
            },
            "giaCertificate": {
                "version": "1.6",
                "title": "",
                "subTitle": "",
                "hideThankYouStep": true,
                "questions": [
                    {
                        "id": 0,
                        "title": "GIA Report Details",
                        "type": "text",
                        "key": "gia_cert_number_standalone",
                        "eventText": "certificateNumberQuestion",
                        "q": "If you know the GIA report number, please enter it below",
                        "inputProps": {
                            "inputmode": "numeric",
                            "min": 0,
                            "max": 9999999999
                        }
                    }
                ]
            }
        },
        "shippingKit": {
            "header": "All Set!",
            "description": "Check your inbox and follow these packing instructions:",
            "steps": [
                "Print shipping labels",
                "Pack your valuable",
                "Place inside a box",
                "Attach FedEx label"
            ],
            "ctaBlockTitle": "Missing a printer and a box?",
            "ctaBlockDescription": "Get our free shipping kit",
            "ctaTrackSK": "Track Shipping Kit",
            "popup": {
                "headline": "Our Free Shipping Kit",
                "text": {
                    "dropOff": "Note that our shipping kit may take 5-7 days to reach you. Once it arrives you’ll be able to drop off your valuable.",
                    "pickUp": "Note that our shipping kit may take 5-7 days to reach you, <b>so your scheduled pickup will be canceled for now</b>."
                },
                "declineButton": "Cancel",
                "approveButton": "Get Shipping Kit"
            },
            "shippingKitShipmentDetails": {
                "title": "Shipment Details",
                "description": "You'll be able to schedule a free pickup once your shipping kit arrives.",
                "pairName": "Shipping kit",
                "pairValue": "<b>{status}</b> to {address}"
            },
            "allGood": {
                "dropOffSelected": "Go ahead and drop your valuable off at any staffed FedEx location. If you change your mind you can still schedule a free and secured FedEx pickup.",
                "pickupScheduled": "Your pickup has been scheduled. We look forward to helping you sell your valuable."
            }
        },
        "feesTable": "<table> <thead> <tr> <td>Transaction</td> <td>Seller Fees</td> </tr> </thead> <tbody> <tr> <td>Up to $5,000</td> <td><span class='deleted'>22%</span> 18%*</td> </tr> <tr> <td>$5,001 - $15,000</td> <td><span class='deleted'>15%</span> 14%</td> </tr> <tr> <td>$15,001 - $30,000</td> <td><span class='deleted'>15%</span> 12%</td> </tr> <tr> <td>$30,001 - Above</td> <td><span class='deleted'>14%</span> 10%</td> </tr> </tbody> </table>",
        "manageCall": {
            "title": {
                "reschedule": "Edit Scheduled Call Details",
                "schedule": "Schedule a Call"
            },
            "regarding": "Regarding",
            "callDetails": {
                "title": "Call Details",
                "cancel": "Cancel call",
                "time": "Time",
                "phoneNumber": "Phone number",
                "selectTimeSlotsPlaceholder": "Select Time Slot",
                "saveBtn": "Save Changes",
                "successWord": "Success",
                "rescheduleSuccessMessage": "Your call has been rescheduled",
                "appointmentNotExistsMsg": "We can’t seem to find your scheduled call. To speak with a representative, give us a call at",
                "phoneUpdatedSuccessMessage": "Your phone has been updated",
                "confirmCancellation": {
                    "text": "Are you sure you\nwant to cancel this call?",
                    "button": "Confirm Cancellation",
                    "link": "Go Back"
                },
                "callCanceled": "Call canceled. To speak with a representative, give us a call at"
            }
        },
        "cancelSubmissionOnline": {
            "popupTitle": "Cancel Submission",
            "popupContent": "You are about to cancel the submission of this valuable. Would you like to proceed?",
            "btnConfirm": "Confirm",
            "btnGoBack": "Go Back"
        }
    }
}
;
;
if (typeof window !== 'undefined') { window.__I18N__ = __I18N__; };
;